[
  {
    "id": "app/components/assistant/SmartAssistant.tsx:14",
    "text": ", message.role ===",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/assistant/SmartAssistant.tsx:9",
    "text": ", text: `J'ai retrouvé ces éléments dans la plateforme : ${excerpts}`, actions: currentKnowledge[0]?.actions ?? [{ label:",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/assistant/SmartAssistant.tsx:12",
    "text": ")} éléments documentés</p></div></div><button type=",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/assistant/SmartAssistant.tsx:18",
    "text": "/></button> : null} {message.source ? <p className=",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/assistant/SmartAssistant.tsx:16",
    "text": "/></button>)}</div> : null} {message.role ===",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/assistant/SmartAssistant.tsx:17",
    "text": "/>Contacter l’équipe directement</span><ChevronRight className=",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/assistant/SmartAssistant.tsx:13",
    "text": "> {messages.map((message) => ( <div key={message.id} className={cn(",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/assistant/SmartAssistant.tsx:11",
    "text": ">Guide Orée</p><p className=",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/assistant/SmartAssistant.tsx:20",
    "text": ">Parler directement à l’équipe</span><span className=",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/assistant/SmartAssistant.tsx:19",
    "text": ">Source interne · {message.source}</p> : null} </div> </div> ))} {messages.length <= 1 ? <div className=",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/assistant/SmartAssistant.tsx:15",
    "text": "${message.id}-${action.href}",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/assistant/SmartAssistant.tsx:21",
    "text": "Écrivez ou prononcez ce que vous cherchez…",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/assistant/SmartAssistant.tsx:8",
    "text": "Je connais les pages, les parcours, les actions et la documentation de la plateforme. Écrivez ou prononcez simplement ce que vous cherchez.",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/assistant/SmartAssistant.tsx:5",
    "text": "Je connais votre espace projet : documents, suivi, messages, associés, formalités et rendez-vous. Dites-moi ce que vous cherchez.",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/assistant/SmartAssistant.tsx:7",
    "text": "Je peux comparer les structures, organiser les associés ou retrouver la prochaine étape du parcours.",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/assistant/SmartAssistant.tsx:4",
    "text": "Je peux retrouver une pièce, expliquer son statut ou ouvrir la prochaine action liée à vos documents.",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/assistant/SmartAssistant.tsx:2",
    "text": "Je suis salarié et je veux me lancer",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/assistant/SmartAssistant.tsx:3",
    "text": "Où en est mon dossier ?",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/assistant/SmartAssistant.tsx:10",
    "text": "Parler à un conseiller",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/assistant/SmartAssistant.tsx:1",
    "text": "Quel statut pour créer seul ?",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/assistant/SmartAssistant.tsx:6",
    "text": "Vous êtes sur le parcours SASU. Je peux la comparer à l'EURL, expliquer les étapes ou lancer le diagnostic avec ce contexte.",
    "file": "app/components/assistant/SmartAssistant.tsx"
  },
  {
    "id": "app/components/feedback/AppErrorBoundary.tsx:22",
    "text": "[Orée] Erreur d’interface",
    "file": "app/components/feedback/AppErrorBoundary.tsx"
  },
  {
    "id": "app/components/layout/AppLayout.tsx:25",
    "text": "/>Demander au Guide Orée <kbd className=",
    "file": "app/components/layout/AppLayout.tsx"
  },
  {
    "id": "app/components/layout/AppLayout.tsx:24",
    "text": ">Espace projet</p><h1 className=",
    "file": "app/components/layout/AppLayout.tsx"
  },
  {
    "id": "app/components/layout/AppLayout.tsx:23",
    "text": ">Projet actif</p><p className=",
    "file": "app/components/layout/AppLayout.tsx"
  },
  {
    "id": "app/components/layout/MobileConversionBar.tsx:26",
    "text": "/diagnostic?intent=${encodeURIComponent(landing.searchIntent)}",
    "file": "app/components/layout/MobileConversionBar.tsx"
  },
  {
    "id": "app/components/layout/MobileConversionBar.tsx:28",
    "text": "arrow aria-label={`${activeLabel} — ouvrir le diagnostic`} onClick={() => analytics.track(",
    "file": "app/components/layout/MobileConversionBar.tsx"
  },
  {
    "id": "app/components/layout/MobileConversionBar.tsx:27",
    "text": "data-phone-number={activeLabel} aria-label={`Appeler Orée au ${activeLabel}`} onClick={() => analytics.track(",
    "file": "app/components/layout/MobileConversionBar.tsx"
  },
  {
    "id": "app/components/layout/OpsLayout.tsx:34",
    "text": ">Contrôles documentaires</p> <p className=",
    "file": "app/components/layout/OpsLayout.tsx"
  },
  {
    "id": "app/components/layout/OpsLayout.tsx:31",
    "text": ">Orée Operations</p> <h1 className=",
    "file": "app/components/layout/OpsLayout.tsx"
  },
  {
    "id": "app/components/layout/OpsLayout.tsx:35",
    "text": ">Ouvrir la file réelle des pièces à contrôler.</p> </Link> <Link to=",
    "file": "app/components/layout/OpsLayout.tsx"
  },
  {
    "id": "app/components/layout/OpsLayout.tsx:33",
    "text": ">Raccourcis de suivi</p> <Link to=",
    "file": "app/components/layout/OpsLayout.tsx"
  },
  {
    "id": "app/components/layout/OpsLayout.tsx:32",
    "text": ">Rechercher avec le Guide Orée</span> <span className=",
    "file": "app/components/layout/OpsLayout.tsx"
  },
  {
    "id": "app/components/layout/OpsLayout.tsx:29",
    "text": "Accès filtré par rôle et affectation.",
    "file": "app/components/layout/OpsLayout.tsx"
  },
  {
    "id": "app/components/layout/OpsLayout.tsx:30",
    "text": "Données locales sans mutation externe.",
    "file": "app/components/layout/OpsLayout.tsx"
  },
  {
    "id": "app/components/layout/PublicFooter.tsx:45",
    "text": "/>Données privées, consentement maîtrisé et accès contrôlés.</div> <ButtonLink to=",
    "file": "app/components/layout/PublicFooter.tsx"
  },
  {
    "id": "app/components/layout/PublicFooter.tsx:40",
    "text": "/>Votre prochaine étape</span><h2 className=",
    "file": "app/components/layout/PublicFooter.tsx"
  },
  {
    "id": "app/components/layout/PublicFooter.tsx:46",
    "text": "><p>© 2026 Orée.</p><p>Orée Entreprises est un service exploité par Optimum Tech — SIRET : 98898880400015</p></div><div className=",
    "file": "app/components/layout/PublicFooter.tsx"
  },
  {
    "id": "app/components/layout/PublicFooter.tsx:41",
    "text": ">feuille de route structurée.</span></h2><p className=",
    "file": "app/components/layout/PublicFooter.tsx"
  },
  {
    "id": "app/components/layout/PublicFooter.tsx:42",
    "text": ">Le diagnostic analyse d'abord votre situation, sans exiger de document au début du parcours.</p></div> <div className=",
    "file": "app/components/layout/PublicFooter.tsx"
  },
  {
    "id": "app/components/layout/PublicFooter.tsx:44",
    "text": ">Une plateforme pensée pour faire avancer un projet de société avec clarté, continuité et accompagnement humain.</p> <div className=",
    "file": "app/components/layout/PublicFooter.tsx"
  },
  {
    "id": "app/components/layout/PublicFooter.tsx:43",
    "text": "arrow>Commencer mon dossier</ButtonLink><ButtonLink to=",
    "file": "app/components/layout/PublicFooter.tsx"
  },
  {
    "id": "app/components/layout/PublicFooter.tsx:36",
    "text": "Choisir son statut",
    "file": "app/components/layout/PublicFooter.tsx"
  },
  {
    "id": "app/components/layout/PublicFooter.tsx:37",
    "text": "Créer en étant salarié",
    "file": "app/components/layout/PublicFooter.tsx"
  },
  {
    "id": "app/components/layout/PublicFooter.tsx:39",
    "text": "Espace de démonstration",
    "file": "app/components/layout/PublicFooter.tsx"
  },
  {
    "id": "app/components/layout/PublicFooter.tsx:38",
    "text": "Passer de micro en société",
    "file": "app/components/layout/PublicFooter.tsx"
  },
  {
    "id": "app/components/layout/PublicHeader.tsx:54",
    "text": ", closeOutside); document.addEventListener(",
    "file": "app/components/layout/PublicHeader.tsx"
  },
  {
    "id": "app/components/layout/PublicHeader.tsx:56",
    "text": ", closeOutside); document.removeEventListener(",
    "file": "app/components/layout/PublicHeader.tsx"
  },
  {
    "id": "app/components/layout/PublicHeader.tsx:55",
    "text": ", closeWithEscape); return () => { document.removeEventListener(",
    "file": "app/components/layout/PublicHeader.tsx"
  },
  {
    "id": "app/components/layout/PublicHeader.tsx:51",
    "text": ", onScroll); }, []); useEffect(() => { document.body.style.overflow = open ?",
    "file": "app/components/layout/PublicHeader.tsx"
  },
  {
    "id": "app/components/layout/PublicHeader.tsx:52",
    "text": "; return () => { document.body.style.overflow =",
    "file": "app/components/layout/PublicHeader.tsx"
  },
  {
    "id": "app/components/layout/PublicHeader.tsx:53",
    "text": ") setCreateOpen(false); }; document.addEventListener(",
    "file": "app/components/layout/PublicHeader.tsx"
  },
  {
    "id": "app/components/layout/PublicHeader.tsx:58",
    "text": "/diagnostic?intent=creation_sasu",
    "file": "app/components/layout/PublicHeader.tsx"
  },
  {
    "id": "app/components/layout/PublicHeader.tsx:61",
    "text": ">Commencer mon dossier <ArrowRight className=",
    "file": "app/components/layout/PublicHeader.tsx"
  },
  {
    "id": "app/components/layout/PublicHeader.tsx:66",
    "text": ">Créer votre structure</p> <div className=",
    "file": "app/components/layout/PublicHeader.tsx"
  },
  {
    "id": "app/components/layout/PublicHeader.tsx:60",
    "text": ">Le diagnostic part de votre situation avant d'aborder la forme juridique.</p> <span className=",
    "file": "app/components/layout/PublicHeader.tsx"
  },
  {
    "id": "app/components/layout/PublicHeader.tsx:65",
    "text": ">Une orientation adaptée à votre situation réelle.</p><ArrowRight className=",
    "file": "app/components/layout/PublicHeader.tsx"
  },
  {
    "id": "app/components/layout/PublicHeader.tsx:59",
    "text": ">Vous hésitez encore&nbsp;?</p> <p className=",
    "file": "app/components/layout/PublicHeader.tsx"
  },
  {
    "id": "app/components/layout/PublicHeader.tsx:64",
    "text": "Commencer mon dossier",
    "file": "app/components/layout/PublicHeader.tsx"
  },
  {
    "id": "app/components/layout/PublicHeader.tsx:63",
    "text": "Créer ma SASU — 600 € TTC",
    "file": "app/components/layout/PublicHeader.tsx"
  },
  {
    "id": "app/components/layout/PublicHeader.tsx:48",
    "text": "Créer seul, cadre structuré",
    "file": "app/components/layout/PublicHeader.tsx"
  },
  {
    "id": "app/components/layout/PublicHeader.tsx:47",
    "text": "Créer seul, structure souple",
    "file": "app/components/layout/PublicHeader.tsx"
  },
  {
    "id": "app/components/layout/PublicHeader.tsx:57",
    "text": "data-phone-number={contact.displayPhone} aria-label={`Appeler Orée au ${contact.displayPhone}`} onClick={() => analytics.track(",
    "file": "app/components/layout/PublicHeader.tsx"
  },
  {
    "id": "app/components/layout/PublicHeader.tsx:50",
    "text": "Organisation collective encadrée",
    "file": "app/components/layout/PublicHeader.tsx"
  },
  {
    "id": "app/components/layout/PublicHeader.tsx:49",
    "text": "Projet avec associés",
    "file": "app/components/layout/PublicHeader.tsx"
  },
  {
    "id": "app/components/layout/PublicHeader.tsx:62",
    "text": "Rechercher avec le Guide Orée",
    "file": "app/components/layout/PublicHeader.tsx"
  },
  {
    "id": "app/components/layout/PublicLayout.tsx:67",
    "text": "à partir // du premier changement de route. React Router marque l",
    "file": "app/components/layout/PublicLayout.tsx"
  },
  {
    "id": "app/components/layout/PublicLayout.tsx:71",
    "text": "animation de sortie contient <Outlet />, qui suit le contexte de route et rend donc immédiatement la page entrante. Celle-ci héritait de l",
    "file": "app/components/layout/PublicLayout.tsx"
  },
  {
    "id": "app/components/layout/PublicLayout.tsx:70",
    "text": "arrivée du chunk suivant. */} <Suspense fallback={<div className=\"min-h-[70vh]\" aria-hidden=\"true\" />}> {/* Pas d",
    "file": "app/components/layout/PublicLayout.tsx"
  },
  {
    "id": "app/components/layout/PublicLayout.tsx:69",
    "text": "au Suspense de App et affiche le PageLoader plein écran à chaque navigation. Ici, l",
    "file": "app/components/layout/PublicLayout.tsx"
  },
  {
    "id": "app/components/layout/PublicLayout.tsx:68",
    "text": "et attribue une clé unique à chaque // navigation client. const animateEntrance = !reduce && location.key !==",
    "file": "app/components/layout/PublicLayout.tsx"
  },
  {
    "id": "app/components/marketing/AcquisitionContactActions.tsx:74",
    "text": "/>Écrire sur WhatsApp </a> </div> </div> ); } return ( <div className=",
    "file": "app/components/marketing/AcquisitionContactActions.tsx"
  },
  {
    "id": "app/components/marketing/AcquisitionContactActions.tsx:72",
    "text": "Bonjour, je souhaite créer une ${legalForm} avec Orée Entreprises.",
    "file": "app/components/marketing/AcquisitionContactActions.tsx"
  },
  {
    "id": "app/components/marketing/AcquisitionContactActions.tsx:73",
    "text": "Bonjour, je souhaite échanger au sujet de la création de mon entreprise.",
    "file": "app/components/marketing/AcquisitionContactActions.tsx"
  },
  {
    "id": "app/components/marketing/ActivitySpotlight.tsx:76",
    "text": "Un rythme soutenu, une équipe et des décisions à rendre lisibles avant de se lancer.",
    "file": "app/components/marketing/ActivitySpotlight.tsx"
  },
  {
    "id": "app/components/marketing/ActivitySpotlight.tsx:75",
    "text": "Une activité mobile, du matériel et des journées organisées autour des interventions.",
    "file": "app/components/marketing/ActivitySpotlight.tsx"
  },
  {
    "id": "app/components/marketing/CallbackLeadForm.tsx:78",
    "text": "]; return { forms, title: legalForm ? `Projet de ${legalForm} à reprendre avec l’équipe` :",
    "file": "app/components/marketing/CallbackLeadForm.tsx"
  },
  {
    "id": "app/components/marketing/CallbackLeadForm.tsx:84",
    "text": ">{errors.firstName.message}</span> : null}</label> <label className=",
    "file": "app/components/marketing/CallbackLeadForm.tsx"
  },
  {
    "id": "app/components/marketing/CallbackLeadForm.tsx:86",
    "text": ">{errors.phone.message}</span> : null}</label> <label className=",
    "file": "app/components/marketing/CallbackLeadForm.tsx"
  },
  {
    "id": "app/components/marketing/CallbackLeadForm.tsx:87",
    "text": ">Date de création souhaitée<select className={fieldClass} {...register(",
    "file": "app/components/marketing/CallbackLeadForm.tsx"
  },
  {
    "id": "app/components/marketing/CallbackLeadForm.tsx:81",
    "text": ">Demandez à l’équipe de vous rappeler.</h2> <p className=",
    "file": "app/components/marketing/CallbackLeadForm.tsx"
  },
  {
    "id": "app/components/marketing/CallbackLeadForm.tsx:82",
    "text": ">Indiquez vos coordonnées pour être rappelé par l’équipe. Vous préférez appeler&nbsp;? <a href={contact.phoneHref} data-conv=",
    "file": "app/components/marketing/CallbackLeadForm.tsx"
  },
  {
    "id": "app/components/marketing/CallbackLeadForm.tsx:83",
    "text": ">Prénom<input autoComplete=",
    "file": "app/components/marketing/CallbackLeadForm.tsx"
  },
  {
    "id": "app/components/marketing/CallbackLeadForm.tsx:85",
    "text": ">Téléphone<input type=",
    "file": "app/components/marketing/CallbackLeadForm.tsx"
  },
  {
    "id": "app/components/marketing/CallbackLeadForm.tsx:80",
    "text": ">Votre demande de rappel est enregistrée.</h2> <p className=",
    "file": "app/components/marketing/CallbackLeadForm.tsx"
  },
  {
    "id": "app/components/marketing/CallbackLeadForm.tsx:77",
    "text": "Calendrier à préciser",
    "file": "app/components/marketing/CallbackLeadForm.tsx"
  },
  {
    "id": "app/components/marketing/CallbackLeadForm.tsx:79",
    "text": "Calendrier de création",
    "file": "app/components/marketing/CallbackLeadForm.tsx"
  },
  {
    "id": "app/components/marketing/CommercialOfferCard.tsx:88",
    "text": "/>Prix fixe confirmé</Badge> <h2 className={cn(",
    "file": "app/components/marketing/CommercialOfferCard.tsx"
  },
  {
    "id": "app/components/marketing/CommercialOfferCard.tsx:89",
    "text": "> {offer.description} Les frais de greffe et d'annonce légale sont des frais obligatoires reversés à des tiers ; ils ne constituent pas notre rémunération. </p> <p className=",
    "file": "app/components/marketing/CommercialOfferCard.tsx"
  },
  {
    "id": "app/components/marketing/CommercialOfferCard.tsx:90",
    "text": "> <Badge>Offre distincte</Badge> <h3 className=",
    "file": "app/components/marketing/CommercialOfferCard.tsx"
  },
  {
    "id": "app/components/marketing/ContactLauncher.tsx:91",
    "text": "Appeler Orée au ${contact.displayPhone}",
    "file": "app/components/marketing/ContactLauncher.tsx"
  },
  {
    "id": "app/components/marketing/CostClarity.tsx:92",
    "text": ", description: `Les frais de greffe et l’annonce légale nécessaires à la création sont compris dans les ${commercialOffers.companyCreation.priceLabel}.`, }, { icon: Layers3, title:",
    "file": "app/components/marketing/CostClarity.tsx"
  },
  {
    "id": "app/components/marketing/CostClarity.tsx:93",
    "text": "> <div> <Badge>Comprendre le coût</Badge> <h2 className={cn(",
    "file": "app/components/marketing/CostClarity.tsx"
  },
  {
    "id": "app/components/marketing/DashboardPreview.tsx:98",
    "text": ">Activité récente</p><MessageSquareText className=",
    "file": "app/components/marketing/DashboardPreview.tsx"
  },
  {
    "id": "app/components/marketing/DashboardPreview.tsx:95",
    "text": ">Confirmé</span></div><p className=",
    "file": "app/components/marketing/DashboardPreview.tsx"
  },
  {
    "id": "app/components/marketing/DashboardPreview.tsx:94",
    "text": ">Orée</span></div><nav className=",
    "file": "app/components/marketing/DashboardPreview.tsx"
  },
  {
    "id": "app/components/marketing/DashboardPreview.tsx:96",
    "text": ">Prochain rendez-vous</p><p className=",
    "file": "app/components/marketing/DashboardPreview.tsx"
  },
  {
    "id": "app/components/marketing/DashboardPreview.tsx:97",
    "text": ">Transmettez un document lisible datant de moins de trois mois.</p><span className=",
    "file": "app/components/marketing/DashboardPreview.tsx"
  },
  {
    "id": "app/components/marketing/DashboardPreview.tsx:99",
    "text": "identité validée\", time: \"09:42\" }, { icon: MessageSquareText, text: \"Nouveau message de l",
    "file": "app/components/marketing/DashboardPreview.tsx"
  },
  {
    "id": "app/components/marketing/DynamicHeroCarousel.tsx:100",
    "text": "/>Parler à un conseiller </ButtonLink> </div> </motion.div> </AnimatePresence> </motion.div> <button type=",
    "file": "app/components/marketing/DynamicHeroCarousel.tsx"
  },
  {
    "id": "app/components/marketing/DynamicHeroCarousel.tsx:101",
    "text": "Mettre en pause le défilement du héros",
    "file": "app/components/marketing/DynamicHeroCarousel.tsx"
  },
  {
    "id": "app/components/marketing/EcosystemRail.tsx:104",
    "text": ">Les organismes et interlocuteurs concernés varient selon votre activité, votre structure et votre dossier.</p> <button type=",
    "file": "app/components/marketing/EcosystemRail.tsx"
  },
  {
    "id": "app/components/marketing/EcosystemRail.tsx:103",
    "text": "activité et les choix du projet. Cette vue situe les interlocuteurs possibles sans laisser entendre qu",
    "file": "app/components/marketing/EcosystemRail.tsx"
  },
  {
    "id": "app/components/marketing/EcosystemRail.tsx:102",
    "text": "Direction générale des Finances publiques",
    "file": "app/components/marketing/EcosystemRail.tsx"
  },
  {
    "id": "app/components/marketing/EcosystemRail.tsx:106",
    "text": "écosystème de la création d",
    "file": "app/components/marketing/EcosystemRail.tsx"
  },
  {
    "id": "app/components/marketing/EcosystemRail.tsx:105",
    "text": "Mettre en pause le défilement des organismes",
    "file": "app/components/marketing/EcosystemRail.tsx"
  },
  {
    "id": "app/components/marketing/HeroCockpit.tsx:115",
    "text": ">Dossier de création</p><p className=",
    "file": "app/components/marketing/HeroCockpit.tsx"
  },
  {
    "id": "app/components/marketing/HeroCockpit.tsx:119",
    "text": ">Guide Orée disponible pour cette étape</span></div><span className=",
    "file": "app/components/marketing/HeroCockpit.tsx"
  },
  {
    "id": "app/components/marketing/HeroCockpit.tsx:117",
    "text": ">Pièces prévues</p></div> <div className=",
    "file": "app/components/marketing/HeroCockpit.tsx"
  },
  {
    "id": "app/components/marketing/HeroCockpit.tsx:116",
    "text": ">Première recommandation</span><ArrowUpRight className=",
    "file": "app/components/marketing/HeroCockpit.tsx"
  },
  {
    "id": "app/components/marketing/HeroCockpit.tsx:118",
    "text": ">Relais humain demandé</p></div> </div> </div> </div> <div className=",
    "file": "app/components/marketing/HeroCockpit.tsx"
  },
  {
    "id": "app/components/marketing/HeroCockpit.tsx:110",
    "text": "3 pièces seront demandées",
    "file": "app/components/marketing/HeroCockpit.tsx"
  },
  {
    "id": "app/components/marketing/HeroCockpit.tsx:109",
    "text": "8 éléments sur 11 renseignés",
    "file": "app/components/marketing/HeroCockpit.tsx"
  },
  {
    "id": "app/components/marketing/HeroCockpit.tsx:107",
    "text": "Activité, porteurs et calendrier",
    "file": "app/components/marketing/HeroCockpit.tsx"
  },
  {
    "id": "app/components/marketing/HeroCockpit.tsx:113",
    "text": "Aucun document sensible n'est nécessaire pour commencer le diagnostic.",
    "file": "app/components/marketing/HeroCockpit.tsx"
  },
  {
    "id": "app/components/marketing/HeroCockpit.tsx:111",
    "text": "Le mode de rémunération peut modifier la comparaison entre SASU et EURL.",
    "file": "app/components/marketing/HeroCockpit.tsx"
  },
  {
    "id": "app/components/marketing/HeroCockpit.tsx:112",
    "text": "Précisez si vous conservez une activité salariée au lancement.",
    "file": "app/components/marketing/HeroCockpit.tsx"
  },
  {
    "id": "app/components/marketing/HeroCockpit.tsx:108",
    "text": "SASU et EURL à comparer",
    "file": "app/components/marketing/HeroCockpit.tsx"
  },
  {
    "id": "app/components/marketing/HeroCockpit.tsx:114",
    "text": "Un conseiller peut reprendre exactement là où vous vous êtes arrêté.",
    "file": "app/components/marketing/HeroCockpit.tsx"
  },
  {
    "id": "app/components/marketing/HomeConversionHero.tsx:121",
    "text": "${commercialOffers.companyCreation.priceLabel} avec greffe et annonce légale incluses",
    "file": "app/components/marketing/HomeConversionHero.tsx"
  },
  {
    "id": "app/components/marketing/HomeConversionHero.tsx:122",
    "text": "Aucun document sensible nécessaire pour commencer",
    "file": "app/components/marketing/HomeConversionHero.tsx"
  },
  {
    "id": "app/components/marketing/HomeConversionHero.tsx:120",
    "text": "Une première orientation avant de créer un compte",
    "file": "app/components/marketing/HomeConversionHero.tsx"
  },
  {
    "id": "app/components/marketing/LegalFormCards.tsx:123",
    "text": "/>À confirmer selon votre situation</span><span className=",
    "file": "app/components/marketing/LegalFormCards.tsx"
  },
  {
    "id": "app/components/marketing/ProcessRail.tsx:128",
    "text": ">Situation illustrative · contrôle documentaire</span> </div> <div className=",
    "file": "app/components/marketing/ProcessRail.tsx"
  },
  {
    "id": "app/components/marketing/ProcessRail.tsx:125",
    "text": "Capital & signatures",
    "file": "app/components/marketing/ProcessRail.tsx"
  },
  {
    "id": "app/components/marketing/ProcessRail.tsx:127",
    "text": "Les documents finaux sont rattachés au projet et restent accessibles dans le même espace.",
    "file": "app/components/marketing/ProcessRail.tsx"
  },
  {
    "id": "app/components/marketing/ProcessRail.tsx:126",
    "text": "Les étapes spécifiques à votre structure s'activent uniquement lorsqu'elles sont nécessaires.",
    "file": "app/components/marketing/ProcessRail.tsx"
  },
  {
    "id": "app/components/marketing/ProcessRail.tsx:124",
    "text": "Pièces centralisées",
    "file": "app/components/marketing/ProcessRail.tsx"
  },
  {
    "id": "app/components/marketing/SasuConversionSections.tsx:132",
    "text": "/>Être rappelé </a> </div> <p className=",
    "file": "app/components/marketing/SasuConversionSections.tsx"
  },
  {
    "id": "app/components/marketing/SasuConversionSections.tsx:133",
    "text": "> 7j/7 de 7h à 20h. C’est Sof qui décroche, pas un standard. </p> <a href={buildWhatsAppHref(undefined, whatsappMessage)} target=",
    "file": "app/components/marketing/SasuConversionSections.tsx"
  },
  {
    "id": "app/components/marketing/SasuConversionSections.tsx:129",
    "text": "Accompagnement à la création",
    "file": "app/components/marketing/SasuConversionSections.tsx"
  },
  {
    "id": "app/components/marketing/SasuConversionSections.tsx:131",
    "text": "Bonjour, je souhaite créer une SASU avec Orée Entreprises.",
    "file": "app/components/marketing/SasuConversionSections.tsx"
  },
  {
    "id": "app/components/marketing/SasuConversionSections.tsx:130",
    "text": "Corrections du dossier",
    "file": "app/components/marketing/SasuConversionSections.tsx"
  },
  {
    "id": "app/components/marketing/ServiceScope.tsx:139",
    "text": "> <Badge>Périmètre et responsabilités</Badge> <h2 className={`${compact ?",
    "file": "app/components/marketing/ServiceScope.tsx"
  },
  {
    "id": "app/components/marketing/ServiceScope.tsx:134",
    "text": "Ce qu’ORÉE organise",
    "file": "app/components/marketing/ServiceScope.tsx"
  },
  {
    "id": "app/components/marketing/ServiceScope.tsx:137",
    "text": "Ce qui exige un professionnel réglementé",
    "file": "app/components/marketing/ServiceScope.tsx"
  },
  {
    "id": "app/components/marketing/ServiceScope.tsx:138",
    "text": "Le conseil juridique, fiscal ou comptable personnalisé et les actes réglementés sont confirmés par le professionnel compétent lorsque nécessaire.",
    "file": "app/components/marketing/ServiceScope.tsx"
  },
  {
    "id": "app/components/marketing/ServiceScope.tsx:135",
    "text": "Le diagnostic, la collecte structurée, la complétude du dossier, les demandes et la prochaine action dans un espace unique.",
    "file": "app/components/marketing/ServiceScope.tsx"
  },
  {
    "id": "app/components/marketing/ServiceScope.tsx:136",
    "text": "Les formalités d'enregistrement, contrôles et décisions restent effectués par les organismes compétents.",
    "file": "app/components/marketing/ServiceScope.tsx"
  },
  {
    "id": "app/components/ui/PageLoader.tsx:141",
    "text": ">Chargement sécurisé des contenus et de votre prochaine action.</p> <div className=",
    "file": "app/components/ui/PageLoader.tsx"
  },
  {
    "id": "app/components/ui/PageLoader.tsx:140",
    "text": ">Préparation de votre espace…</p> <p className=",
    "file": "app/components/ui/PageLoader.tsx"
  },
  {
    "id": "app/config/brand.ts:142",
    "text": "entreprise\", tagline: \"Votre société, de l",
    "file": "app/config/brand.ts"
  },
  {
    "id": "app/config/commercial-offers.ts:151",
    "text": "; } export function buildWhatsAppHref( value: string = commercialOffers.contact.whatsapp, message: string = \"Bonjour, je souhaite échanger au sujet de la création de mon entreprise.\", ) { return",
    "file": "app/config/commercial-offers.ts"
  },
  {
    "id": "app/config/commercial-offers.ts:143",
    "text": "Annonce légale incluse",
    "file": "app/config/commercial-offers.ts"
  },
  {
    "id": "app/config/commercial-offers.ts:147",
    "text": "Commencer ma création",
    "file": "app/config/commercial-offers.ts"
  },
  {
    "id": "app/config/commercial-offers.ts:144",
    "text": "Corrections et compléments du dossier inclus",
    "file": "app/config/commercial-offers.ts"
  },
  {
    "id": "app/config/commercial-offers.ts:149",
    "text": "Création de micro-entreprise",
    "file": "app/config/commercial-offers.ts"
  },
  {
    "id": "app/config/commercial-offers.ts:150",
    "text": "Créez votre ${form} pour ${commercialOffers.companyCreation.priceLabel}",
    "file": "app/config/commercial-offers.ts"
  },
  {
    "id": "app/config/commercial-offers.ts:152",
    "text": "Demande depuis Orée Entreprises",
    "file": "app/config/commercial-offers.ts"
  },
  {
    "id": "app/config/commercial-offers.ts:148",
    "text": "Le paiement intervient après que vous avez renseigné les informations nécessaires au dossier.",
    "file": "app/config/commercial-offers.ts"
  },
  {
    "id": "app/config/commercial-offers.ts:145",
    "text": "Modification d’une société existante",
    "file": "app/config/commercial-offers.ts"
  },
  {
    "id": "app/config/commercial-offers.ts:146",
    "text": "Offre réservée aux créations d’entreprise. Les modifications de sociétés existantes ne sont pas prises en charge.",
    "file": "app/config/commercial-offers.ts"
  },
  {
    "id": "app/config/routes.ts:153",
    "text": "Choisir mon statut",
    "file": "app/config/routes.ts"
  },
  {
    "id": "app/content/contact.ts:157",
    "text": ", href: buildWhatsAppHref(directContact.whatsapp, message), external: true }, { id:",
    "file": "app/content/contact.ts"
  },
  {
    "id": "app/content/contact.ts:154",
    "text": "Bonjour, j’ai une question au sujet de la création de mon entreprise.",
    "file": "app/content/contact.ts"
  },
  {
    "id": "app/content/contact.ts:156",
    "text": "Envoyer une demande plus détaillée.",
    "file": "app/content/contact.ts"
  },
  {
    "id": "app/content/contact.ts:159",
    "text": "https://api.whatsapp.com/send?phone=${directContact.phone.slice(1)}&text=${encodeURIComponent(message)}",
    "file": "app/content/contact.ts"
  },
  {
    "id": "app/content/contact.ts:158",
    "text": "Ouvrir l’échange côté professionnel.",
    "file": "app/content/contact.ts"
  },
  {
    "id": "app/content/contact.ts:155",
    "text": "sms:${directContact.phone}?body=${encodeURIComponent(message)}",
    "file": "app/content/contact.ts"
  },
  {
    "id": "app/content/imagery.ts:183",
    "text": "], }), documentReview: asset({ base: `${imageryRoot}/process/process-document-review`, widths: [480, 720, 960, 1280], width: 1280, height: 960, alt:",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:168",
    "text": "${imageryRoot}/landing/hero-blocked-dossier-review",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:169",
    "text": "${imageryRoot}/mobile/hero-blocked-dossier-review-mobile",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:175",
    "text": "Artisan préparant son travail dans son atelier.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:176",
    "text": "Commerçante organisant les produits de son magasin de proximité.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:171",
    "text": "Créateur prenant du recul avant de comparer les structures adaptées à son projet.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:162",
    "text": "Créateur seul relisant les éléments de son projet de société près de son ordinateur.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:172",
    "text": "Créateur travaillant seul sur les premières décisions de sa future société.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:173",
    "text": "Créatrice préparant les premières décisions de son entreprise depuis chez elle.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:161",
    "text": "Créatrice travaillant naturellement sur son projet de société depuis sa table de cuisine.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:180",
    "text": "Documents de travail, carnet et calculatrice organisés sur une table.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:170",
    "text": "Entrepreneur examinant calmement les étapes d'un dossier de création à reprendre.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:182",
    "text": "Entrepreneur prenant des notes pendant un échange de cadrage en visioconférence.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:163",
    "text": "Entrepreneur structurant seul son activité avec ses notes et son ordinateur.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:167",
    "text": "Indépendant déjà en activité organisant sa transition vers une société.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:181",
    "text": "Porteuse de projet échangeant avec un accompagnant au sujet de son dossier.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:179",
    "text": "Professionnel de la logistique préparant une livraison.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:177",
    "text": "Professionnelle de service préparant son matériel avant une intervention.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:178",
    "text": "Restaurateur préparant sa salle avant le service.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:166",
    "text": "Salarié préparant progressivement son projet d'entreprise dans un espace de travail calme.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:164",
    "text": "Trois associés discutent des décisions d'un projet de société autour d'une table.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:165",
    "text": "Trois associés organisent ensemble les informations de leur future société.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:174",
    "text": "Trois porteurs de projet discutent ensemble de leurs premières décisions.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/imagery.ts:160",
    "text": "Trois porteurs de projet examinent ensemble leur dossier de création de société.",
    "file": "app/content/imagery.ts"
  },
  {
    "id": "app/content/knowledge.ts:196",
    "text": ")}. Il concerne la préparation et le dépôt d’un dossier de création.`, actions: [ { label:",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:195",
    "text": "], answer: `Le forfait à ${commercialOffers.companyCreation.priceLabel} comprend ${commercialOffers.companyCreation.included.map((item) => item.toLocaleLowerCase(",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:198",
    "text": "${commercialOffers.companyCreation.restriction} Un dossier de création déjà commencé mais bloqué reste un besoin distinct : vous pouvez décrire le blocage pour vérifier la prochaine action.",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:190",
    "text": "activité déjà lancée, les clients, les charges, les raisons du changement et le calendrier. SASU et EURL peuvent ensuite être comparées sans supposer qu",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:188",
    "text": "activité secondaire",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:187",
    "text": "Choisir un créneau",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:184",
    "text": "Commencer le diagnostic",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:192",
    "text": "Comprendre les points à vérifier",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:202",
    "text": "Contacter l’équipe Orée",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:197",
    "text": "Créations prises en charge et modifications exclues",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:204",
    "text": "Démarrer le diagnostic",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:208",
    "text": "espace projet réunit l",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:206",
    "text": "étape concernée et la demande reçue. Il associe ensuite la correction au bon document et conserve l",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:207",
    "text": "exécution du service sont distinguées des communications commerciales. Les documents doivent être conservés dans un espace privé avec des droits d",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:201",
    "text": "La création de micro-entreprise est une offre distincte à ${commercialOffers.microEnterprise.priceLabel}. ${commercialOffers.microEnterprise.description} ${commercialOffers.microEnterprise.paymentStage}",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:205",
    "text": "La messagerie relie chaque échange au projet. Les demandes de documents ou de correction peuvent pointer directement vers la pièce concernée.",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:191",
    "text": "Le parcours aide à organiser le calendrier et les points à vérifier. Il ne garantit ni éligibilité, ni maintien des allocations : ces éléments dépendent du dossier et des règles applicables.",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:200",
    "text": "Offre de création de micro-entreprise",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:189",
    "text": "Passer de micro-entreprise en société",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:185",
    "text": "Prendre rendez-vous",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:193",
    "text": "Prix fixe de création de société",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:194",
    "text": "Voir l’offre complète",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:199",
    "text": "Voir l’offre de création",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:203",
    "text": "Vous pouvez demander un rappel, appeler ou écrire sur WhatsApp au ${commercialOffers.contact.displayPhone}, ou envoyer un e-mail à ${commercialOffers.contact.email}. ${commercialOffers.contact.availability}.",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/knowledge.ts:186",
    "text": "Vous pouvez sélectionner un échange de cadrage, une validation d'orientation ou un point consacré au dossier. Les formats proposés sont le téléphone et la visioconférence, avec plusieurs plages horaires.",
    "file": "app/content/knowledge.ts"
  },
  {
    "id": "app/content/landingPages.ts:210",
    "text": "Accompagnement, frais de greffe, annonce légale et corrections du dossier inclus.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:230",
    "text": "Accompagnement, greffe, annonce légale et corrections du dossier inclus. Clarifiez le cadre de votre projet solo avant la formalité.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:271",
    "text": "Accompagnement, greffe, annonce légale et corrections du dossier inclus. Organisez les associés, la gérance et les apports avant la formalité.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:249",
    "text": "Accompagnement, greffe, annonce légale et corrections du dossier inclus. Organisez les associés, le capital et la gouvernance avant la formalité.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:316",
    "text": "Activité déjà en cours",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:217",
    "text": "Activité, calendrier, rémunération, développement et contraintes.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:301",
    "text": "Activité, clients, besoins, rémunération et risques.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:321",
    "text": "Activité, revenus, charges, clients et organisation actuelle.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:409",
    "text": "Ajoutez le message",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:312",
    "text": "Analysez les raisons du changement, comparez les structures et préparez la transition en préservant la continuité de votre activité.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:342",
    "text": "Anticipez les pièces",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:394",
    "text": "ARE, ARCE et ACRE sont-elles la même aide ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:276",
    "text": "Associés, gérants, apports et participations.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:401",
    "text": "Aucun document sensible pour commencer",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:237",
    "text": "Cadrez votre activité",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:292",
    "text": "Calendrier intégré à la synthèse",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:254",
    "text": "Capital à répartir",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:250",
    "text": "Capital et rôles à préciser",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:265",
    "text": "Cela dépend du projet. La SAS offre une forte liberté statutaire, tandis que la SARL apporte un cadre légal plus balisé. Les objectifs des associés doivent guider l'analyse.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:329",
    "text": "Cela peut être nécessaire lorsque l'entité qui facture change. Ce point doit figurer dans la liste de contrôle de la transition.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:261",
    "text": "Centralisez les pièces",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:339",
    "text": "Chaque action doit avoir un responsable, une date et un statut.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:257",
    "text": "Chaque associé doit savoir ce qu'il doit compléter, fournir ou valider.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:348",
    "text": "Chaque associé voit-il tous les documents ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:215",
    "text": "Chaque justificatif est suivi afin d'éviter les oublis et les allers-retours inutiles.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:416",
    "text": "Chaque nouveau fichier devient une version distincte, avec date, auteur, statut et commentaire.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:278",
    "text": "Chaque personne voit uniquement ses actions et leur statut.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:353",
    "text": "Choisissez une structure adaptée à",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:285",
    "text": "Comment éviter les documents manquants ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:266",
    "text": "Comment répartir le capital ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:277",
    "text": "Comparez la SARL à la SAS selon votre organisation et vos objectifs.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:218",
    "text": "Comparez la SASU avec les alternatives qui méritent réellement d'être étudiées.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:355",
    "text": "Comparez les formes unipersonnelles, précisez vos priorités et organisez les informations nécessaires avant d'engager les formalités.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:408",
    "text": "Compte, identité, statuts, capital, annonce, dépôt ou correction.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:334",
    "text": "Configurer notre projet",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:295",
    "text": "Conserver de la visibilité",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:240",
    "text": "Constituez le dossier",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:369",
    "text": "Constituez les informations et les pièces nécessaires dans un espace de suivi unique.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:289",
    "text": "Construisez votre feuille de route, sauvegardez votre progression et choisissez le bon moment pour lancer les formalités.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:319",
    "text": "Continuité commerciale",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:314",
    "text": "Continuité des contrats à vérifier",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:410",
    "text": "Copiez la demande ou joignez le document reçu.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:375",
    "text": "Création & demande d’emploi",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:359",
    "text": "Créer seul ne conduit pas automatiquement à une SASU ou à une EURL. L'activité, la rémunération et les perspectives doivent être examinées ensemble.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:352",
    "text": "Créer une entreprise seul",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:229",
    "text": "Créez votre EURL pour",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:270",
    "text": "Créez votre SARL pour",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:248",
    "text": "Créez votre SAS pour",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:209",
    "text": "Créez votre SASU pour",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:376",
    "text": "Créez votre société en clarifiant d’abord",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:315",
    "text": "Date de transition à préciser",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:335",
    "text": "Décisions implicites",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:256",
    "text": "Décisions partagées",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:302",
    "text": "Déclenchez la création",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:364",
    "text": "Décrire l'activité",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:399",
    "text": "Décrivez l'étape, la demande reçue et les pièces concernées pour orienter rapidement la vérification.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:320",
    "text": "Décrivez l'existant",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:216",
    "text": "Décrivez votre projet",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:293",
    "text": "Demande d'échange facultative",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:290",
    "text": "Demander un échange",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:387",
    "text": "Dispositifs envisagés, rémunération et accompagnement attendu.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:304",
    "text": "Dois-je quitter mon emploi avant de préparer ma société ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:214",
    "text": "Dossier à fiabiliser",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:378",
    "text": "Éligibilité à confirmer auprès des organismes",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:299",
    "text": "Emploi actuel, disponibilité, échéance et niveau de maturité.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:313",
    "text": "Étudier mon passage en société",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:356",
    "text": "Étudier mon projet",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:366",
    "text": "Étudiez les différences entre société unipersonnelle, entreprise individuelle et régime micro.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:382",
    "text": "Éviter les conclusions générales",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:297",
    "text": "Éviter les raccourcis",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:362",
    "text": "Évolution à anticiper",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:235",
    "text": "Évolution du projet",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:400",
    "text": "Faire vérifier mon blocage",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:327",
    "text": "Faut-il fermer la micro-entreprise immédiatement ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:279",
    "text": "Finalisez le projet",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:242",
    "text": "Gardez le contrôle",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:251",
    "text": "Gouvernance à confirmer",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:252",
    "text": "Gouvernance à écrire",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:211",
    "text": "Greffe et annonce légale inclus",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:406",
    "text": "Historique dispersé",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:259",
    "text": "Identifiez chaque personne, son rôle envisagé et les informations à recueillir.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:322",
    "text": "Identifiez le déclencheur",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:239",
    "text": "Identifiez les différences concrètes entre EURL et SASU selon vos priorités.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:326",
    "text": "Il n'existe pas un seuil universel. La décision peut dépendre du chiffre d'affaires, des charges, de la protection recherchée, des investissements ou de l'arrivée d'associés.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:374",
    "text": "Il peut convenir à certaines activités en phase de lancement, mais ses limites et son mode de calcul doivent être comparés aux besoins réels du projet.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:391",
    "text": "Information publique, rendez-vous ou espace projet.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:241",
    "text": "Informations société, gérance, siège, capital et justificatifs.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:236",
    "text": "L'arrivée d'associés transforme l'EURL en SARL : mieux vaut anticiper ce scénario.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:363",
    "text": "L'arrivée future d'un associé, un financement ou un changement d'échelle peuvent modifier la structure la plus pertinente.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:234",
    "text": "L'EURL est encadrée par la loi : c'est rassurant, mais cela laisse moins de liberté que la SASU.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:245",
    "text": "L'EURL impose-t-elle un capital minimum élevé ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:381",
    "text": "La date de création et les demandes d’aide doivent être organisées avec attention.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:398",
    "text": "la démarche au bon endroit.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:247",
    "text": "La démonstration n'active pas encore les invitations externes. Dans le mode connecté, tout accès devra être limité aux informations nécessaires et confirmé avant ouverture.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:228",
    "text": "La liste dépend de votre situation et du siège social. Votre espace affiche uniquement les pièces nécessaires et leur statut.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:405",
    "text": "La plateforme associe chaque correction à la pièce et au commentaire correspondant.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:267",
    "text": "La plateforme permet de simuler une répartition et de signaler les incohérences, mais l'accord final appartient aux associés et peut nécessiter un conseil professionnel.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:350",
    "text": "La plateforme remplace-t-elle un pacte d'associés ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:274",
    "text": "La répartition des parts et les règles de cession doivent être comprises par tous.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:283",
    "text": "La SARL est-elle réservée aux familles ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:264",
    "text": "La SAS est-elle préférable à la SARL ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:223",
    "text": "La SASU convient-elle à tous les créateurs seuls ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:212",
    "text": "La SASU est souple, mais elle n'est pas automatiquement la meilleure réponse pour tous les projets solo.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:253",
    "text": "La souplesse de la SAS exige de préciser les règles de décision et les responsabilités.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:343",
    "text": "La synthèse distingue les informations attendues pour chaque associé.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:317",
    "text": "La transition doit tenir compte des clients, contrats, factures et outils utilisés.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:414",
    "text": "Le blocage sera-t-il résolu automatiquement ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:328",
    "text": "Le calendrier doit être organisé selon votre situation. La plateforme prévoit une feuille de route à confirmer avec les professionnels compétents.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:246",
    "text": "Le capital doit être cohérent avec le projet. La plateforme distingue le montant envisagé, les apports et les justificatifs à préparer.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:286",
    "text": "Le centre documentaire associe chaque exigence à une personne, un statut et une éventuelle demande de correction.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:370",
    "text": "Le choix dépend notamment de l'activité, du niveau de charges, de la rémunération envisagée, de la protection sociale recherchée et du développement prévu. La SASU et l'EURL ne sont pas les seules options à examiner.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:411",
    "text": "Le dossier est classé selon la nature du blocage.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:269",
    "text": "Le fonctionnement définitif des invitations doit encore être relié au mode connecté. Les droits de chaque associé devront rester limités à son rôle et aux informations nécessaires.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:413",
    "text": "Le parcours de reprise permet de réunir les documents disponibles, les demandes déjà reçues et l'historique utile avant d'identifier la prochaine action.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:361",
    "text": "Le régime du dirigeant, le mode de rémunération envisagé et la protection recherchée influencent la comparaison.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:373",
    "text": "Le régime micro est-il toujours le plus simple ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:273",
    "text": "Le statut du ou des gérants dépend notamment de la détention du capital.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:298",
    "text": "Le statut ne se choisit pas uniquement en fonction d'une promesse de charges plus faibles.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:233",
    "text": "Le statut social du gérant doit être compris avant de fixer la structure et la rémunération.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:255",
    "text": "Les apports et pourcentages doivent être cohérents, acceptés et documentés.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:380",
    "text": "Les conséquences dépendent du dispositif, de la rémunération et des démarches effectuées.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:345",
    "text": "Les décisions communes et les points professionnels à confirmer restent visibles.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:336",
    "text": "Les désaccords apparaissent souvent lorsque les rôles n'ont pas été explicités tôt.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:244",
    "text": "Les deux permettent de créer seul, mais leur gouvernance, le régime du dirigeant, la liberté statutaire et l'évolution vers plusieurs associés diffèrent.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:337",
    "text": "Les documents transmis dans plusieurs conversations sont difficiles à suivre.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:263",
    "text": "Les étapes critiques sont confirmées avant la préparation finale.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:280",
    "text": "Les informations consolidées alimentent le dossier et le suivi.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:213",
    "text": "Les règles de fonctionnement doivent correspondre à votre projet, à votre rémunération et à vos perspectives.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:307",
    "text": "Les réponses non sensibles sont sauvegardées localement pendant l'exploration. Les données personnelles enregistrées dans le service connecté devront être protégées par l'authentification et des droits d'accès stricts.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:404",
    "text": "Mauvaise pièce renvoyée",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:403",
    "text": "Message difficile à comprendre",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:306",
    "text": "Mon diagnostic reste-t-il confidentiel ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:238",
    "text": "Nature de l'activité, besoins, charges, clients et calendrier.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:385",
    "text": "Niveau d’avancement, date souhaitée et activité envisagée.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:349",
    "text": "Non nécessairement. Les droits peuvent être limités selon le rôle de la personne et la nature du document concerné.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:351",
    "text": "Non. Elle aide à collecter les décisions et à signaler les sujets à traiter. La rédaction d'un pacte relève d'un professionnel réglementé.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:284",
    "text": "Non. Elle convient à différents projets à plusieurs, notamment lorsque les associés préfèrent un cadre juridique structuré.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:224",
    "text": "Non. Elle mérite souvent d'être comparée à l'EURL, à l'entreprise individuelle ou au régime micro selon le niveau d'activité, la rémunération, la protection sociale recherchée et les perspectives du projet.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:395",
    "text": "Non. Elles répondent à des logiques différentes. Le parcours doit vous orienter vers les informations publiques et une validation adaptée.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:393",
    "text": "Non. L’éligibilité et le montant dépendent de votre dossier et des règles applicables. La plateforme met en évidence les points à vérifier.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:415",
    "text": "Non. La plateforme aide à qualifier la situation et à organiser la vérification. Certaines demandes exigent l'intervention d'un professionnel ou de l'organisme compétent.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:305",
    "text": "Non. Vous pouvez organiser le projet, comparer les structures et réunir des informations avant de déclencher les formalités.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:392",
    "text": "Orée peut-elle garantir le maintien de mes allocations ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:368",
    "text": "Organiser le dossier",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:357",
    "text": "Orientation expliquée et modifiable",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:347",
    "text": "Oui, tant que le projet n'est pas finalisé. Chaque modification importante doit être datée et conservée dans l'historique du dossier.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:226",
    "text": "Oui. Le diagnostic est conçu pour faire émerger les options pertinentes avant une validation humaine.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:372",
    "text": "Oui. Le diagnostic permet d'organiser les informations du projet et de faire ressortir les structures à approfondir avant toute validation définitive.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:282",
    "text": "Oui. Le projet doit alors préciser leur rôle, leurs pouvoirs et leur situation au capital.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:310",
    "text": "Passage en société",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:303",
    "text": "Passez au dossier lorsque le projet et le calendrier sont alignés.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:231",
    "text": "Pièces à anticiper présentées",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:358",
    "text": "Points à valider identifiés",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:389",
    "text": "Points à vérifier et formes juridiques à comparer.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:346",
    "text": "Pouvons-nous modifier la répartition du capital ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:365",
    "text": "Précisez l'offre, les clients, les charges, le calendrier et les besoins de financement.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:386",
    "text": "Précisez votre situation",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:344",
    "text": "Préparez la validation",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:219",
    "text": "Préparez votre dossier",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:287",
    "text": "Préparez votre société avec",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:379",
    "text": "Préserver ses droits",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:260",
    "text": "Présidence, pouvoirs, décisions et répartition du capital sont rendus visibles.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:330",
    "text": "Projet à plusieurs",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:332",
    "text": "projet partagé et vérifiable.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:360",
    "text": "Protection et rémunération",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:371",
    "text": "Puis-je commencer avant d'avoir arrêté mon choix ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:225",
    "text": "Puis-je commencer sans avoir choisi définitivement ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:308",
    "text": "Puis-je demander un créneau adapté à mon emploi ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:412",
    "text": "Puis-je importer un dossier déjà commencé ailleurs ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:325",
    "text": "Quand faut-il passer en société ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:396",
    "text": "Quand faut-il prendre rendez-vous ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:227",
    "text": "Quels documents dois-je préparer ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:220",
    "text": "Rassemblez les informations et documents depuis votre espace sécurisé.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:258",
    "text": "Recensez les associés",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:388",
    "text": "Recevez une synthèse prudente",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:232",
    "text": "Régime du dirigeant",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:291",
    "text": "Réponses non sensibles conservées localement",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:402",
    "text": "Résolution non garantie",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:338",
    "text": "Responsabilité floue",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:333",
    "text": "Réunissez les décisions, rôles, apports et documents des associés dans un espace commun.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:341",
    "text": "Rôles, apports, capital, décisions et calendrier.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:324",
    "text": "SASU, EURL ou autre orientation selon les priorités réelles.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:323",
    "text": "Seuil, recrutement, investissement, association ou crédibilité.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:272",
    "text": "Situation de la gérance examinée",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:384",
    "text": "Situez votre projet",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:300",
    "text": "Structurez le projet",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:377",
    "text": "Structurez le projet avec une formulation prudente sur l’ARE, l’ARCE et l’ACRE, dont les conditions dépendent de votre situation personnelle.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:262",
    "text": "Suivez la complétude de chaque associé et de la future société.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:221",
    "text": "Suivez la formalité",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:243",
    "text": "Suivez les demandes, documents et changements de statut dans votre espace.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:268",
    "text": "Tous les associés doivent-ils créer un compte ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:331",
    "text": "Transformez une idée commune en",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:288",
    "text": "un calendrier et des décisions explicites.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:397",
    "text": "Un échange devient utile lorsqu’une décision de calendrier, de rémunération ou de dispositif ne peut pas être clarifiée par le parcours indicatif.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:407",
    "text": "Un fil chronologique évite de perdre les versions et les explications déjà reçues.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:340",
    "text": "Un porteur de projet recense les associés, leurs rôles et les décisions à prendre.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:296",
    "text": "Une feuille de route distingue les décisions urgentes de celles qui peuvent attendre.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:383",
    "text": "Une page d’information ne remplace pas la vérification de votre dossier auprès des organismes compétents.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:281",
    "text": "Une SARL peut-elle avoir plusieurs gérants ?",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:275",
    "text": "Une seule pièce manquante peut ralentir l'ensemble du projet.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:318",
    "text": "Une structure adaptée dépend aussi des dépenses et du mode de rémunération.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:367",
    "text": "Valider les points décisifs",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:390",
    "text": "Validez la prochaine étape",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:222",
    "text": "Visualisez les validations, signatures, étapes et éventuelles corrections.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:354",
    "text": "votre activité et à votre trajectoire.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:311",
    "text": "Votre activité grandit. Faites évoluer",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:294",
    "text": "Votre projet peut être préparé avant la date réelle de création.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/content/landingPages.ts:309",
    "text": "Vous pouvez formuler une demande, mais les disponibilités et la durée de l'échange doivent être confirmées dans le calendrier réellement connecté.",
    "file": "app/content/landingPages.ts"
  },
  {
    "id": "app/data/legalForms.ts:451",
    "text": "activité\", \"Faibles charges initiales\", \"Gestion simple\", \"Activité complémentaire\"], watchouts: [\"Seuils et règles du régime\", \"Déduction des charges limitée\", \"Pas d",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:444",
    "text": "Adaptée à un actionnariat stable et connu.",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:425",
    "text": "Cadre juridique balisé",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:441",
    "text": "Cessions de parts encadrées",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:421",
    "text": "Comptabilité complète",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:420",
    "text": "Coût social du président rémunéré",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:443",
    "text": "Dépend de la détention du capital et de la situation du gérant.",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:417",
    "text": "Développement futur",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:436",
    "text": "Dirigeant assimilé salarié lorsqu'il est rémunéré.",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:418",
    "text": "Entrée d'investisseurs",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:438",
    "text": "Entreprise familiale",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:429",
    "text": "Évolution à organiser",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:431",
    "text": "Gérant associé relevant généralement du régime des indépendants.",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:430",
    "text": "Gérant associé unique, dans un cadre légal plus structuré.",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:426",
    "text": "Gérant opérationnel",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:446",
    "text": "Image différente d'une société",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:448",
    "text": "L'entrepreneur décide seul.",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:428",
    "text": "Moins de liberté statutaire",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:447",
    "text": "Options fiscales à examiner",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:433",
    "text": "Pacte d'associés à envisager",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:424",
    "text": "Passage naturel vers une SAS si de nouveaux associés entrent.",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:432",
    "text": "Peut devenir une SARL avec l'arrivée de nouveaux associés.",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:423",
    "text": "Président assimilé salarié lorsqu'il est rémunéré.",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:435",
    "text": "Président obligatoire, organes complémentaires possibles.",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:422",
    "text": "Président, avec une grande liberté statutaire.",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:427",
    "text": "Régime social du gérant à étudier",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:434",
    "text": "Règles de décision à cadrer",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:439",
    "text": "Répartition claire",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:440",
    "text": "Statut social du gérant variable",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:419",
    "text": "Statuts à rédiger avec attention",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:449",
    "text": "Travailleur indépendant.",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:437",
    "text": "Très adaptée aux changements de capital et à l'entrée d'investisseurs.",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:442",
    "text": "Un ou plusieurs gérants, avec des règles légales structurées.",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:450",
    "text": "Un passage en société peut être étudié lorsque le projet grandit.",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/legalForms.ts:445",
    "text": "une personne morale distincte.\", bestFor: [\"Projet solo\", \"Démarrage simple\", \"Gestion allégée\", \"Activité indépendante\"], watchouts: [\"Pas d",
    "file": "app/data/legalForms.ts"
  },
  {
    "id": "app/data/mock.ts:455",
    "text": "Attestation de dépôt du capital",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/data/mock.ts:454",
    "text": "Déclaration de non-condamnation",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/data/mock.ts:462",
    "text": "Dépôt de la formalité",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/data/mock.ts:459",
    "text": "Documents en vérification",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/data/mock.ts:467",
    "text": "Elle peut être examinée si elle indique le nom du titulaire, l'adresse complète et une date de moins de trois mois. Vous pouvez la transmettre depuis la rubrique Documents.",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/data/mock.ts:468",
    "text": "Google — création SASU",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/data/mock.ts:470",
    "text": "Google — créer société à deux",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/data/mock.ts:472",
    "text": "Google — prix création SASU",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/data/mock.ts:466",
    "text": "Je déposerai le nouveau document aujourd'hui. Une attestation délivrée en ligne par mon fournisseur peut-elle convenir ?",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/data/mock.ts:452",
    "text": "Justificatif de siège",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/data/mock.ts:458",
    "text": "La SASU a été retenue comme hypothèse de travail.",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/data/mock.ts:453",
    "text": "Le document transmis date de plus de trois mois.",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/data/mock.ts:456",
    "text": "Mandat de formalités",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/data/mock.ts:465",
    "text": "Nous avons vérifié les premières informations du projet. Un justificatif de siège récent reste nécessaire pour poursuivre le contrôle documentaire.",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/data/mock.ts:457",
    "text": "Orientation validée",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/data/mock.ts:471",
    "text": "Passage micro → société",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/data/mock.ts:461",
    "text": "Prévue après validation des informations et justificatifs.",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/data/mock.ts:464",
    "text": "Réception des documents finaux après traitement par les registres.",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/data/mock.ts:469",
    "text": "Rendez-vous réservé",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/data/mock.ts:463",
    "text": "Transmission après signature et règlement des frais applicables.",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/data/mock.ts:460",
    "text": "Trois pièces sont en cours de contrôle.",
    "file": "app/data/mock.ts"
  },
  {
    "id": "app/features/auth/auth-context.ts:473",
    "text": "useAuth doit être utilisé dans AuthProvider",
    "file": "app/features/auth/auth-context.ts"
  },
  {
    "id": "app/features/consent/ConsentBanner.tsx:477",
    "text": ">Les cookies nécessaires font fonctionner la plateforme. La mesure d’audience et la publicité restent désactivables, sans bloquer votre diagnostic.</span></p> </div> <button className=",
    "file": "app/features/consent/ConsentBanner.tsx"
  },
  {
    "id": "app/features/consent/ConsentBanner.tsx:476",
    "text": ">Mesure d’audience facultative. Le diagnostic reste accessible.</span><span className=",
    "file": "app/features/consent/ConsentBanner.tsx"
  },
  {
    "id": "app/features/consent/ConsentBanner.tsx:475",
    "text": ">Vos choix de confidentialité</p> <p className=",
    "file": "app/features/consent/ConsentBanner.tsx"
  },
  {
    "id": "app/features/consent/ConsentBanner.tsx:474",
    "text": "Préférences de confidentialité",
    "file": "app/features/consent/ConsentBanner.tsx"
  },
  {
    "id": "app/features/diagnostic/config.ts:508",
    "text": "Construction, réparation, fabrication, métiers manuels.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:509",
    "text": "Création & communication",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:510",
    "text": "Design, photo, vidéo, contenu et production.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:506",
    "text": "Développement, data, cybersécurité, SaaS.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:501",
    "text": "Entreprise individuelle",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:495",
    "text": "J'ai commencé les démarches et reçu une demande ou un rejet.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:486",
    "text": "J’ai reçu une demande, un rejet ou un message difficile à interpréter.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:487",
    "text": "J'ai une idée, mais tout n'est pas encore défini.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:500",
    "text": "J'exerce sous le régime micro.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:488",
    "text": "Je cherche le bon statut",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:519",
    "text": "Je peux différer une rémunération personnelle.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:502",
    "text": "Je possède ou dirige déjà une société.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:511",
    "text": "Je préciserai mon activité dans la suite.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:526",
    "text": "Je prépare activement le lancement.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:497",
    "text": "Je prépare une création ou une reprise.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:517",
    "text": "Je prévois de me rémunérer rapidement.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:520",
    "text": "Je souhaite comprendre les conséquences avant de décider.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:525",
    "text": "Je souhaite engager la création rapidement.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:523",
    "text": "Je souhaite réunir les informations, pièces et étapes dans le même parcours.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:481",
    "text": "Je suis déjà en micro-entreprise",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:492",
    "text": "Je suis en micro, EI ou indépendant et je veux évoluer.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:490",
    "text": "Je suis prêt à créer",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:483",
    "text": "Je suis salarié et je prépare une transition",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:528",
    "text": "Je veux clarifier les étapes avant de fixer une date.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:484",
    "text": "Je veux clarifier mon calendrier et les dispositifs à vérifier.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:489",
    "text": "Je veux comparer les structures selon mon projet.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:479",
    "text": "Je veux créer une société à plusieurs",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:478",
    "text": "Je veux créer une société seul",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:496",
    "text": "Je veux d'abord comprendre les possibilités.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:522",
    "text": "Je veux organiser mon dossier",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:527",
    "text": "Je veux structurer le projet à l'avance.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:482",
    "text": "Je veux vérifier si le passage en société est justifié.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:504",
    "text": "L'activité existe hors de France.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:499",
    "text": "L'activité n'a pas encore commencé.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:524",
    "text": "La disponibilité et le périmètre de l'intervenant devront être confirmés avant l'échange.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:480",
    "text": "Le projet implique au moins un autre associé.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:498",
    "text": "Ma situation ne correspond pas aux choix précédents.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:512",
    "text": "Maîtriser les coûts au démarrage",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:491",
    "text": "Mon activité est définie et je veux avancer.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:485",
    "text": "Mon dossier de création est bloqué",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:494",
    "text": "Mon dossier est bloqué",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:493",
    "text": "Nous créons à plusieurs",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:505",
    "text": "Numérique & technologie",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:516",
    "text": "Oui, dès le démarrage",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:518",
    "text": "Pas forcément au début",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:514",
    "text": "Recruter ou développer une équipe",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:515",
    "text": "Renforcer la crédibilité commerciale",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:503",
    "text": "Structure étrangère",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:513",
    "text": "Structurer et protéger le projet",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:521",
    "text": "Une synthèse et des comparaisons ciblées me suffisent pour l’instant.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/config.ts:507",
    "text": "Vente de produits, boutique ou activité en ligne.",
    "file": "app/features/diagnostic/config.ts"
  },
  {
    "id": "app/features/diagnostic/engine.ts:536",
    "text": "Arrivée future d'associés",
    "file": "app/features/diagnostic/engine.ts"
  },
  {
    "id": "app/features/diagnostic/engine.ts:546",
    "text": "Cette orientation est fournie à titre indicatif à partir de vos réponses. Certains éléments doivent être validés selon votre situation personnelle, votre activité et votre calendrier.",
    "file": "app/features/diagnostic/engine.ts"
  },
  {
    "id": "app/features/diagnostic/engine.ts:538",
    "text": "Compatibilité avec l’activité envisagée",
    "file": "app/features/diagnostic/engine.ts"
  },
  {
    "id": "app/features/diagnostic/engine.ts:534",
    "text": "Conditions d'entrée ou de sortie d'un associé",
    "file": "app/features/diagnostic/engine.ts"
  },
  {
    "id": "app/features/diagnostic/engine.ts:540",
    "text": "Date de création envisagée",
    "file": "app/features/diagnostic/engine.ts"
  },
  {
    "id": "app/features/diagnostic/engine.ts:539",
    "text": "Date de démarrage et disponibilité",
    "file": "app/features/diagnostic/engine.ts"
  },
  {
    "id": "app/features/diagnostic/engine.ts:532",
    "text": "Délai ou action indiqué par l’organisme",
    "file": "app/features/diagnostic/engine.ts"
  },
  {
    "id": "app/features/diagnostic/engine.ts:531",
    "text": "Dernière version des pièces concernées",
    "file": "app/features/diagnostic/engine.ts"
  },
  {
    "id": "app/features/diagnostic/engine.ts:543",
    "text": "Enregistrer ma synthèse",
    "file": "app/features/diagnostic/engine.ts"
  },
  {
    "id": "app/features/diagnostic/engine.ts:530",
    "text": "Message ou demande exacte reçue",
    "file": "app/features/diagnostic/engine.ts"
  },
  {
    "id": "app/features/diagnostic/engine.ts:537",
    "text": "Niveau réel de charges",
    "file": "app/features/diagnostic/engine.ts"
  },
  {
    "id": "app/features/diagnostic/engine.ts:535",
    "text": "Protection sociale recherchée",
    "file": "app/features/diagnostic/engine.ts"
  },
  {
    "id": "app/features/diagnostic/engine.ts:541",
    "text": "Rémunération prévue au démarrage",
    "file": "app/features/diagnostic/engine.ts"
  },
  {
    "id": "app/features/diagnostic/engine.ts:533",
    "text": "Répartition du capital et apports",
    "file": "app/features/diagnostic/engine.ts"
  },
  {
    "id": "app/features/diagnostic/engine.ts:542",
    "text": "Trésorerie disponible au lancement",
    "file": "app/features/diagnostic/engine.ts"
  },
  {
    "id": "app/features/diagnostic/engine.ts:529",
    "text": "Un dossier déjà engagé nécessite une reprise de l’historique plutôt qu’un nouveau parcours générique.",
    "file": "app/features/diagnostic/engine.ts"
  },
  {
    "id": "app/features/diagnostic/engine.ts:544",
    "text": "Votre projet doit principalement comparer une SAS et une SARL",
    "file": "app/features/diagnostic/engine.ts"
  },
  {
    "id": "app/features/diagnostic/engine.ts:545",
    "text": "Votre projet doit principalement comparer une SASU et une EURL",
    "file": "app/features/diagnostic/engine.ts"
  },
  {
    "id": "app/hooks/usePageMeta.ts:551",
    "text": ", \"name\", \"twitter:title\").content = `${title} — Orée`; upsertMeta(",
    "file": "app/hooks/usePageMeta.ts"
  },
  {
    "id": "app/hooks/usePageMeta.ts:550",
    "text": ", \"property\", \"og:title\").content = `${title} — Orée`; upsertMeta(",
    "file": "app/hooks/usePageMeta.ts"
  },
  {
    "id": "app/hooks/usePageMeta.ts:547",
    "text": ", key: string) { const existing = document.querySelector<HTMLMetaElement>(selector) ?? document.head.appendChild(document.createElement(",
    "file": "app/hooks/usePageMeta.ts"
  },
  {
    "id": "app/hooks/usePageMeta.ts:548",
    "text": ").content = description; const canonical = document.querySelector<HTMLLinkElement>('link[rel=",
    "file": "app/hooks/usePageMeta.ts"
  },
  {
    "id": "app/hooks/usePageMeta.ts:549",
    "text": "]') ?? document.head.appendChild(document.createElement(",
    "file": "app/hooks/usePageMeta.ts"
  },
  {
    "id": "app/main.tsx:552",
    "text": "] : undefined; const root = document.getElementById(",
    "file": "app/main.tsx"
  },
  {
    "id": "app/pages/app/AppointmentsPage.tsx:554",
    "text": "); await client.invalidateQueries({ queryKey: [",
    "file": "app/pages/app/AppointmentsPage.tsx"
  },
  {
    "id": "app/pages/app/AppointmentsPage.tsx:557",
    "text": ">{error instanceof Error ? error.message :",
    "file": "app/pages/app/AppointmentsPage.tsx"
  },
  {
    "id": "app/pages/app/AppointmentsPage.tsx:564",
    "text": ">{mutation.error instanceof Error ? mutation.error.message :",
    "file": "app/pages/app/AppointmentsPage.tsx"
  },
  {
    "id": "app/pages/app/AppointmentsPage.tsx:558",
    "text": ">Aucun rendez-vous enregistré.</p> : null}</div></Card></div><Card className=",
    "file": "app/pages/app/AppointmentsPage.tsx"
  },
  {
    "id": "app/pages/app/AppointmentsPage.tsx:556",
    "text": ">autour du projet.</span></>} description=",
    "file": "app/pages/app/AppointmentsPage.tsx"
  },
  {
    "id": "app/pages/app/AppointmentsPage.tsx:565",
    "text": ">Demande enregistrée ; elle attend une confirmation.</p> : null}<Button onClick={() => mutation.mutate()} disabled={mutation.isPending || !data?.project} className=",
    "file": "app/pages/app/AppointmentsPage.tsx"
  },
  {
    "id": "app/pages/app/AppointmentsPage.tsx:559",
    "text": ">Demander un créneau</h2><p className=",
    "file": "app/pages/app/AppointmentsPage.tsx"
  },
  {
    "id": "app/pages/app/AppointmentsPage.tsx:561",
    "text": ">Durée<select value={duration} onChange={(event) => setDuration(Number(event.target.value))} className=",
    "file": "app/pages/app/AppointmentsPage.tsx"
  },
  {
    "id": "app/pages/app/AppointmentsPage.tsx:560",
    "text": ">La demande reste « requested » jusqu’à confirmation par l’équipe.</p><div className=",
    "file": "app/pages/app/AppointmentsPage.tsx"
  },
  {
    "id": "app/pages/app/AppointmentsPage.tsx:563",
    "text": ">Téléphone</option><option value=",
    "file": "app/pages/app/AppointmentsPage.tsx"
  },
  {
    "id": "app/pages/app/AppointmentsPage.tsx:562",
    "text": ">Visioconférence</option><option value=",
    "file": "app/pages/app/AppointmentsPage.tsx"
  },
  {
    "id": "app/pages/app/AppointmentsPage.tsx:553",
    "text": "Demandez un créneau et retrouvez les rendez-vous liés au projet.",
    "file": "app/pages/app/AppointmentsPage.tsx"
  },
  {
    "id": "app/pages/app/AppointmentsPage.tsx:555",
    "text": "title={<>Vos échanges organisés <span className=",
    "file": "app/pages/app/AppointmentsPage.tsx"
  },
  {
    "id": "app/pages/app/AssociatesPage.tsx:567",
    "text": ">{(error ?? addFounder.error) instanceof Error ? (error ?? addFounder.error as Error).message :",
    "file": "app/pages/app/AssociatesPage.tsx"
  },
  {
    "id": "app/pages/app/AssociatesPage.tsx:576",
    "text": ">Ajoutez les personnes concernées pour préparer la structure du capital.</p></div>}</div></Card> <div className=",
    "file": "app/pages/app/AssociatesPage.tsx"
  },
  {
    "id": "app/pages/app/AssociatesPage.tsx:575",
    "text": ">Aucun fondateur renseigné</h4><p className=",
    "file": "app/pages/app/AssociatesPage.tsx"
  },
  {
    "id": "app/pages/app/AssociatesPage.tsx:568",
    "text": ">Cette action ajoute la personne au dossier ; elle ne crée pas automatiquement un compte utilisateur.</p><form onSubmit={(event) => { event.preventDefault(); addFounder.mutate(); }} className=",
    "file": "app/pages/app/AssociatesPage.tsx"
  },
  {
    "id": "app/pages/app/AssociatesPage.tsx:573",
    "text": ">Données du dossier</p><h3 className=",
    "file": "app/pages/app/AssociatesPage.tsx"
  },
  {
    "id": "app/pages/app/AssociatesPage.tsx:574",
    "text": ">Fondateurs déclarés</h3></div><span className=",
    "file": "app/pages/app/AssociatesPage.tsx"
  },
  {
    "id": "app/pages/app/AssociatesPage.tsx:570",
    "text": ">Participation envisagée (%)<input type=",
    "file": "app/pages/app/AssociatesPage.tsx"
  },
  {
    "id": "app/pages/app/AssociatesPage.tsx:569",
    "text": ">Prénom<input required value={form.firstName} onChange={(event) => setForm((current) => ({ ...current, firstName: event.target.value }))} className=",
    "file": "app/pages/app/AssociatesPage.tsx"
  },
  {
    "id": "app/pages/app/AssociatesPage.tsx:581",
    "text": ">Répartition renseignée</p><div className=",
    "file": "app/pages/app/AssociatesPage.tsx"
  },
  {
    "id": "app/pages/app/AssociatesPage.tsx:571",
    "text": ">Rôle envisagé<input value={form.role} onChange={(event) => setForm((current) => ({ ...current, role: event.target.value }))} className=",
    "file": "app/pages/app/AssociatesPage.tsx"
  },
  {
    "id": "app/pages/app/AssociatesPage.tsx:577",
    "text": ">Séparation des droits</h3><div className=",
    "file": "app/pages/app/AssociatesPage.tsx"
  },
  {
    "id": "app/pages/app/AssociatesPage.tsx:572",
    "text": "Ajouter au dossier",
    "file": "app/pages/app/AssociatesPage.tsx"
  },
  {
    "id": "app/pages/app/AssociatesPage.tsx:566",
    "text": "Gérez les fondateurs, les rôles et les participations du projet.",
    "file": "app/pages/app/AssociatesPage.tsx"
  },
  {
    "id": "app/pages/app/AssociatesPage.tsx:583",
    "text": "La répartition sera contrôlée avant la finalisation du dossier.",
    "file": "app/pages/app/AssociatesPage.tsx"
  },
  {
    "id": "app/pages/app/AssociatesPage.tsx:582",
    "text": "La somme dépasse 100 % et doit être corrigée avant validation.",
    "file": "app/pages/app/AssociatesPage.tsx"
  },
  {
    "id": "app/pages/app/AssociatesPage.tsx:579",
    "text": "Les comptes sont liés après invitation et acceptation.",
    "file": "app/pages/app/AssociatesPage.tsx"
  },
  {
    "id": "app/pages/app/AssociatesPage.tsx:580",
    "text": "Les validations restent réservées aux rôles autorisés.",
    "file": "app/pages/app/AssociatesPage.tsx"
  },
  {
    "id": "app/pages/app/AssociatesPage.tsx:578",
    "text": "Une fiche fondateur ne crée aucun accès.",
    "file": "app/pages/app/AssociatesPage.tsx"
  },
  {
    "id": "app/pages/app/DashboardPage.tsx:590",
    "text": "].includes(document.status)); const receivedDocuments = data.documents.filter((document) => ![",
    "file": "app/pages/app/DashboardPage.tsx"
  },
  {
    "id": "app/pages/app/DashboardPage.tsx:593",
    "text": "/>Écrire à l’équipe</ButtonLink></div></div><div className=",
    "file": "app/pages/app/DashboardPage.tsx"
  },
  {
    "id": "app/pages/app/DashboardPage.tsx:596",
    "text": ">{data.documents.slice(0, 6).map((document) => <div key={document.id} className=",
    "file": "app/pages/app/DashboardPage.tsx"
  },
  {
    "id": "app/pages/app/DashboardPage.tsx:598",
    "text": ">{document.category}</p></div><StatusBadge status={document.status} /></div>)}</div></Card> <div className=",
    "file": "app/pages/app/DashboardPage.tsx"
  },
  {
    "id": "app/pages/app/DashboardPage.tsx:597",
    "text": ">{document.label}</p><p className=",
    "file": "app/pages/app/DashboardPage.tsx"
  },
  {
    "id": "app/pages/app/DashboardPage.tsx:600",
    "text": ">Aucun événement enregistré.</p> : null}</div></Card>{nextAppointment ? <Card className=",
    "file": "app/pages/app/DashboardPage.tsx"
  },
  {
    "id": "app/pages/app/DashboardPage.tsx:587",
    "text": ">Aucun projet n’est encore associé à ce compte. Lancez un diagnostic avec la même adresse email pour créer une continuité sécurisée, ou contactez l’équipe si une demande existe déjà.</p><div className=",
    "file": "app/pages/app/DashboardPage.tsx"
  },
  {
    "id": "app/pages/app/DashboardPage.tsx:585",
    "text": ">Chargement de votre espace sécurisé…</Card>; if (error) return <Card className=",
    "file": "app/pages/app/DashboardPage.tsx"
  },
  {
    "id": "app/pages/app/DashboardPage.tsx:589",
    "text": ">Contacter l’équipe</ButtonLink></div></Card></div>; const project = data.project; const pendingDocuments = data.documents.filter((document) => [",
    "file": "app/pages/app/DashboardPage.tsx"
  },
  {
    "id": "app/pages/app/DashboardPage.tsx:588",
    "text": ">Démarrer un diagnostic</ButtonLink><ButtonLink to=",
    "file": "app/pages/app/DashboardPage.tsx"
  },
  {
    "id": "app/pages/app/DashboardPage.tsx:599",
    "text": ">Derniers événements</h2><ButtonLink to=",
    "file": "app/pages/app/DashboardPage.tsx"
  },
  {
    "id": "app/pages/app/DashboardPage.tsx:595",
    "text": ">État du dossier</h2></div><ButtonLink to=",
    "file": "app/pages/app/DashboardPage.tsx"
  },
  {
    "id": "app/pages/app/DashboardPage.tsx:601",
    "text": ">Prochain rendez-vous</p><h3 className=",
    "file": "app/pages/app/DashboardPage.tsx"
  },
  {
    "id": "app/pages/app/DashboardPage.tsx:602",
    "text": ">Statut : {nextAppointment.status}</p><ButtonLink to=",
    "file": "app/pages/app/DashboardPage.tsx"
  },
  {
    "id": "app/pages/app/DashboardPage.tsx:586",
    "text": ">Votre compte est prêt.</h1><p className=",
    "file": "app/pages/app/DashboardPage.tsx"
  },
  {
    "id": "app/pages/app/DashboardPage.tsx:591",
    "text": "Espace Supabase privé",
    "file": "app/pages/app/DashboardPage.tsx"
  },
  {
    "id": "app/pages/app/DashboardPage.tsx:594",
    "text": "Prochain rendez-vous",
    "file": "app/pages/app/DashboardPage.tsx"
  },
  {
    "id": "app/pages/app/DashboardPage.tsx:584",
    "text": "Suivez les actions, documents, messages et rendez-vous de votre projet.",
    "file": "app/pages/app/DashboardPage.tsx"
  },
  {
    "id": "app/pages/app/DashboardPage.tsx:592",
    "text": "Votre projet reste lisible, étape par étape.",
    "file": "app/pages/app/DashboardPage.tsx"
  },
  {
    "id": "app/pages/app/DocumentsPage.tsx:605",
    "text": "))); const received = (data?.documents ?? []).filter((document) => ![",
    "file": "app/pages/app/DocumentsPage.tsx"
  },
  {
    "id": "app/pages/app/DocumentsPage.tsx:613",
    "text": "}</p></div><StatusBadge status={document.status} /></button>)}{!isLoading && filtered.length === 0 ? <p className=",
    "file": "app/pages/app/DocumentsPage.tsx"
  },
  {
    "id": "app/pages/app/DocumentsPage.tsx:616",
    "text": "/>Télécharger</Button></div></> : <p className=",
    "file": "app/pages/app/DocumentsPage.tsx"
  },
  {
    "id": "app/pages/app/DocumentsPage.tsx:612",
    "text": ">{document.category}{document.filename ? ` · ${document.filename}` :",
    "file": "app/pages/app/DocumentsPage.tsx"
  },
  {
    "id": "app/pages/app/DocumentsPage.tsx:609",
    "text": ">{upload.error instanceof Error ? upload.error.message :",
    "file": "app/pages/app/DocumentsPage.tsx"
  },
  {
    "id": "app/pages/app/DocumentsPage.tsx:614",
    "text": ">Élément sélectionné</p><h2 className=",
    "file": "app/pages/app/DocumentsPage.tsx"
  },
  {
    "id": "app/pages/app/DocumentsPage.tsx:610",
    "text": ">La nouvelle version a été enregistrée et rattachée au projet.</Card> : null}<div className=",
    "file": "app/pages/app/DocumentsPage.tsx"
  },
  {
    "id": "app/pages/app/DocumentsPage.tsx:615",
    "text": ">Retour de contrôle</p><p className=",
    "file": "app/pages/app/DocumentsPage.tsx"
  },
  {
    "id": "app/pages/app/DocumentsPage.tsx:617",
    "text": ">Sélectionnez un document.</p>}</Card><Card className=",
    "file": "app/pages/app/DocumentsPage.tsx"
  },
  {
    "id": "app/pages/app/DocumentsPage.tsx:618",
    "text": ">Traçabilité</h3></div><p className=",
    "file": "app/pages/app/DocumentsPage.tsx"
  },
  {
    "id": "app/pages/app/DocumentsPage.tsx:604",
    "text": "${document.label} ${document.category}",
    "file": "app/pages/app/DocumentsPage.tsx"
  },
  {
    "id": "app/pages/app/DocumentsPage.tsx:607",
    "text": "Centre documentaire privé",
    "file": "app/pages/app/DocumentsPage.tsx"
  },
  {
    "id": "app/pages/app/DocumentsPage.tsx:611",
    "text": "flex w-full items-center gap-4 p-5 text-left transition ${selected?.id === document.id ? \"bg-[var(--mint-soft)]/55\" : \"hover:bg-[var(--paper)]\"}",
    "file": "app/pages/app/DocumentsPage.tsx"
  },
  {
    "id": "app/pages/app/DocumentsPage.tsx:608",
    "text": "Les fichiers connectés sont conservés dans un bucket privé. Le téléchargement utilise un lien signé de courte durée.",
    "file": "app/pages/app/DocumentsPage.tsx"
  },
  {
    "id": "app/pages/app/DocumentsPage.tsx:606",
    "text": "Sélectionnez une exigence documentaire.",
    "file": "app/pages/app/DocumentsPage.tsx"
  },
  {
    "id": "app/pages/app/DocumentsPage.tsx:603",
    "text": "Téléversez et suivez les versions conservées dans le stockage privé du projet.",
    "file": "app/pages/app/DocumentsPage.tsx"
  },
  {
    "id": "app/pages/app/FormalitiesPage.tsx:630",
    "text": "] ?? 0; const blockingDocuments = (data?.documents ?? []).filter((document) => [",
    "file": "app/pages/app/FormalitiesPage.tsx"
  },
  {
    "id": "app/pages/app/FormalitiesPage.tsx:632",
    "text": "].includes(document.status)); const activeTasks = (data?.tasks ?? []).filter((task) => task.status !==",
    "file": "app/pages/app/FormalitiesPage.tsx"
  },
  {
    "id": "app/pages/app/FormalitiesPage.tsx:631",
    "text": "].includes(document.status)); const pendingDocuments = (data?.documents ?? []).filter((document) => ![",
    "file": "app/pages/app/FormalitiesPage.tsx"
  },
  {
    "id": "app/pages/app/FormalitiesPage.tsx:634",
    "text": ">l’état réel du dossier.</span></>} description=",
    "file": "app/pages/app/FormalitiesPage.tsx"
  },
  {
    "id": "app/pages/app/FormalitiesPage.tsx:635",
    "text": "${blockingDocuments.length} pièce${blockingDocuments.length > 1 ? \"s nécessitent\" : \" nécessite\"} une correction avant de poursuivre.",
    "file": "app/pages/app/FormalitiesPage.tsx"
  },
  {
    "id": "app/pages/app/FormalitiesPage.tsx:636",
    "text": "${pendingDocuments.length} pièce${pendingDocuments.length > 1 ? \"s restent\" : \" reste\"} à déposer ou à faire valider.",
    "file": "app/pages/app/FormalitiesPage.tsx"
  },
  {
    "id": "app/pages/app/FormalitiesPage.tsx:624",
    "text": "Capital & justificatifs",
    "file": "app/pages/app/FormalitiesPage.tsx"
  },
  {
    "id": "app/pages/app/FormalitiesPage.tsx:622",
    "text": "Collecte puis vérification des pièces nécessaires.",
    "file": "app/pages/app/FormalitiesPage.tsx"
  },
  {
    "id": "app/pages/app/FormalitiesPage.tsx:621",
    "text": "Contrôle documentaire",
    "file": "app/pages/app/FormalitiesPage.tsx"
  },
  {
    "id": "app/pages/app/FormalitiesPage.tsx:620",
    "text": "Dénomination, activité, calendrier, forme et parties prenantes.",
    "file": "app/pages/app/FormalitiesPage.tsx"
  },
  {
    "id": "app/pages/app/FormalitiesPage.tsx:619",
    "text": "Informations société",
    "file": "app/pages/app/FormalitiesPage.tsx"
  },
  {
    "id": "app/pages/app/FormalitiesPage.tsx:623",
    "text": "Préparation selon le périmètre réel du prestataire et la structure retenue.",
    "file": "app/pages/app/FormalitiesPage.tsx"
  },
  {
    "id": "app/pages/app/FormalitiesPage.tsx:626",
    "text": "Signature des éléments définitifs après validation du dossier.",
    "file": "app/pages/app/FormalitiesPage.tsx"
  },
  {
    "id": "app/pages/app/FormalitiesPage.tsx:629",
    "text": "Suivez les étapes de préparation, validation, signature et transmission de la formalité.",
    "file": "app/pages/app/FormalitiesPage.tsx"
  },
  {
    "id": "app/pages/app/FormalitiesPage.tsx:633",
    "text": "title={<>Une progression fondée sur <span className=",
    "file": "app/pages/app/FormalitiesPage.tsx"
  },
  {
    "id": "app/pages/app/FormalitiesPage.tsx:637",
    "text": "Toutes les pièces demandées sont validées.",
    "file": "app/pages/app/FormalitiesPage.tsx"
  },
  {
    "id": "app/pages/app/FormalitiesPage.tsx:625",
    "text": "Traitement des éléments relatifs au capital et au siège.",
    "file": "app/pages/app/FormalitiesPage.tsx"
  },
  {
    "id": "app/pages/app/FormalitiesPage.tsx:627",
    "text": "Transmission de la formalité",
    "file": "app/pages/app/FormalitiesPage.tsx"
  },
  {
    "id": "app/pages/app/FormalitiesPage.tsx:628",
    "text": "Transmission uniquement lorsque le dossier est complet et autorisé.",
    "file": "app/pages/app/FormalitiesPage.tsx"
  },
  {
    "id": "app/pages/app/MessagesPage.tsx:639",
    "text": "] })); }, [client, data?.messages]); const mutation = useMutation({ mutationFn: () => data?.conversationId ? portalRepository.sendMessage(data.conversationId, body) : Promise.reject(new Error(",
    "file": "app/pages/app/MessagesPage.tsx"
  },
  {
    "id": "app/pages/app/MessagesPage.tsx:643",
    "text": "}><p className=\"whitespace-pre-wrap\">{message.body}</p><p className={",
    "file": "app/pages/app/MessagesPage.tsx"
  },
  {
    "id": "app/pages/app/MessagesPage.tsx:646",
    "text": "/>Les pièces doivent être transmises depuis Documents.</div><div className=",
    "file": "app/pages/app/MessagesPage.tsx"
  },
  {
    "id": "app/pages/app/MessagesPage.tsx:642",
    "text": ">Chargement des messages…</p> : null}{data?.messages.map((message) => <div key={message.id} className={`flex ${message.isOwn ?",
    "file": "app/pages/app/MessagesPage.tsx"
  },
  {
    "id": "app/pages/app/MessagesPage.tsx:645",
    "text": ">Écrivez votre première question. N’envoyez pas de document sensible ici : utilisez le centre documentaire privé.</p></div></div> : null}</div><div className=",
    "file": "app/pages/app/MessagesPage.tsx"
  },
  {
    "id": "app/pages/app/MessagesPage.tsx:641",
    "text": ">Équipe Orée</p><p className=",
    "file": "app/pages/app/MessagesPage.tsx"
  },
  {
    "id": "app/pages/app/MessagesPage.tsx:644",
    "text": ">La conversation est prête.</p><p className=",
    "file": "app/pages/app/MessagesPage.tsx"
  },
  {
    "id": "app/pages/app/MessagesPage.tsx:638",
    "text": "Échangez avec l’équipe et conservez le contexte du dossier.",
    "file": "app/pages/app/MessagesPage.tsx"
  },
  {
    "id": "app/pages/app/MessagesPage.tsx:640",
    "text": "title={<>Des échanges conservés <span className=",
    "file": "app/pages/app/MessagesPage.tsx"
  },
  {
    "id": "app/pages/app/NotificationsPage.tsx:649",
    "text": ", icon: FileText })) ?? []), ...(data?.messages.filter((item) => !item.isOwn && !item.read).map((item) => ({ id: `message-${item.id}`, title:",
    "file": "app/pages/app/NotificationsPage.tsx"
  },
  {
    "id": "app/pages/app/NotificationsPage.tsx:648",
    "text": "].includes(item.status)).map((item) => ({ id: `document-${item.id}`, title: item.label, description: item.comment ||",
    "file": "app/pages/app/NotificationsPage.tsx"
  },
  {
    "id": "app/pages/app/NotificationsPage.tsx:654",
    "text": ">Aucune action signalée.</p><p className=",
    "file": "app/pages/app/NotificationsPage.tsx"
  },
  {
    "id": "app/pages/app/NotificationsPage.tsx:653",
    "text": ">reliés à leur action.</span></>} description=",
    "file": "app/pages/app/NotificationsPage.tsx"
  },
  {
    "id": "app/pages/app/NotificationsPage.tsx:651",
    "text": "Demande de rendez-vous en attente",
    "file": "app/pages/app/NotificationsPage.tsx"
  },
  {
    "id": "app/pages/app/NotificationsPage.tsx:650",
    "text": "Rendez-vous confirmé",
    "file": "app/pages/app/NotificationsPage.tsx"
  },
  {
    "id": "app/pages/app/NotificationsPage.tsx:647",
    "text": "Retrouvez les éléments du projet qui nécessitent votre attention.",
    "file": "app/pages/app/NotificationsPage.tsx"
  },
  {
    "id": "app/pages/app/NotificationsPage.tsx:652",
    "text": "title={<>Les événements importants, <span className=",
    "file": "app/pages/app/NotificationsPage.tsx"
  },
  {
    "id": "app/pages/app/OrientationPage.tsx:666",
    "text": ": \"Aucune version liée\"}</p></div></div><div className=\"mt-7 space-y-4\">{reasons.length ? reasons.map((item, index) => <div key={",
    "file": "app/pages/app/OrientationPage.tsx"
  },
  {
    "id": "app/pages/app/OrientationPage.tsx:665",
    "text": ">{orientation?.definitionVersion ? `Questions ${orientation.definitionVersion} · règles ${orientation.ruleVersion ??",
    "file": "app/pages/app/OrientationPage.tsx"
  },
  {
    "id": "app/pages/app/OrientationPage.tsx:668",
    "text": ">À valider</h3></div>{validationPoints.length ? <ul className=",
    "file": "app/pages/app/OrientationPage.tsx"
  },
  {
    "id": "app/pages/app/OrientationPage.tsx:669",
    "text": ">Aucun point spécifique n’est enregistré. Une validation humaine reste recommandée avant toute décision.</p>}<ButtonLink to=",
    "file": "app/pages/app/OrientationPage.tsx"
  },
  {
    "id": "app/pages/app/OrientationPage.tsx:663",
    "text": ">Aucun résultat de diagnostic n’est encore lié à ce projet.</div>}</Card> <div className=",
    "file": "app/pages/app/OrientationPage.tsx"
  },
  {
    "id": "app/pages/app/OrientationPage.tsx:664",
    "text": ">Éléments du diagnostic</h3><p className=",
    "file": "app/pages/app/OrientationPage.tsx"
  },
  {
    "id": "app/pages/app/OrientationPage.tsx:667",
    "text": ">Les raisons détaillées apparaîtront ici lorsqu’un diagnostic terminé sera rattaché au projet.</p>}</div></Card> <div className=",
    "file": "app/pages/app/OrientationPage.tsx"
  },
  {
    "id": "app/pages/app/OrientationPage.tsx:662",
    "text": ">Régime du dirigeant</p><p className=",
    "file": "app/pages/app/OrientationPage.tsx"
  },
  {
    "id": "app/pages/app/OrientationPage.tsx:660",
    "text": "${forms.length} structure${forms.length > 1 ? \"s\" : \"\"} à approfondir",
    "file": "app/pages/app/OrientationPage.tsx"
  },
  {
    "id": "app/pages/app/OrientationPage.tsx:661",
    "text": "Aucune structure enregistrée",
    "file": "app/pages/app/OrientationPage.tsx"
  },
  {
    "id": "app/pages/app/OrientationPage.tsx:657",
    "text": "Cette orientation provient du dossier et reste une hypothèse à confirmer avec les paramètres sociaux, fiscaux, juridiques et personnels pertinents.",
    "file": "app/pages/app/OrientationPage.tsx"
  },
  {
    "id": "app/pages/app/OrientationPage.tsx:656",
    "text": "Comparez les structures envisagées et les points restant à valider.",
    "file": "app/pages/app/OrientationPage.tsx"
  },
  {
    "id": "app/pages/app/OrientationPage.tsx:658",
    "text": "Complétez le diagnostic pour faire apparaître des structures à comparer et les points qui devront être confirmés.",
    "file": "app/pages/app/OrientationPage.tsx"
  },
  {
    "id": "app/pages/app/OrientationPage.tsx:659",
    "text": "Faire le diagnostic",
    "file": "app/pages/app/OrientationPage.tsx"
  },
  {
    "id": "app/pages/app/OrientationPage.tsx:655",
    "text": "Orientation du projet",
    "file": "app/pages/app/OrientationPage.tsx"
  },
  {
    "id": "app/pages/app/ProjectPage.tsx:676",
    "text": "/>Projet enregistré dans votre espace.</Card> : null}<div className=",
    "file": "app/pages/app/ProjectPage.tsx"
  },
  {
    "id": "app/pages/app/ProjectPage.tsx:675",
    "text": ">{(error ?? mutation.error) instanceof Error ? (error ?? mutation.error as Error).message :",
    "file": "app/pages/app/ProjectPage.tsx"
  },
  {
    "id": "app/pages/app/ProjectPage.tsx:678",
    "text": ">À confirmer</option>{[",
    "file": "app/pages/app/ProjectPage.tsx"
  },
  {
    "id": "app/pages/app/ProjectPage.tsx:671",
    "text": ">Aucun projet associé</h1><p className=",
    "file": "app/pages/app/ProjectPage.tsx"
  },
  {
    "id": "app/pages/app/ProjectPage.tsx:679",
    "text": ">Description de l’activité<textarea rows={5} value={form.activity} onChange={(event) => setForm((current) => ({ ...current, activity: event.target.value }))} className=",
    "file": "app/pages/app/ProjectPage.tsx"
  },
  {
    "id": "app/pages/app/ProjectPage.tsx:680",
    "text": ">État opérationnel</p><p className=",
    "file": "app/pages/app/ProjectPage.tsx"
  },
  {
    "id": "app/pages/app/ProjectPage.tsx:677",
    "text": ">Forme envisagée<select value={form.legalForm} onChange={(event) => setForm((current) => ({ ...current, legalForm: event.target.value }))} className=",
    "file": "app/pages/app/ProjectPage.tsx"
  },
  {
    "id": "app/pages/app/ProjectPage.tsx:674",
    "text": ">informations de référence.</span></>} description=",
    "file": "app/pages/app/ProjectPage.tsx"
  },
  {
    "id": "app/pages/app/ProjectPage.tsx:673",
    "text": ">Lancer le diagnostic</ButtonLink></Card>; return <div className=",
    "file": "app/pages/app/ProjectPage.tsx"
  },
  {
    "id": "app/pages/app/ProjectPage.tsx:672",
    "text": ">Le projet apparaît après la continuité sécurisée d’un diagnostic ou une création autorisée.</p><ButtonLink to=",
    "file": "app/pages/app/ProjectPage.tsx"
  },
  {
    "id": "app/pages/app/ProjectPage.tsx:681",
    "text": ">Séparation des responsabilités</h3><p className=",
    "file": "app/pages/app/ProjectPage.tsx"
  },
  {
    "id": "app/pages/app/ProjectPage.tsx:670",
    "text": "Mettez à jour les informations descriptives autorisées de votre projet.",
    "file": "app/pages/app/ProjectPage.tsx"
  },
  {
    "id": "app/pages/app/SettingsPage.tsx:683",
    "text": "? action(profile) : action); } const save = useMutation({ mutationFn: () => portalRepository.saveProfile(profile), onSuccess: async () => client.invalidateQueries({ queryKey: [",
    "file": "app/pages/app/SettingsPage.tsx"
  },
  {
    "id": "app/pages/app/SettingsPage.tsx:686",
    "text": "/>Préférences enregistrées.</Card> : null} <div className=",
    "file": "app/pages/app/SettingsPage.tsx"
  },
  {
    "id": "app/pages/app/SettingsPage.tsx:685",
    "text": ">{(error ?? save.error) instanceof Error ? (error ?? save.error as Error).message :",
    "file": "app/pages/app/SettingsPage.tsx"
  },
  {
    "id": "app/pages/app/SettingsPage.tsx:689",
    "text": ">Contraintes de disponibilité<textarea rows={3} value={profile.availabilityNote} onChange={(event) => setProfile((current) => ({ ...current, availabilityNote: event.target.value }))} className=",
    "file": "app/pages/app/SettingsPage.tsx"
  },
  {
    "id": "app/pages/app/SettingsPage.tsx:695",
    "text": ">Exporter les données visibles</p><p className=",
    "file": "app/pages/app/SettingsPage.tsx"
  },
  {
    "id": "app/pages/app/SettingsPage.tsx:697",
    "text": ">La demande sera examinée selon les obligations de conservation.</p></div></button>{dataRequest.isSuccess ? <p className=",
    "file": "app/pages/app/SettingsPage.tsx"
  },
  {
    "id": "app/pages/app/SettingsPage.tsx:691",
    "text": ">La préférence marketing ne vaut consentement que si le cadre juridique et le canal réel le permettent.</p> </Card> <Card className=",
    "file": "app/pages/app/SettingsPage.tsx"
  },
  {
    "id": "app/pages/app/SettingsPage.tsx:693",
    "text": ">Les sessions, mots de passe et liens de connexion sont gérés par Supabase Auth. Les rôles internes ne sont jamais modifiables ici.</p></Card> <Card className=",
    "file": "app/pages/app/SettingsPage.tsx"
  },
  {
    "id": "app/pages/app/SettingsPage.tsx:690",
    "text": ">Préférences par catégorie</p></div></div> <div className=",
    "file": "app/pages/app/SettingsPage.tsx"
  },
  {
    "id": "app/pages/app/SettingsPage.tsx:687",
    "text": ">Prénom<input value={profile.firstName} onChange={(event) => setProfile((current) => ({ ...current, firstName: event.target.value }))} className=",
    "file": "app/pages/app/SettingsPage.tsx"
  },
  {
    "id": "app/pages/app/SettingsPage.tsx:696",
    "text": ">Prépare un fichier local et enregistre une demande d’export.</p></div></button><button onClick={() => dataRequest.mutate(",
    "file": "app/pages/app/SettingsPage.tsx"
  },
  {
    "id": "app/pages/app/SettingsPage.tsx:692",
    "text": ">Sécurité du compte</h2><p className=",
    "file": "app/pages/app/SettingsPage.tsx"
  },
  {
    "id": "app/pages/app/SettingsPage.tsx:688",
    "text": ">Téléphone<input value={profile.phone} onChange={(event) => setProfile((current) => ({ ...current, phone: event.target.value }))} className=",
    "file": "app/pages/app/SettingsPage.tsx"
  },
  {
    "id": "app/pages/app/SettingsPage.tsx:694",
    "text": ">Vos données</h2><div className=",
    "file": "app/pages/app/SettingsPage.tsx"
  },
  {
    "id": "app/pages/app/SettingsPage.tsx:682",
    "text": "Gérez votre profil, notifications, sécurité et demandes relatives aux données.",
    "file": "app/pages/app/SettingsPage.tsx"
  },
  {
    "id": "app/pages/app/SettingsPage.tsx:684",
    "text": "title={<>Maîtrisez les paramètres de <span className=",
    "file": "app/pages/app/SettingsPage.tsx"
  },
  {
    "id": "app/pages/app/TrackingPage.tsx:701",
    "text": ">Aucun événement dans cette catégorie.</p> : null}</div></Card><div className=",
    "file": "app/pages/app/TrackingPage.tsx"
  },
  {
    "id": "app/pages/app/TrackingPage.tsx:703",
    "text": ">La messagerie conserve votre demande dans le contexte du projet.</p><ButtonLink to=",
    "file": "app/pages/app/TrackingPage.tsx"
  },
  {
    "id": "app/pages/app/TrackingPage.tsx:702",
    "text": ">Une question sur une étape ?</h3><p className=",
    "file": "app/pages/app/TrackingPage.tsx"
  },
  {
    "id": "app/pages/app/TrackingPage.tsx:699",
    "text": "Chronologie du projet",
    "file": "app/pages/app/TrackingPage.tsx"
  },
  {
    "id": "app/pages/app/TrackingPage.tsx:698",
    "text": "Consultez les événements serveur et les prochaines étapes du projet.",
    "file": "app/pages/app/TrackingPage.tsx"
  },
  {
    "id": "app/pages/app/TrackingPage.tsx:700",
    "text": "Les changements opérationnels et actions documentaires alimentent cette chronologie sans promettre les délais des registres externes.",
    "file": "app/pages/app/TrackingPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthCallbackPage.tsx:704",
    "text": ">Connexion sécurisée en cours…</p><p className=",
    "file": "app/pages/auth/AuthCallbackPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthCallbackPage.tsx:705",
    "text": ">Nous vérifions votre session avant d'ouvrir l'espace projet.</p><div className=",
    "file": "app/pages/auth/AuthCallbackPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:711",
    "text": "); } } catch (cause) { setError(cause instanceof Error ? cause.message :",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:722",
    "text": ")}>Revenir à la connexion</Button></div> : forgot ? <> <p className=",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:725",
    "text": "/> : null}Envoyer le lien sécurisé</Button></form><p className=",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:717",
    "text": "><span>Authentification sécurisée</span><span>Accès limités selon les rôles</span></div> </div> <div className=",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:718",
    "text": ">Espace sécurisé</span></div> <div className=",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:730",
    "text": ">Les rôles équipe sont gérés côté serveur. Une inscription publique ne peut jamais attribuer un rôle administrateur.</p></div> <p className=",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:723",
    "text": ">Récupération du compte</p><h1 className=",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:724",
    "text": ">Réinitialisez votre mot de passe.</h1><p className=",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:726",
    "text": ">Un lien de connexion à usage limité a été envoyé à <strong>{email}</strong>.</p><Button className=",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:710",
    "text": "Connectez-vous à votre espace projet Orée.",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:728",
    "text": "Connexion sécurisée avec Supabase Auth.",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:707",
    "text": "Créez votre espace projet Orée.",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:706",
    "text": "Définir un nouveau mot de passe",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:709",
    "text": "Définissez un nouveau mot de passe pour votre compte.",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:720",
    "text": "Demande enregistrée",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:708",
    "text": "Demandez un lien sécurisé pour réinitialiser votre mot de passe.",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:712",
    "text": "La demande n'a pas pu être enregistrée.",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:713",
    "text": "Le mot de passe doit contenir au moins huit caractères.",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:714",
    "text": "Le mot de passe n'a pas pu être modifié.",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:729",
    "text": "Mode démonstration actif : utilisez n'importe quel email et mot de passe.",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:719",
    "text": "Mot de passe modifié",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:715",
    "text": "Projet synchronisé",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:727",
    "text": "Retrouvez votre projet.",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:721",
    "text": "Si un compte correspond à ${email}, un lien sécurisé lui sera envoyé.",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/auth/AuthPage.tsx:716",
    "text": "Suivi contextualisé",
    "file": "app/pages/auth/AuthPage.tsx"
  },
  {
    "id": "app/pages/legal/CgvPage.tsx:735",
    "text": "Conditions Générales de Vente",
    "file": "app/pages/legal/CgvPage.tsx"
  },
  {
    "id": "app/pages/legal/CgvPage.tsx:736",
    "text": "Conditions Générales de Vente des services Orée Entreprises.",
    "file": "app/pages/legal/CgvPage.tsx"
  },
  {
    "id": "app/pages/legal/CgvPage.tsx:734",
    "text": "Conformément à la réglementation, et compte tenu de la nature du service (personnalisé et exécuté immédiatement avec l'accord du client), le droit de rétractation peut ne pas s'appliquer une fois la prestation commencée.",
    "file": "app/pages/legal/CgvPage.tsx"
  },
  {
    "id": "app/pages/legal/CgvPage.tsx:731",
    "text": "Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre Orée Entreprises et toute personne souhaitant bénéficier de ses services d'accompagnement à la création d'entreprise.",
    "file": "app/pages/legal/CgvPage.tsx"
  },
  {
    "id": "app/pages/legal/CgvPage.tsx:733",
    "text": "Les prix sont indiqués en euros toutes taxes comprises (TTC). Ils comprennent nos honoraires ainsi que les frais de greffe et d'annonce légale, qui sont reversés à des tiers.",
    "file": "app/pages/legal/CgvPage.tsx"
  },
  {
    "id": "app/pages/legal/CgvPage.tsx:732",
    "text": "Orée Entreprises propose des services d'assistance administrative pour la constitution de dossiers d'immatriculation. Les formalités d'enregistrement relèvent des organismes compétents.",
    "file": "app/pages/legal/CgvPage.tsx"
  },
  {
    "id": "app/pages/legal/LegalPage.tsx:738",
    "text": "2. Données collectées",
    "file": "app/pages/legal/LegalPage.tsx"
  },
  {
    "id": "app/pages/legal/LegalPage.tsx:740",
    "text": "3. Finalités et bases légales",
    "file": "app/pages/legal/LegalPage.tsx"
  },
  {
    "id": "app/pages/legal/LegalPage.tsx:737",
    "text": "À compléter avec l'identité juridique, l'adresse et les coordonnées réelles du responsable du traitement avant la mise en production.",
    "file": "app/pages/legal/LegalPage.tsx"
  },
  {
    "id": "app/pages/legal/LegalPage.tsx:742",
    "text": "accès, la rectification, l",
    "file": "app/pages/legal/LegalPage.tsx"
  },
  {
    "id": "app/pages/legal/LegalPage.tsx:746",
    "text": "accompagnement à la création d",
    "file": "app/pages/legal/LegalPage.tsx"
  },
  {
    "id": "app/pages/legal/LegalPage.tsx:745",
    "text": "Hébergeur : [NOM_HEBERGEUR] Adresse : [ADRESSE_HEBERGEUR] Téléphone : [TELEPHONE_HEBERGEUR] Infrastructure technique : Frontend via Cloudflare Pages, base de données et authentification via Supabase (Région Europe).",
    "file": "app/pages/legal/LegalPage.tsx"
  },
  {
    "id": "app/pages/legal/LegalPage.tsx:739",
    "text": "identification, de contact, de situation professionnelle, de projet, de rendez-vous, des messages et des documents nécessaires au service. Les données envoyées à des outils statistiques doivent être limitées et ne jamais contenir de pièce d",
    "file": "app/pages/legal/LegalPage.tsx"
  },
  {
    "id": "app/pages/legal/LegalPage.tsx:751",
    "text": "Informations sur le traitement des données personnelles par Orée.",
    "file": "app/pages/legal/LegalPage.tsx"
  },
  {
    "id": "app/pages/legal/LegalPage.tsx:741",
    "text": "Les durées doivent être définies par finalité : diagnostic abandonné, prospect, client actif, dossier clôturé, obligations légales et demande de suppression. Elles ne doivent pas être codées comme une conservation illimitée.",
    "file": "app/pages/legal/LegalPage.tsx"
  },
  {
    "id": "app/pages/legal/LegalPage.tsx:749",
    "text": "Les textes, interfaces, marques, illustrations et éléments logiciels appartiennent à leurs titulaires respectifs. La marque Orée est utilisée comme marque de démonstration et doit être remplacée ou validée.",
    "file": "app/pages/legal/LegalPage.tsx"
  },
  {
    "id": "app/pages/legal/LegalPage.tsx:744",
    "text": "Les traceurs non nécessaires restent désactivés avant le choix de l'utilisateur. Le consentement Google et les éventuels pixels publicitaires doivent être pilotés par une interface de consentement conforme.",
    "file": "app/pages/legal/LegalPage.tsx"
  },
  {
    "id": "app/pages/legal/LegalPage.tsx:752",
    "text": "Mentions légales de la plateforme Orée.",
    "file": "app/pages/legal/LegalPage.tsx"
  },
  {
    "id": "app/pages/legal/LegalPage.tsx:743",
    "text": "opposition ou la portabilité de vos données. Une page de paramètres et une procédure interne sont prévues pour traiter ces demandes.\"], [\"7. Cookies et mesure d",
    "file": "app/pages/legal/LegalPage.tsx"
  },
  {
    "id": "app/pages/legal/LegalPage.tsx:748",
    "text": "Propriété intellectuelle",
    "file": "app/pages/legal/LegalPage.tsx"
  },
  {
    "id": "app/pages/legal/LegalPage.tsx:750",
    "text": "Service client : [TELEPHONE_CONTACT] - [EMAIL_CONTACT] Responsable de publication : [NOM_DIRECTEUR_PUBLICATION]",
    "file": "app/pages/legal/LegalPage.tsx"
  },
  {
    "id": "app/pages/legal/LegalPage.tsx:747",
    "text": "un projet. Elle ne doit pas se présenter comme fournissant un conseil juridique personnalisé lorsqu",
    "file": "app/pages/legal/LegalPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsAnalyticsPage.tsx:754",
    "text": ">Acquisition et résultats</h1><p className=",
    "file": "app/pages/ops/OpsAnalyticsPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsAnalyticsPage.tsx:755",
    "text": ">Cette vue relie l’origine des demandes aux statuts qualifié et gagné. Aucun email, téléphone ou contenu de dossier n’est envoyé aux plateformes publicitaires.</p></section>{error ? <Card className=",
    "file": "app/pages/ops/OpsAnalyticsPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsAnalyticsPage.tsx:753",
    "text": "Analysez les sources, campagnes et résultats commerciaux sans données personnelles publicitaires.",
    "file": "app/pages/ops/OpsAnalyticsPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsAuditPage.tsx:758",
    "text": ": `${data.length} événement(s) accessible(s)`}</p></div><div className=",
    "file": "app/pages/ops/OpsAuditPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsAuditPage.tsx:757",
    "text": ">Affectations, qualifications, contrôles documentaires, rendez-vous et changements de rôle sont consignés côté serveur.</p></section>{error ? <Card className=",
    "file": "app/pages/ops/OpsAuditPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsAuditPage.tsx:756",
    "text": "Observez les actions sensibles consignées par la plateforme.",
    "file": "app/pages/ops/OpsAuditPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsDashboardPage.tsx:762",
    "text": "/>Répondre aux clients</ButtonLink><ButtonLink to=",
    "file": "app/pages/ops/OpsDashboardPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsDashboardPage.tsx:766",
    "text": ">De la demande au projet</h3><div className=",
    "file": "app/pages/ops/OpsDashboardPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsDashboardPage.tsx:764",
    "text": ">Demandes récentes</h3></div><ButtonLink to=",
    "file": "app/pages/ops/OpsDashboardPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsDashboardPage.tsx:763",
    "text": ">Impossible de charger le pilotage : {error instanceof Error ? error.message :",
    "file": "app/pages/ops/OpsDashboardPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsDashboardPage.tsx:765",
    "text": ">Statut</th></tr></thead><tbody>{leads.slice(0, 8).map((lead) => <tr key={lead.id} className=",
    "file": "app/pages/ops/OpsDashboardPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsDashboardPage.tsx:761",
    "text": "Données Supabase · accès filtré",
    "file": "app/pages/ops/OpsDashboardPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsDashboardPage.tsx:760",
    "text": "Rendez-vous à venir",
    "file": "app/pages/ops/OpsDashboardPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsDashboardPage.tsx:759",
    "text": "Suivez les demandes, dossiers, documents et rendez-vous à partir des données autorisées.",
    "file": "app/pages/ops/OpsDashboardPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsHelpPage.tsx:776",
    "text": "/>Interroger le Guide Orée</Button></section><div className=",
    "file": "app/pages/ops/OpsHelpPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsHelpPage.tsx:775",
    "text": ">Cette rubrique rassemble les principes indispensables au traitement cohérent des demandes, des projets et des documents.</p><Button variant=",
    "file": "app/pages/ops/OpsHelpPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsHelpPage.tsx:774",
    "text": ">Procédures opérationnelles et règles de sécurité</h1><p className=",
    "file": "app/pages/ops/OpsHelpPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsHelpPage.tsx:769",
    "text": "Comparer la pièce aux exigences du dossier, consigner le motif précis et ne jamais valider sa propre action.",
    "file": "app/pages/ops/OpsHelpPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsHelpPage.tsx:773",
    "text": "Consultez les procédures essentielles de traitement et de sécurité.",
    "file": "app/pages/ops/OpsHelpPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsHelpPage.tsx:768",
    "text": "Contrôler un document",
    "file": "app/pages/ops/OpsHelpPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsHelpPage.tsx:772",
    "text": "Limiter l'accès au rôle nécessaire, éviter toute donnée personnelle dans les outils publicitaires et utiliser des liens signés courts.",
    "file": "app/pages/ops/OpsHelpPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsHelpPage.tsx:771",
    "text": "Protéger les données",
    "file": "app/pages/ops/OpsHelpPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsHelpPage.tsx:770",
    "text": "Relier la demande au document concerné, préserver l'historique et indiquer l'action attendue en termes compréhensibles.",
    "file": "app/pages/ops/OpsHelpPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsHelpPage.tsx:767",
    "text": "Vérifier l'intention, la maturité, le calendrier et les actions déjà réalisées avant toute affectation.",
    "file": "app/pages/ops/OpsHelpPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsInboxPage.tsx:778",
    "text": "); setInternal(false); await client.invalidateQueries({ queryKey: [",
    "file": "app/pages/ops/OpsInboxPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsInboxPage.tsx:784",
    "text": "}{new Date(message.created_at).toLocaleString(",
    "file": "app/pages/ops/OpsInboxPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsInboxPage.tsx:785",
    "text": "/>Note interne — invisible pour le client</label><div className=",
    "file": "app/pages/ops/OpsInboxPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsInboxPage.tsx:783",
    "text": ">{message.body}</p><p className={`mt-2 text-[10px] ${own && !message.internal_only ?",
    "file": "app/pages/ops/OpsInboxPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsInboxPage.tsx:782",
    "text": ">{selected.messages.map((message) => { const own = message.sender_user_id === user?.id; return <div key={message.id} className={`flex ${own ?",
    "file": "app/pages/ops/OpsInboxPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsInboxPage.tsx:779",
    "text": ">Boîte de réception projets</h1><p className=",
    "file": "app/pages/ops/OpsInboxPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsInboxPage.tsx:780",
    "text": ">Chaque réponse reste liée au projet. Les notes internes sont filtrées par les permissions et ne sont jamais montrées au client.</p></section>{error ? <Card className=",
    "file": "app/pages/ops/OpsInboxPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsInboxPage.tsx:781",
    "text": "Conversation prête",
    "file": "app/pages/ops/OpsInboxPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsInboxPage.tsx:777",
    "text": "Répondez aux clients dans la conversation rattachée à chaque projet.",
    "file": "app/pages/ops/OpsInboxPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsInboxPage.tsx:786",
    "text": "Répondre au client…",
    "file": "app/pages/ops/OpsInboxPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsProfilePage.tsx:794",
    "text": "}</span>. Il ne peut pas être modifié ici.</div> <Button onClick={() => save.mutate()} disabled={isLoading || save.isPending}><Save className=",
    "file": "app/pages/ops/OpsProfilePage.tsx"
  },
  {
    "id": "app/pages/ops/OpsProfilePage.tsx:790",
    "text": "/>Profil enregistré.</Card> : null} <Card className=",
    "file": "app/pages/ops/OpsProfilePage.tsx"
  },
  {
    "id": "app/pages/ops/OpsProfilePage.tsx:793",
    "text": ">Plages et contraintes de disponibilité <textarea disabled={isLoading} rows={4} value={profile.availabilityNote} onChange={(event) => setProfile((current) => ({ ...current, availabilityNote: event.target.value }))} placeholder=",
    "file": "app/pages/ops/OpsProfilePage.tsx"
  },
  {
    "id": "app/pages/ops/OpsProfilePage.tsx:791",
    "text": ">Prénom <input disabled={isLoading} value={profile.firstName} onChange={(event) => setProfile((current) => ({ ...current, firstName: event.target.value }))} className=",
    "file": "app/pages/ops/OpsProfilePage.tsx"
  },
  {
    "id": "app/pages/ops/OpsProfilePage.tsx:788",
    "text": ">Profil du compte équipe</h1> <p className=",
    "file": "app/pages/ops/OpsProfilePage.tsx"
  },
  {
    "id": "app/pages/ops/OpsProfilePage.tsx:792",
    "text": ">Téléphone <input disabled={isLoading} value={profile.phone} onChange={(event) => setProfile((current) => ({ ...current, phone: event.target.value }))} className=",
    "file": "app/pages/ops/OpsProfilePage.tsx"
  },
  {
    "id": "app/pages/ops/OpsProfilePage.tsx:789",
    "text": ">Votre profil opérationnel est stocké dans Supabase. Il ne peut jamais accorder un rôle interne : les autorisations sont administrées séparément côté serveur.</p> </section> {error || save.error ? <Card className=",
    "file": "app/pages/ops/OpsProfilePage.tsx"
  },
  {
    "id": "app/pages/ops/OpsProfilePage.tsx:787",
    "text": "Gérez les informations de présentation et les préférences du compte équipe.",
    "file": "app/pages/ops/OpsProfilePage.tsx"
  },
  {
    "id": "app/pages/ops/OpsSectionPage.tsx:799",
    "text": ", active); }, onSuccess: async () => { await client.invalidateQueries({ queryKey: [",
    "file": "app/pages/ops/OpsSectionPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsSectionPage.tsx:795",
    "text": ", lead.message], [",
    "file": "app/pages/ops/OpsSectionPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsSectionPage.tsx:801",
    "text": ": `${filtered.length} élément(s)`}</span><span>Les mutations sensibles sont auditées</span></div><div className=",
    "file": "app/pages/ops/OpsSectionPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsSectionPage.tsx:807",
    "text": "/>Accès interne actif</label> : null} {mutation.error ? <p className=",
    "file": "app/pages/ops/OpsSectionPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsSectionPage.tsx:802",
    "text": ">À rappeler</span> : null}<span className=",
    "file": "app/pages/ops/OpsSectionPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsSectionPage.tsx:804",
    "text": ">Action contrôlée</p><h2 className=",
    "file": "app/pages/ops/OpsSectionPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsSectionPage.tsx:803",
    "text": ">Aucun élément accessible.</p> : null}</div></Card> <Card className=",
    "file": "app/pages/ops/OpsSectionPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsSectionPage.tsx:796",
    "text": ">Cette personne a explicitement demandé à être rappelée. Son numéro et les actions de contact sont disponibles ci-dessous.</p></div></div> : null} <div className=",
    "file": "app/pages/ops/OpsSectionPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsSectionPage.tsx:800",
    "text": ">Orée Operations · {data?.demo ?",
    "file": "app/pages/ops/OpsSectionPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsSectionPage.tsx:797",
    "text": ">Projet et acquisition</p> <dl className=",
    "file": "app/pages/ops/OpsSectionPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsSectionPage.tsx:798",
    "text": ">Résultat commercial</p>{lead.qualificationReason ? <p className=",
    "file": "app/pages/ops/OpsSectionPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsSectionPage.tsx:808",
    "text": ">Sélectionnez un élément</p><p className=",
    "file": "app/pages/ops/OpsSectionPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsSectionPage.tsx:805",
    "text": ">Statut ou rôle<select value={status} onChange={(event) => setStatus(event.target.value)} className=",
    "file": "app/pages/ops/OpsSectionPage.tsx"
  },
  {
    "id": "app/pages/ops/OpsSectionPage.tsx:806",
    "text": "disabled>Aucune affectation — choisissez un conseiller</option> : null}{advisorOptions.map((member) => <option key={member.id} value={member.id}>{member.name} · {member.role}{member.active ?",
    "file": "app/pages/ops/OpsSectionPage.tsx"
  },
  {
    "id": "app/pages/public/AccompanimentPage.tsx:820",
    "text": "/>Contexte partagé</Badge><h2 className=",
    "file": "app/pages/public/AccompanimentPage.tsx"
  },
  {
    "id": "app/pages/public/AccompanimentPage.tsx:822",
    "text": ">déjà communiquées.</span></h2><p className=",
    "file": "app/pages/public/AccompanimentPage.tsx"
  },
  {
    "id": "app/pages/public/AccompanimentPage.tsx:821",
    "text": ">L'équipe retrouve les informations <span className=",
    "file": "app/pages/public/AccompanimentPage.tsx"
  },
  {
    "id": "app/pages/public/AccompanimentPage.tsx:828",
    "text": "Analyse juridique, fiscale ou comptable personnalisée par un professionnel réglementé lorsque nécessaire.",
    "file": "app/pages/public/AccompanimentPage.tsx"
  },
  {
    "id": "app/pages/public/AccompanimentPage.tsx:826",
    "text": "Collecte, contrôle de complétude, suivi des pièces et préparation opérationnelle du dossier.",
    "file": "app/pages/public/AccompanimentPage.tsx"
  },
  {
    "id": "app/pages/public/AccompanimentPage.tsx:825",
    "text": "Comparaisons pédagogiques, étapes, listes de contrôle et explications du parcours.",
    "file": "app/pages/public/AccompanimentPage.tsx"
  },
  {
    "id": "app/pages/public/AccompanimentPage.tsx:818",
    "text": "Confirmer l'orientation, le calendrier ou une décision avant de poursuivre.",
    "file": "app/pages/public/AccompanimentPage.tsx"
  },
  {
    "id": "app/pages/public/AccompanimentPage.tsx:827",
    "text": "Conseil réglementé",
    "file": "app/pages/public/AccompanimentPage.tsx"
  },
  {
    "id": "app/pages/public/AccompanimentPage.tsx:813",
    "text": "Contrôle du dossier",
    "file": "app/pages/public/AccompanimentPage.tsx"
  },
  {
    "id": "app/pages/public/AccompanimentPage.tsx:809",
    "text": "Découvrez comment le conseiller intervient dans le parcours de création de société Orée.",
    "file": "app/pages/public/AccompanimentPage.tsx"
  },
  {
    "id": "app/pages/public/AccompanimentPage.tsx:815",
    "text": "Explication contextualisée",
    "file": "app/pages/public/AccompanimentPage.tsx"
  },
  {
    "id": "app/pages/public/AccompanimentPage.tsx:819",
    "text": "Identifier les questions qui doivent être confiées à un professionnel réglementé.",
    "file": "app/pages/public/AccompanimentPage.tsx"
  },
  {
    "id": "app/pages/public/AccompanimentPage.tsx:824",
    "text": "Information générale",
    "file": "app/pages/public/AccompanimentPage.tsx"
  },
  {
    "id": "app/pages/public/AccompanimentPage.tsx:812",
    "text": "L'outil prépare le contexte. L'équipe peut ainsi se concentrer sur les incohérences, les décisions et les validations nécessaires.",
    "file": "app/pages/public/AccompanimentPage.tsx"
  },
  {
    "id": "app/pages/public/AccompanimentPage.tsx:823",
    "text": "Le service distingue l'information générale, l'accompagnement administratif et les prestations qui relèvent d'un professionnel réglementé.",
    "file": "app/pages/public/AccompanimentPage.tsx"
  },
  {
    "id": "app/pages/public/AccompanimentPage.tsx:810",
    "text": "Les pièces et demandes sont reliées",
    "file": "app/pages/public/AccompanimentPage.tsx"
  },
  {
    "id": "app/pages/public/AccompanimentPage.tsx:811",
    "text": "Les questions réglementées sont identifiées",
    "file": "app/pages/public/AccompanimentPage.tsx"
  },
  {
    "id": "app/pages/public/AccompanimentPage.tsx:814",
    "text": "Repérer une incohérence, une pièce manquante ou une information à préciser.",
    "file": "app/pages/public/AccompanimentPage.tsx"
  },
  {
    "id": "app/pages/public/AccompanimentPage.tsx:816",
    "text": "Répondre à partir des éléments du projet et de l'étape concernée.",
    "file": "app/pages/public/AccompanimentPage.tsx"
  },
  {
    "id": "app/pages/public/AccompanimentPage.tsx:817",
    "text": "Validation d'étape",
    "file": "app/pages/public/AccompanimentPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:902",
    "text": "} title={<>Les décisions à examiner <span className=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:905",
    "text": "} title={<>Quatre étapes pour passer de l’intention <span className=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:888",
    "text": "/diagnostic?intent=${content.searchIntent}",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:914",
    "text": "><Badge>Questions fréquentes</Badge><h2 className=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:896",
    "text": ">À confirmer avec vous</p><p className=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:898",
    "text": ">À préparer</p><h2 className=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:909",
    "text": ">Après le diagnostic</Badge><h2 className=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:906",
    "text": ">au dossier suivi.</span></>} /> <div className={cn(",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:903",
    "text": ">avant de constituer le dossier.</span></>} description=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:908",
    "text": ">Cette démarche ne nécessite pas toujours un accompagnement de création de société. Consultez d’abord les informations publiques adaptées.</p></div><a href=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:901",
    "text": ">Informations à anticiper</h2><ul className=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:912",
    "text": ">La démonstration illustre la fiche projet, les documents, les messages et la prochaine action. Les données réelles relèvent ensuite du mode connecté sécurisé.</p><ButtonLink to=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:916",
    "text": ">Le fonctionnement général, les limites de l'orientation et les validations qui peuvent rester nécessaires.</p></div><Faq items={content.faq} /></div></Section> <Section className=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:904",
    "text": ">les différences à vérifier.</span></>} description=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:899",
    "text": ">Les premières informations</h2><ul className=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:915",
    "text": ">Les réponses essentielles avant de commencer.</h2><p className=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:890",
    "text": ">Orée Entreprises · Optimum Tech · SIRET 98898880400015 · Montpellier</p> : null} <div className=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:900",
    "text": ">Un calendrier expliqué</h2><p className=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:897",
    "text": ">Un dossier complet d’abord</h2><p className=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:911",
    "text": ">un projet structuré.</span></h2><p className=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:910",
    "text": ">Une synthèse qui peut ouvrir <span className=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:907",
    "text": ">Vous recherchez uniquement l’ouverture gratuite d’une micro-entreprise ?</p><p className=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:829",
    "text": "${commercialOffers.companyCreation.priceLabel} avec accompagnement, greffe, annonce légale et corrections du dossier inclus.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:857",
    "text": "À plusieurs, la première décision n'est pas seulement SAS ou SARL : il faut d'abord rendre explicites les rôles, apports, pouvoirs et règles de décision.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:868",
    "text": "Activité et date de lancement envisagées",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:876",
    "text": "Activité et forme juridique à comparer",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:894",
    "text": "Activité, clients et calendrier",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:863",
    "text": "Adresse et activité de la future société",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:856",
    "text": "Adresse et calendrier du projet",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:833",
    "text": "Adresse et justificatif du siège",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:918",
    "text": "Appelez-nous, demandez un rappel ou commencez votre dossier en ligne.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:861",
    "text": "Apports et répartition envisagée",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:871",
    "text": "ARE, ARCE et ACRE répondent à des règles différentes. L'éligibilité, le calendrier et les effets d'une rémunération doivent être confirmés auprès des organismes compétents.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:913",
    "text": "arrow>Explorer l'espace démo</ButtonLink></div><DashboardPreview /></div></Section> : null} <Section><div className=",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:893",
    "text": "Associés et organisation",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:872",
    "text": "Aucune aide ne doit être présentée comme une remise garantie sur le prix du service ou comme automatiquement acquise.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:834",
    "text": "Capital et apports envisagés",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:839",
    "text": "Capital et nature des apports",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:855",
    "text": "Charges et rémunération envisagées",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:919",
    "text": "Choisissez la manière la plus simple de commencer.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:869",
    "text": "Clients ou premières ventes éventuels",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:851",
    "text": "Créer seul n'impose pas automatiquement une SASU ou une EURL. L'entreprise individuelle et le régime micro peuvent aussi devoir être examinés selon l'activité et les charges.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:875",
    "text": "Date de création souhaitée",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:881",
    "text": "Date et structure cible envisagées",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:845",
    "text": "Décisions de gouvernance à confirmer",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:854",
    "text": "Description de l'activité et des clients",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:840",
    "text": "Description précise de l'activité",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:880",
    "text": "Données d'activité et charges réelles",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:887",
    "text": "Échéance éventuelle communiquée",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:889",
    "text": "entreprise par vous-même, gratuitement ou à moindre coût, sur le site public du <a href=\"https://formalites.entreprises.gouv.fr\" target=\"_blank\" rel=\"noreferrer\" className=\"underline hover:text-[color:var(--ink)]\">Guichet unique de l",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:885",
    "text": "Étape actuelle de la formalité",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:843",
    "text": "Identité de chaque associé et dirigeant",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:848",
    "text": "Identité des associés et gérants",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:860",
    "text": "Identité et situation de chaque porteur",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:832",
    "text": "Identité et situation du dirigeant",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:838",
    "text": "Identité et situation du gérant",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:835",
    "text": "Informations sur l'activité",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:842",
    "text": "L'accord des associés et la complétude de chaque partie précèdent tout calendrier de formalité.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:836",
    "text": "L'EURL propose un cadre plus balisé pour entreprendre seul. Le régime du gérant, la rémunération et l'arrivée possible d'associés doivent être examinés face à la SASU.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:873",
    "text": "L'ordre des démarches peut compter ; la synthèse indique les dates et conditions qui restent à vérifier auprès des registres.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:879",
    "text": "La continuité de facturation et des contrats doit être organisée avant la date de bascule.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:837",
    "text": "La date utile est celle d'un dossier complet et cohérent, pas une promesse de traitement par les greffes.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:865",
    "text": "La préparation du calendrier et une éventuelle revue humaine doivent être chiffrées séparément dans le devis.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:882",
    "text": "La prochaine action dépend du message exact reçu, de l'étape concernée et de la dernière version envoyée. ORÉE ne peut pas garantir l'acceptation d'une correction.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:846",
    "text": "La SARL encadre davantage l'organisation collective. La gérance, la détention du capital et les règles entre associés restent des sujets déterminants.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:841",
    "text": "La SAS offre une grande liberté d'organisation, qui exige d'aligner les associés sur les pouvoirs, les décisions, le capital et les scénarios d'évolution.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:830",
    "text": "La SASU peut convenir à un projet porté seul qui recherche une gouvernance souple. Elle doit rester comparée à l'EURL selon la rémunération, la protection recherchée et l'évolution prévue.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:866",
    "text": "Le bon moment dépend du contrat, de la disponibilité et de la maturité du projet, pas d'une règle unique.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:831",
    "text": "Le calendrier dépend de la complétude du dossier et des organismes concernés ; aucun délai administratif n'est garanti.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:883",
    "text": "Le coût d'une reprise ne peut être défini qu'après qualification du blocage et du travail déjà effectué.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:852",
    "text": "Le coût ne doit être demandé qu'après avoir identifié la structure et l'accompagnement réellement utiles.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:878",
    "text": "Le devis doit distinguer la création de la société des éventuelles opérations nécessaires à la transition de l'activité existante.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:858",
    "text": "Le devis doit préciser l'effet du nombre d'associés et des besoins de gouvernance sur le périmètre.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:853",
    "text": "Le diagnostic peut commencer avant le choix définitif et sans document sensible.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:877",
    "text": "Le passage en société se décide à partir des charges, contrats, besoins de financement, protection et perspectives — pas sur un seuil universel.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:859",
    "text": "Le projet avance au rythme des décisions communes et de la complétude de chaque associé.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:864",
    "text": "Le projet peut être préparé avant de quitter un emploi. Le contrat de travail, la loyauté, l'activité envisagée et la date de lancement peuvent nécessiter une vérification adaptée.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:886",
    "text": "Liste des versions déjà transmises",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:891",
    "text": "Nous préparons les éléments de votre dossier",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:850",
    "text": "Organisation de la gérance",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:870",
    "text": "Points contractuels à faire vérifier",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:895",
    "text": "Priorités et points à valider",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:844",
    "text": "Répartition des apports et du capital",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:849",
    "text": "Répartition des parts et apports",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:862",
    "text": "Rôles et pouvoirs à discuter",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:874",
    "text": "Situation et dispositif envisagé",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:867",
    "text": "Situation professionnelle sans document sensible",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:884",
    "text": "Toute échéance mentionnée par l'organisme doit être identifiée avant de prioriser la vérification.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:847",
    "text": "Une pièce ou une décision manquante chez un associé peut décaler l'ensemble du dossier.",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:917",
    "text": "Votre prochaine étape",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AcquisitionLandingPage.tsx:892",
    "text": "Vous suivez le dépôt et les éventuelles corrections",
    "file": "app/pages/public/AcquisitionLandingPage.tsx"
  },
  {
    "id": "app/pages/public/AppointmentPage.tsx:920",
    "text": "} à ${slot}`, [selectedDay?.label, slot]); const calendarHeading = useMemo(() => selectedDay ? new Intl.DateTimeFormat(",
    "file": "app/pages/public/AppointmentPage.tsx"
  },
  {
    "id": "app/pages/public/AppointmentPage.tsx:933",
    "text": "/></span><span>Téléphone</span></button></div> </div> <aside className=",
    "file": "app/pages/public/AppointmentPage.tsx"
  },
  {
    "id": "app/pages/public/AppointmentPage.tsx:932",
    "text": "/></span><span>Visioconférence</span></button><button onClick={() => setType(",
    "file": "app/pages/public/AppointmentPage.tsx"
  },
  {
    "id": "app/pages/public/AppointmentPage.tsx:929",
    "text": ">Aucun événement externe n'a été créé. La réservation effective sera activée après connexion au fournisseur de calendrier retenu.</p><div className=",
    "file": "app/pages/public/AppointmentPage.tsx"
  },
  {
    "id": "app/pages/public/AppointmentPage.tsx:931",
    "text": ">Modifier le créneau</Button></div> </motion.div> ) : ( <motion.div key=",
    "file": "app/pages/public/AppointmentPage.tsx"
  },
  {
    "id": "app/pages/public/AppointmentPage.tsx:935",
    "text": ">Point création</p><p className=",
    "file": "app/pages/public/AppointmentPage.tsx"
  },
  {
    "id": "app/pages/public/AppointmentPage.tsx:928",
    "text": ">Sélection enregistrée en démonstration</p><h2 className=",
    "file": "app/pages/public/AppointmentPage.tsx"
  },
  {
    "id": "app/pages/public/AppointmentPage.tsx:930",
    "text": ">Suivi du projet · {type ===",
    "file": "app/pages/public/AppointmentPage.tsx"
  },
  {
    "id": "app/pages/public/AppointmentPage.tsx:936",
    "text": ">Suivi du projet</p></div></div></div> <Button variant=",
    "file": "app/pages/public/AppointmentPage.tsx"
  },
  {
    "id": "app/pages/public/AppointmentPage.tsx:934",
    "text": ">Votre sélection</p> <div className=",
    "file": "app/pages/public/AppointmentPage.tsx"
  },
  {
    "id": "app/pages/public/AppointmentPage.tsx:924",
    "text": "Aucune fausse réservation",
    "file": "app/pages/public/AppointmentPage.tsx"
  },
  {
    "id": "app/pages/public/AppointmentPage.tsx:925",
    "text": "Cette interface n'envoie pas d'événement à un calendrier externe.",
    "file": "app/pages/public/AppointmentPage.tsx"
  },
  {
    "id": "app/pages/public/AppointmentPage.tsx:926",
    "text": "Échange illustratif",
    "file": "app/pages/public/AppointmentPage.tsx"
  },
  {
    "id": "app/pages/public/AppointmentPage.tsx:922",
    "text": "La discussion peut reprendre les éléments du diagnostic avec votre accord.",
    "file": "app/pages/public/AppointmentPage.tsx"
  },
  {
    "id": "app/pages/public/AppointmentPage.tsx:923",
    "text": "Le format réel dépendra du calendrier et du service connectés.",
    "file": "app/pages/public/AppointmentPage.tsx"
  },
  {
    "id": "app/pages/public/AppointmentPage.tsx:927",
    "text": "Le rendez-vous prolonge le diagnostic.",
    "file": "app/pages/public/AppointmentPage.tsx"
  },
  {
    "id": "app/pages/public/AppointmentPage.tsx:921",
    "text": "Réservez un échange de cadrage, d'orientation ou de suivi de dossier.",
    "file": "app/pages/public/AppointmentPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:966",
    "text": "> <div><Badge>Questions fréquentes</Badge><h2 className=",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:951",
    "text": "> Explorez les premières options en quelques secondes, puis approfondissez avec un diagnostic qui tient compte de votre activité, de votre situation et de votre trajectoire. </p> <div className=",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:949",
    "text": "> Le choix du statut organise <span className=",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:956",
    "text": ">Combien serez-vous au capital ?</p> <div className=",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:967",
    "text": ">Comparer les structures avec les nuances nécessaires.</h2><p className=",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:961",
    "text": ">Diagnostic adaptatif</Badge><h2 className=",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:968",
    "text": ">L'orientation classe les options à approfondir et explicite les critères utilisés, sans se substituer à une validation professionnelle lorsque celle-ci est requise.</p></div> <Faq items={[ { question:",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:950",
    "text": ">la gouvernance, la protection et l'évolution du projet.</span> </h1> <p className=",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:964",
    "text": ">Le diagnostic sauvegarde vos réponses, explique son orientation et liste les points qui nécessitent une validation humaine.</p></div> <ButtonLink to=",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:959",
    "text": ">MIS À JOUR</span></div> <motion.div layout className=",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:962",
    "text": ">Passez de la comparaison générale à <span className=",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:960",
    "text": ">réellement le choix.</span></>} /> <div className=",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:958",
    "text": ">Structures à approfondir</p><span className=",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:957",
    "text": ">Votre priorité dominante aujourd'hui ?</p> <div className=",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:963",
    "text": ">votre situation réelle.</span></h2><p className=",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:946",
    "text": "Activité et économie",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:940",
    "text": "Anticiper l'entrée de nouveaux profils et la montée en puissance.",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:947",
    "text": "Arrivée d'associés, transmission, levée de fonds ou changement d'échelle.",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:965",
    "text": "arrow>Démarrer maintenant</ButtonLink> </div> </Section> <Section> <div className=",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:952",
    "text": "arrow>Faire le diagnostic complet</ButtonLink> <ButtonLink to=",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:943",
    "text": "Associés et gouvernance",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:971",
    "text": "Certains projets très simples, sans associé et avec un objectif de test peuvent justifier d'étudier une entreprise individuelle ou le régime micro au lieu de créer immédiatement une société.",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:948",
    "text": "Comparez les principales structures selon votre situation, votre équipe et vos priorités.",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:939",
    "text": "Croissance et associés",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:944",
    "text": "Nombre d'associés, répartition des pouvoirs, décisions et évolution du capital.",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:969",
    "text": "Non. Il classe les options selon vos réponses et met en évidence les points à valider. Une décision personnalisée peut nécessiter l'intervention d'un professionnel réglementé.",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:973",
    "text": "Oui. Le parcours permet de revenir en arrière, et l'orientation est recalculée à partir des nouvelles réponses.",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:970",
    "text": "Pourquoi l'entreprise individuelle apparaît-elle parfois ?",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:942",
    "text": "Préparer une structure plus souple pour les opérations futures.",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:941",
    "text": "Privilégier une organisation plus encadrée et prévisible.",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:972",
    "text": "Puis-je modifier mes réponses ?",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:945",
    "text": "Régime social, rémunération, responsabilités et fonctionnement quotidien.",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:954",
    "text": "Réponses modifiables",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:953",
    "text": "Résultat explicable",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:955",
    "text": "Sans compte au départ",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:937",
    "text": "Simplicité de fonctionnement",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ChooseStatusPage.tsx:938",
    "text": "Un cadre lisible pour démarrer sans complexité inutile.",
    "file": "app/pages/public/ChooseStatusPage.tsx"
  },
  {
    "id": "app/pages/public/ContactPage.tsx:975",
    "text": "> Une question ? Besoin d'aide pour avancer sur votre projet ? Notre équipe est disponible pour vous accompagner. </p> </div> </div> </section> <section className=",
    "file": "app/pages/public/ContactPage.tsx"
  },
  {
    "id": "app/pages/public/ContactPage.tsx:977",
    "text": ">Appelez Sof directement, 7j/7 de 7h à 20h.</p> <p className=",
    "file": "app/pages/public/ContactPage.tsx"
  },
  {
    "id": "app/pages/public/ContactPage.tsx:978",
    "text": ">Écrivez-nous à tout moment, nous vous répondrons rapidement.</p> <p className=",
    "file": "app/pages/public/ContactPage.tsx"
  },
  {
    "id": "app/pages/public/ContactPage.tsx:976",
    "text": ">Par téléphone</h2> <p className=",
    "file": "app/pages/public/ContactPage.tsx"
  },
  {
    "id": "app/pages/public/ContactPage.tsx:974",
    "text": "Contacter l'équipe Orée Entreprises.",
    "file": "app/pages/public/ContactPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:991",
    "text": ", { forms: diagnostic.recommendation.forms, complexity: diagnostic.recommendation.complexity }); analytics.track(",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:990",
    "text": ", { path: window.location.pathname }); } }, [diagnostic.step]); useEffect(() => { if (diagnostic.step ===",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1011",
    "text": ", { step: diagnostic.step, index: diagnostic.stepIndex }); diagnostic.next(); } if (submitted) { return ( <section className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:987",
    "text": ", step: diagnostic.step })} className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:992",
    "text": ", trackAbandonment); trackAbandonment(); }; }, []); function togglePriority(value: string) { const priorities = diagnostic.answers.priorities ?? []; diagnostic.update(",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1021",
    "text": ", value as never)} /> : null} {diagnostic.step ===",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1025",
    "text": ", value as never)} /></div></div> : null} {diagnostic.step ===",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:982",
    "text": ", value: diagnostic.answers.activity ? activityChoices.find((choice) => choice.value === diagnostic.answers.activity)?.label ?? diagnostic.answers.activity :",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:980",
    "text": ", value: diagnostic.answers.founderMode ===",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:983",
    "text": ", value: diagnostic.answers.timeline ? timelineChoices.find((choice) => choice.value === diagnostic.answers.timeline)?.label ?? diagnostic.answers.timeline :",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1030",
    "text": "? <><ChoiceGrid multiple choices={priorityChoices} values={diagnostic.answers.priorities} onSelect={togglePriority} /><p className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1022",
    "text": "? <ChoiceGrid choices={founderChoices} value={diagnostic.answers.founderMode} onSelect={(value) => diagnostic.update(",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1020",
    "text": "? <ChoiceGrid choices={startingChoices} value={diagnostic.answers.startingSituation} onSelect={(value) => diagnostic.update(",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1026",
    "text": "? <div><ChoiceGrid choices={activityChoices} value={diagnostic.answers.activity} onSelect={(value) => diagnostic.update(",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1041",
    "text": "} onChange={(event) => diagnostic.update(",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1034",
    "text": "} onChange={(value) => diagnostic.update(",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1050",
    "text": "/>{item}</li>)}</ul></div> </div> {(() => { const form = diagnostic.recommendation.forms.find((code) => isSupportedCompanyForm(code)); return form ? <div className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1051",
    "text": "/></div> : null; })()} </div> : null} {diagnostic.step ===",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1048",
    "text": "/>À vérifier ensemble</p><ul className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1014",
    "text": "/>Appeler l’équipe</a> <ButtonLink to=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1063",
    "text": "/>Choix non sensibles sauvegardés</div> {diagnostic.step ===",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1015",
    "text": "/>Recommencer le diagnostic</button> </div> </div> </div> </section> ); } return ( <section className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1031",
    "text": "/>Vous pouvez sélectionner plusieurs éléments.</p></> : null} {diagnostic.step ===",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1013",
    "text": "> <a href={contact.phoneHref} data-phone-number={contact.displayPhone} aria-label={`Appeler Orée au ${contact.displayPhone}`} onClick={() => analytics.track(",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1046",
    "text": ">{diagnostic.recommendation.explanation}</p> </div> <div className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1045",
    "text": ">{diagnostic.recommendation.forms.map((code) => getLegalForm(code)?.label ?? code).join(",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1049",
    "text": ">{diagnostic.recommendation.pointsToValidate.map((item) => <li key={item} className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1047",
    "text": ">{diagnostic.recommendation.reasons.map((item) => <li key={item} className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1044",
    "text": ">{diagnostic.recommendation.title}</h2> <p className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1017",
    "text": ">{diagnostic.stepIndex + 1}/{diagnostic.steps.length}</span> <div className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1032",
    "text": "><ChoiceGrid choices={timelineChoices} value={diagnostic.answers.timeline} onSelect={(value) => diagnostic.update(",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1056",
    "text": ">Ces coordonnées ne sont pas enregistrées dans le brouillon local. Le téléphone devient nécessaire uniquement si vous demandez un rappel.</p> <label className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1029",
    "text": ">Cette information aide à situer l’avancement du projet.</span></span></label></div> : null} {diagnostic.step ===",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1059",
    "text": ">Cette option est facultative et distincte de l’envoi de la synthèse.</span></span></label> <label className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1062",
    "text": ">Consultez la politique de confidentialité pour connaître les finalités, accès et durées de conservation.</span></span></label> {error ? <div role=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:985",
    "text": ">D’après vos réponses</h2> <dl className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1016",
    "text": ">Diagnostic de création de société</p> <p className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1036",
    "text": ">Envisagez-vous une rémunération dès le démarrage ?</p><ChoiceGrid choices={remunerationChoices} value={diagnostic.answers.remunerationTiming} onSelect={(value) => diagnostic.update(",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1024",
    "text": ">Exercez-vous déjà avec une structure ?</p><ChoiceGrid choices={structureChoices} value={diagnostic.answers.currentStructure} onSelect={(value) => diagnostic.update(",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1035",
    "text": ">Indiquez uniquement le code du département, par exemple 34, 2A ou 971.</p></div></div> : null} {diagnostic.step ===",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1061",
    "text": ">J’accepte le traitement de mes données pour transmettre et traiter cette demande.</strong><span className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1028",
    "text": ">J’ai déjà des clients ou des premières ventes</strong><span className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1058",
    "text": ">Je souhaite être rappelé au sujet de mon projet</strong><span className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1042",
    "text": ">Ne transmettez pas ici de pièce d’identité, de coordonnées bancaires ou de document sensible.</span></label></div> : null} {diagnostic.step ===",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1043",
    "text": ">Notre première recommandation</p> <h2 className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1037",
    "text": ">Quel niveau d’accompagnement recherchez-vous ?</p><ChoiceGrid choices={supportChoices} value={diagnostic.answers.supportLevel} onSelect={(value) => diagnostic.update(",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1012",
    "text": ">Votre demande est bien enregistrée.</h1> <p className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:984",
    "text": ">Votre projet</p> <h2 className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1023",
    "text": ">Votre situation professionnelle</p><ChoiceGrid choices={professionalChoices} value={diagnostic.answers.professionalStatus} onSelect={(value) => diagnostic.update(",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1019",
    "text": "animate={{ width: `${diagnostic.progress}%` }} transition={{ duration: reduce ? 0 : .3 }} /> </div> </div> <button onClick={diagnostic.reset} className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1018",
    "text": "aria-label={`Progression ${diagnostic.progress}%`}> <motion.div className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:986",
    "text": "Besoin d’aide ? Appeler Orée au ${contact.displayPhone}",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1040",
    "text": "Capital ou apports",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1027",
    "text": "checked={diagnostic.answers.existingClients ?? false} onChange={(event) => diagnostic.update(",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1060",
    "text": "checked={diagnostic.answers.privacyAccepted ?? false} onChange={(event) => diagnostic.update(",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1057",
    "text": "checked={diagnostic.answers.wantsCallback ?? false} onChange={(event) => diagnostic.update(",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:995",
    "text": "Commencez par votre situation réelle. Les statuts à comparer apparaîtront ensuite.",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1006",
    "text": "Décrivez le message reçu sans transmettre de document sensible, de coordonnées bancaires ou de pièce d’identité.",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:989",
    "text": "Décrivez votre situation et obtenez une première recommandation avant de constituer votre dossier.",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:988",
    "text": "Diagnostic de création de société",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1054",
    "text": "E-mail pour transmettre la synthèse",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:998",
    "text": "Elle nous aide à distinguer création, transition et activité déjà existante.",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1038",
    "text": "Identité ou justificatif",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1003",
    "text": "Le calendrier aide à déterminer si la prochaine étape doit être un dossier, une préparation ou un échange.",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:997",
    "text": "Le nombre d’associés change la gouvernance, les documents et les structures à comparer.",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1000",
    "text": "Le secteur permet d’anticiper les besoins, contraintes ou questions complémentaires.",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:993",
    "text": "Nous n’avons pas pu transmettre votre demande. Vérifiez votre connexion, puis réessayez.",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1064",
    "text": "onClick={() => void submit()} disabled={!diagnostic.canContinue || submitting}>{submitting ? <LoaderCircle className=",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1065",
    "text": "onClick={continueDiagnostic} disabled={!diagnostic.canContinue}>{diagnostic.step ===",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:981",
    "text": "Plusieurs associés",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1005",
    "text": "Quel est le blocage rencontré ?",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:994",
    "text": "Quel est le point de départ de votre projet ?",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:999",
    "text": "Quelle activité allez-vous exercer ?",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1001",
    "text": "Quels critères sont prioritaires pour votre projet ?",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:996",
    "text": "Qui porte le projet ?",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1009",
    "text": "Recevez votre synthèse.",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1039",
    "text": "Statuts ou décisions",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:979",
    "text": "Structure à comparer",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1055",
    "text": "Téléphone facultatif",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1004",
    "text": "Un échange peut être demandé pour reprendre les points qui restent à confirmer.",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1033",
    "text": "value={diagnostic.answers.department ??",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1052",
    "text": "value={diagnostic.answers.firstName ??",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1053",
    "text": "value={diagnostic.answers.lastName ??",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1008",
    "text": "Voici les structures à comparer et les sujets qui doivent encore être validés.",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1010",
    "text": "Vos coordonnées servent à transmettre et traiter la demande. Aucun appel n’est demandé sans votre accord.",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1007",
    "text": "Votre première recommandation est prête.",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/DiagnosticPage.tsx:1002",
    "text": "Vous pouvez en sélectionner plusieurs. Ils servent à expliquer la recommandation.",
    "file": "app/pages/public/DiagnosticPage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1118",
    "text": ">Décrivez votre situation avant d’engager les formalités.</h2><p className=",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1116",
    "text": ">Fonctionnement, coûts, limites de l'orientation et reprise d'un dossier déjà engagé.</p></div> <Faq items={faqs} /> </div> </Section> <Section className=",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1112",
    "text": ">La plateforme prépare le contexte. <span className=",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1119",
    "text": ">La synthèse reste indicative et affiche les décisions qui nécessitent encore une confirmation.</p></div><ButtonLink to=",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1107",
    "text": ">Le diagnostic structure la fiche projet, la liste documentaire, les messages et la prochaine action. La démonstration permet d'examiner cette continuité avant connexion à Supabase.</p> <div className=",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1115",
    "text": ">Le Guide Orée retrouve une page ou une action dans les contenus du site.</p></div><button type=",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1117",
    "text": ">Votre prochaine étape</Badge><h2 className=",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1106",
    "text": ">Votre projet devient <span className=",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1113",
    "text": ">Vous pouvez demander un échange pour reprendre les informations déjà structurées. La disponibilité, les compétences mobilisées et le périmètre d'intervention doivent être confirmés avant la prestation.</p> <div className=",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1097",
    "text": "${commercialOffers.companyCreation.priceLabel} comprend l’accompagnement, les frais de greffe, l’annonce légale et les corrections ou compléments du dossier. Les modifications de sociétés existantes ne sont pas prises en charge.",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1082",
    "text": "Activité déjà facturée",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1114",
    "text": "arrow>Demander un échange</ButtonLink><ButtonLink to=",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1108",
    "text": "arrow>Explorer l'espace démo</ButtonLink> </div> <DashboardPreview /> </div> </Section> <Section className=",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1110",
    "text": "associés ouvre la comparaison. La rémunération, le calendrier, l",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1075",
    "text": "Calendrier à cadrer",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1074",
    "text": "Calendrier du projet",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1086",
    "text": "Chaque information et document conserve un statut compréhensible.",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1104",
    "text": "Choisissez le contexte qui ressemble le plus au vôtre. Chaque entrée conserve son intention jusqu'au diagnostic.",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1066",
    "text": "Comparez les structures unipersonnelles et organisez votre dossier avant de retenir une option.",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1083",
    "text": "Continuité des contrats",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1073",
    "text": "Contraintes à vérifier",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1072",
    "text": "Création immédiate ou progressive",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1101",
    "text": "Créez votre société avec clarté",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1077",
    "text": "Dates de démarches",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1087",
    "text": "Des accès contrôlés",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1102",
    "text": "Diagnostic adaptatif, dossier structuré et prochaine action visible pour votre projet de société.",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1092",
    "text": "Dois-je déjà savoir quelle société créer ?",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1079",
    "text": "Éligibilité à confirmer",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1081",
    "text": "Étudier la transition",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1080",
    "text": "Étudiez le passage d'une micro-entreprise ou d'une EI vers une société adaptée au projet.",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1111",
    "text": "évolution permettent ensuite de l",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1088",
    "text": "Le mode connecté repose sur stockage privé, RLS et droits limités.",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1089",
    "text": "Le projet indique ce qui doit être complété, vérifié ou attendu.",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1091",
    "text": "Les échanges peuvent être reliés à une étape ou à un document.",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1067",
    "text": "Mode de rémunération",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1098",
    "text": "Non. Elle organise les informations, explique le parcours et met en évidence les points à valider. Les recommandations personnalisées et actes réglementés nécessitent l'intervention d'un professionnel réglementé.",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1093",
    "text": "Non. Le diagnostic commence par votre situation, votre activité, vos associés éventuels et vos priorités. Les structures apparaissent ensuite comme des pistes à comparer, jamais comme une réponse automatique définitive.",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1095",
    "text": "Oui. Vous pouvez avancer dans le diagnostic et obtenir une première orientation avant de créer un compte. L'inscription devient utile pour poursuivre le dossier dans l'espace connecté.",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1071",
    "text": "Pièces par personne",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1068",
    "text": "Préparer le projet",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1085",
    "text": "Projet de développement",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1084",
    "text": "Protection et fiscalité",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1094",
    "text": "Puis-je commencer sans créer de compte ?",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1096",
    "text": "Que comprend le prix de création ?",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1099",
    "text": "Que se passe-t-il si mon dossier est déjà bloqué ?",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1078",
    "text": "Rémunération envisagée",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1069",
    "text": "Répartition du capital",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1070",
    "text": "Rôles des associés",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1076",
    "text": "Situez la création dans votre calendrier et identifiez les dispositifs à vérifier auprès des organismes compétents.",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1105",
    "text": "title={<>De l’orientation au suivi, <span className=",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1109",
    "text": "title={<>Les structures à examiner, <span className=",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1090",
    "text": "Un contexte conservé",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1100",
    "text": "Un parcours distinct permet de situer l'étape et la demande reçue. Il organise la vérification sans promettre qu'une correction sera automatiquement acceptée par l'organisme compétent.",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HomePage.tsx:1103",
    "text": "Votre point de départ",
    "file": "app/pages/public/HomePage.tsx"
  },
  {
    "id": "app/pages/public/HowItWorksPage.tsx:1133",
    "text": ">des responsabilités.</span></>} description=",
    "file": "app/pages/public/HowItWorksPage.tsx"
  },
  {
    "id": "app/pages/public/HowItWorksPage.tsx:1125",
    "text": ">du début à la fin.</span></>} description=",
    "file": "app/pages/public/HowItWorksPage.tsx"
  },
  {
    "id": "app/pages/public/HowItWorksPage.tsx:1128",
    "text": ">espace opérationnel.</span></h2><p className=",
    "file": "app/pages/public/HowItWorksPage.tsx"
  },
  {
    "id": "app/pages/public/HowItWorksPage.tsx:1127",
    "text": ">Le projet se poursuit dans un <span className=",
    "file": "app/pages/public/HowItWorksPage.tsx"
  },
  {
    "id": "app/pages/public/HowItWorksPage.tsx:1129",
    "text": ">Les informations, les documents, les échanges, les rendez-vous et la chronologie sont réunis dans un même espace de suivi.</p><div className=",
    "file": "app/pages/public/HowItWorksPage.tsx"
  },
  {
    "id": "app/pages/public/HowItWorksPage.tsx:1121",
    "text": "Commencez immédiatement. Les réponses non sensibles restent sauvegardées pendant votre exploration.",
    "file": "app/pages/public/HowItWorksPage.tsx"
  },
  {
    "id": "app/pages/public/HowItWorksPage.tsx:1135",
    "text": "Contrôle le dossier, demande des corrections, accompagne et prépare les étapes relevant du service.",
    "file": "app/pages/public/HowItWorksPage.tsx"
  },
  {
    "id": "app/pages/public/HowItWorksPage.tsx:1130",
    "text": "Demandes contextualisées",
    "file": "app/pages/public/HowItWorksPage.tsx"
  },
  {
    "id": "app/pages/public/HowItWorksPage.tsx:1120",
    "text": "Diagnostic sans compte",
    "file": "app/pages/public/HowItWorksPage.tsx"
  },
  {
    "id": "app/pages/public/HowItWorksPage.tsx:1124",
    "text": "Du diagnostic à l'espace projet : découvrez le fonctionnement complet de la plateforme Orée.",
    "file": "app/pages/public/HowItWorksPage.tsx"
  },
  {
    "id": "app/pages/public/HowItWorksPage.tsx:1122",
    "text": "L'orientation présente ses raisons, ses alternatives et les points qui restent à confirmer.",
    "file": "app/pages/public/HowItWorksPage.tsx"
  },
  {
    "id": "app/pages/public/HowItWorksPage.tsx:1123",
    "text": "Le compte devient utile au bon moment : sauvegarde multi-appareils, pièces, associés et suivi.",
    "file": "app/pages/public/HowItWorksPage.tsx"
  },
  {
    "id": "app/pages/public/HowItWorksPage.tsx:1134",
    "text": "Répondez, fournissez les pièces, confirmez les choix et signez lorsque nécessaire.",
    "file": "app/pages/public/HowItWorksPage.tsx"
  },
  {
    "id": "app/pages/public/HowItWorksPage.tsx:1131",
    "text": "Statut de chaque formalité",
    "file": "app/pages/public/HowItWorksPage.tsx"
  },
  {
    "id": "app/pages/public/HowItWorksPage.tsx:1126",
    "text": "title={<>Obtenez une première orientation <span className=",
    "file": "app/pages/public/HowItWorksPage.tsx"
  },
  {
    "id": "app/pages/public/HowItWorksPage.tsx:1132",
    "text": "title={<>Une répartition explicite <span className=",
    "file": "app/pages/public/HowItWorksPage.tsx"
  },
  {
    "id": "app/pages/public/HowItWorksPage.tsx:1136",
    "text": "Traitent les formalités transmises selon leurs propres délais et peuvent demander des éléments complémentaires.",
    "file": "app/pages/public/HowItWorksPage.tsx"
  },
  {
    "id": "app/pages/public/NotFoundPage.tsx:1139",
    "text": "arrow>Retour à l'accueil</ButtonLink><ButtonLink to=",
    "file": "app/pages/public/NotFoundPage.tsx"
  },
  {
    "id": "app/pages/public/NotFoundPage.tsx:1137",
    "text": "Cette page n'existe pas ou a été déplacée.",
    "file": "app/pages/public/NotFoundPage.tsx"
  },
  {
    "id": "app/pages/public/NotFoundPage.tsx:1138",
    "text": "est pas <span className=\"gradient-text\">dans le dossier.</span></h1><p className=\"mx-auto mt-6 max-w-xl text-base leading-8 text-white/72\">Le Guide Orée peut retrouver une action avec quelques mots, ou vous pouvez revenir à l",
    "file": "app/pages/public/NotFoundPage.tsx"
  },
  {
    "id": "app/pages/public/OffersPage.tsx:1151",
    "text": ", answer: `Oui. Le forfait de ${offer.priceLabel} comprend les frais de greffe et l’annonce légale nécessaires à la création prise en charge.` }, { question:",
    "file": "app/pages/public/OffersPage.tsx"
  },
  {
    "id": "app/pages/public/OffersPage.tsx:1143",
    "text": "/>Tarif confirmé</Badge> <h1 className=",
    "file": "app/pages/public/OffersPage.tsx"
  },
  {
    "id": "app/pages/public/OffersPage.tsx:1144",
    "text": "> Créez votre société pour <span className=",
    "file": "app/pages/public/OffersPage.tsx"
  },
  {
    "id": "app/pages/public/OffersPage.tsx:1145",
    "text": ">{offer.description} Le même forfait s’applique aux formes principales prises en charge.</p> <div className=",
    "file": "app/pages/public/OffersPage.tsx"
  },
  {
    "id": "app/pages/public/OffersPage.tsx:1147",
    "text": "><Badge>Lecture de l’offre</Badge><h2 className=",
    "file": "app/pages/public/OffersPage.tsx"
  },
  {
    "id": "app/pages/public/OffersPage.tsx:1146",
    "text": ">Accompagnement, frais de greffe, annonce légale et corrections ou compléments du dossier sont compris.</p> <ul className=",
    "file": "app/pages/public/OffersPage.tsx"
  },
  {
    "id": "app/pages/public/OffersPage.tsx:1158",
    "text": ">Commencez par les informations utiles au dossier.</h2><p className=",
    "file": "app/pages/public/OffersPage.tsx"
  },
  {
    "id": "app/pages/public/OffersPage.tsx:1157",
    "text": ">Étape suivante</Badge><h2 className=",
    "file": "app/pages/public/OffersPage.tsx"
  },
  {
    "id": "app/pages/public/OffersPage.tsx:1149",
    "text": ">La forme juridique principale ne déclenche pas de supplément. Les demandes qui ne relèvent pas d’une création de société sont qualifiées séparément.</p></div> <div className=",
    "file": "app/pages/public/OffersPage.tsx"
  },
  {
    "id": "app/pages/public/OffersPage.tsx:1150",
    "text": ">Les éléments à connaître avant de commencer.</h2></div> <Faq items={[ { question:",
    "file": "app/pages/public/OffersPage.tsx"
  },
  {
    "id": "app/pages/public/OffersPage.tsx:1148",
    "text": ">Un prix unique, avec un périmètre explicite.</h2><p className=",
    "file": "app/pages/public/OffersPage.tsx"
  },
  {
    "id": "app/pages/public/OffersPage.tsx:1142",
    "text": "${offer.priceLabel} pour créer une SASU, EURL, SAS ou SARL, avec greffe, annonce légale et corrections incluses.",
    "file": "app/pages/public/OffersPage.tsx"
  },
  {
    "id": "app/pages/public/OffersPage.tsx:1155",
    "text": "Le prix de ${commercialOffers.microEnterprise.priceLabel} concerne-t-il une société ?",
    "file": "app/pages/public/OffersPage.tsx"
  },
  {
    "id": "app/pages/public/OffersPage.tsx:1152",
    "text": "Non. Aucun supplément n’est appliqué selon l’une de ces quatre formes. Les autres projets de création peuvent être étudiés après vérification.",
    "file": "app/pages/public/OffersPage.tsx"
  },
  {
    "id": "app/pages/public/OffersPage.tsx:1156",
    "text": "Non. Il s’agit d’une offre distincte d’accompagnement à la création d’une micro-entreprise.",
    "file": "app/pages/public/OffersPage.tsx"
  },
  {
    "id": "app/pages/public/OffersPage.tsx:1154",
    "text": "Non. L’offre est réservée aux créations d’entreprise et ne couvre pas les modifications d’une société existante.",
    "file": "app/pages/public/OffersPage.tsx"
  },
  {
    "id": "app/pages/public/OffersPage.tsx:1153",
    "text": "Prenez-vous en charge les modifications de sociétés existantes ?",
    "file": "app/pages/public/OffersPage.tsx"
  },
  {
    "id": "app/pages/public/OffersPage.tsx:1141",
    "text": "Tarifs de création d’entreprise",
    "file": "app/pages/public/OffersPage.tsx"
  },
  {
    "id": "app/pages/public/OffersPage.tsx:1140",
    "text": "Toute prestation qui sortirait du périmètre doit être présentée et acceptée séparément.",
    "file": "app/pages/public/OffersPage.tsx"
  },
  {
    "id": "app/services/leadContinuation.ts:1159",
    "text": ").trim(); writePending({ leadId: result.id, claimToken: result.claimToken, email: answers.email.trim().toLowerCase(), displayName: `Projet de ${fullName ||",
    "file": "app/services/leadContinuation.ts"
  },
  {
    "id": "app/services/supabase/operations.ts:1161",
    "text": ", legalForm: lead.intent, activity: lead.project, message:",
    "file": "app/services/supabase/operations.ts"
  },
  {
    "id": "app/services/supabase/operations.ts:1162",
    "text": ", message: row.message ??",
    "file": "app/services/supabase/operations.ts"
  },
  {
    "id": "app/services/supabase/operations.ts:1160",
    "text": "@/services/supabase/client",
    "file": "app/services/supabase/operations.ts"
  },
  {
    "id": "app/services/supabase/portal.ts:1163",
    "text": ", isOwn: message.author ===",
    "file": "app/services/supabase/portal.ts"
  },
  {
    "id": "app/services/supabase/repositories.ts:1166",
    "text": ", Activité: input.activityDetails ?? input.activity ??",
    "file": "app/services/supabase/repositories.ts"
  },
  {
    "id": "app/services/supabase/repositories.ts:1167",
    "text": ", Délai: input.creationTimeline ?? input.timeline ??",
    "file": "app/services/supabase/repositories.ts"
  },
  {
    "id": "app/services/supabase/repositories.ts:1168",
    "text": ", Rappel_demandé: input.wantsCallback ?",
    "file": "app/services/supabase/repositories.ts"
  },
  {
    "id": "app/services/supabase/repositories.ts:1165",
    "text": "✨ NOUVEAU LEAD ORÉE",
    "file": "app/services/supabase/repositories.ts"
  },
  {
    "id": "app/services/supabase/repositories.ts:1164",
    "text": "🚨 DEMANDE DE RAPPEL ORÉE",
    "file": "app/services/supabase/repositories.ts"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1183",
    "text": "\"aide pour créer une sasu\"",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1181",
    "text": "\"création sasu en ligne\"",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1182",
    "text": "\"formalités création sasu\"",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1215",
    "text": "[ ] budget initial confirmé.",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1212",
    "text": "[ ] chaque conversion principale observée une seule fois ;",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1206",
    "text": "[ ] fonction `submit-lead` redéployée ;",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1214",
    "text": "[ ] import des conversions qualifiées documenté ;",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1211",
    "text": "[ ] initialisation GA4 et remplacement du numéro vérifiés avec Tag Assistant sur le domaine réel ;",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1209",
    "text": "[ ] lien sécurisé de la notification ouvrable après authentification ;",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1205",
    "text": "[ ] migration `0013_offer_and_ads_lead_workflow.sql` appliquée ;",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1208",
    "text": "[ ] notification réellement reçue par le partenaire ;",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1207",
    "text": "[ ] origine de production autorisée ;",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1213",
    "text": "[ ] qualification et gain vérifiés dans l’espace opérations ;",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1210",
    "text": "[ ] téléphone et WhatsApp testés sur mobile réel ;",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1180",
    "text": "[accompagnement création sasu]",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1179",
    "text": "[coût création sasu]",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1178",
    "text": "[prix création sasu]",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1195",
    "text": "`07 87 82 32 08`. Aucun second chargeur `gtag.js` ne doit être ajouté.",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1197",
    "text": "`qualify_lead` et `close_convert_lead`. Ils sont prêts pour un futur export Google Ads,",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1176",
    "text": "2. Prix création SASU",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1187",
    "text": "appels depuis le site, qualifiés à partir d’environ 60 secondes de conversation.",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1198",
    "text": "après définition de la convention d’import et des identifiants de conversion.",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1202",
    "text": "Après soumission, vérifier dans `/ops/leads` :",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1203",
    "text": "campagne et mot-clé ;",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1204",
    "text": "Checklist avant dépense",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1194",
    "text": "configuration d’appel `AW-18362621917/mQHqCLOG6tscEN2__bNE` pour le numéro visible",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1189",
    "text": "conversion d’appel qualifié mesurée par Google Ads.",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1186",
    "text": "Conversions principales configurées dans Google Ads :",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1192",
    "text": "être confondus avec une conversation téléphonique qualifiée. La démonstration de",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1190",
    "text": "Événements d’observation :",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1201",
    "text": "Exemple sans donnée personnelle :",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1171",
    "text": "FR | Search | SASU | 14€/j | Août 2026",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1174",
    "text": "intention principale : création de SASU avec accompagnement ;",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1199",
    "text": "la base possède un index unique sur cet UUID ;",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1173",
    "text": "langue : français ;",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1193",
    "text": "Le chargeur Google tag existant utilise `G-FL6QMMYVLM`. Le même chargeur reçoit la",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1188",
    "text": "Le clic sur un numéro reste un événement de diagnostic : il ne remplace jamais la",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1191",
    "text": "Le formulaire de rappel et le diagnostic restent utiles pour piloter le parcours, sans",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1216",
    "text": "Le lancement reste bloqué tant que les éléments externes ci-dessus ne sont pas validés.",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1196",
    "text": "Les changements `qualified` et `won` créent respectivement des événements serveur",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1200",
    "text": "les événements lifecycle utilisent une `event_key` unique en base.",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1185",
    "text": "Les termes de recherche réels doivent être examinés après lancement avant d’élargir cette",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1170",
    "text": "Mise à jour : 30 juillet 2026.",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1177",
    "text": "Mots-clés de départ",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1175",
    "text": "offre visible sans ambiguïté : `600 € TTC tout compris`.",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1169",
    "text": "Plan de préparation Google Ads",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1172",
    "text": "réseau : Search uniquement ;",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ADS_READINESS_PLAN.md:1184",
    "text": "Thèmes négatifs initiaux :",
    "file": "docs/ADS_READINESS_PLAN.md"
  },
  {
    "id": "docs/ANALYTICS_AND_ADS.md:1225",
    "text": "`AW-18362621917/mQHqCLOG6tscEN2__bNE` active le remplacement du numéro",
    "file": "docs/ANALYTICS_AND_ADS.md"
  },
  {
    "id": "docs/ANALYTICS_AND_ADS.md:1228",
    "text": "`callback_request`, `lead_submitted` et une véritable `appointment_booked` peuvent être",
    "file": "docs/ANALYTICS_AND_ADS.md"
  },
  {
    "id": "docs/ANALYTICS_AND_ADS.md:1231",
    "text": "`qualify_lead` et `close_convert_lead`. Chaque événement serveur possède une clé",
    "file": "docs/ANALYTICS_AND_ADS.md"
  },
  {
    "id": "docs/ANALYTICS_AND_ADS.md:1229",
    "text": "analysés séparément. La démonstration de calendrier n’est pas une conversion.",
    "file": "docs/ANALYTICS_AND_ADS.md"
  },
  {
    "id": "docs/ANALYTICS_AND_ADS.md:1220",
    "text": "analytics, cette interface réutilise le Google tag existant pour émettre les événements",
    "file": "docs/ANALYTICS_AND_ADS.md"
  },
  {
    "id": "docs/ANALYTICS_AND_ADS.md:1226",
    "text": "annonces et les appels depuis le site qualifiés par leur durée. `phone_click` reste un",
    "file": "docs/ANALYTICS_AND_ADS.md"
  },
  {
    "id": "docs/ANALYTICS_AND_ADS.md:1218",
    "text": "Attribution conservée",
    "file": "docs/ANALYTICS_AND_ADS.md"
  },
  {
    "id": "docs/ANALYTICS_AND_ADS.md:1223",
    "text": "Données personnelles",
    "file": "docs/ANALYTICS_AND_ADS.md"
  },
  {
    "id": "docs/ANALYTICS_AND_ADS.md:1232",
    "text": "émises qu’une fois par session.",
    "file": "docs/ANALYTICS_AND_ADS.md"
  },
  {
    "id": "docs/ANALYTICS_AND_ADS.md:1227",
    "text": "événement de diagnostic, jamais une conversation qualifiée.",
    "file": "docs/ANALYTICS_AND_ADS.md"
  },
  {
    "id": "docs/ANALYTICS_AND_ADS.md:1221",
    "text": "GA4. `landing_view` reste un événement distinct et ne crée pas un second `page_view`.",
    "file": "docs/ANALYTICS_AND_ADS.md"
  },
  {
    "id": "docs/ANALYTICS_AND_ADS.md:1230",
    "text": "Les changements opérations `qualified` et `won` préparent respectivement",
    "file": "docs/ANALYTICS_AND_ADS.md"
  },
  {
    "id": "docs/ANALYTICS_AND_ADS.md:1219",
    "text": "Les composants appellent l’interface analytics, jamais directement `gtag`. Après accord",
    "file": "docs/ANALYTICS_AND_ADS.md"
  },
  {
    "id": "docs/ANALYTICS_AND_ADS.md:1217",
    "text": "Mesurer la qualité commerciale complète, pas seulement le formulaire.",
    "file": "docs/ANALYTICS_AND_ADS.md"
  },
  {
    "id": "docs/ANALYTICS_AND_ADS.md:1224",
    "text": "Ne jamais envoyer à GA4 : nom, email, téléphone, texte libre du projet, nom de fichier, document, adresse précise ou message conseiller.",
    "file": "docs/ANALYTICS_AND_ADS.md"
  },
  {
    "id": "docs/ANALYTICS_AND_ADS.md:1222",
    "text": "Noms GA4 émis pour le parcours publicitaire :",
    "file": "docs/ANALYTICS_AND_ADS.md"
  },
  {
    "id": "docs/CONTENT_EDITING.md:1240",
    "text": "Ajouter une entrée pour toute nouvelle action importante. Le build complète automatiquement l'index.",
    "file": "docs/CONTENT_EDITING.md"
  },
  {
    "id": "docs/CONTENT_EDITING.md:1236",
    "text": "Cette configuration est l’autorité unique pour les tarifs publics, les inclusions,",
    "file": "docs/CONTENT_EDITING.md"
  },
  {
    "id": "docs/CONTENT_EDITING.md:1234",
    "text": "Chaque entrée définit : titre, promesse, bénéfices, CTA, FAQ et intention initiale.",
    "file": "docs/CONTENT_EDITING.md"
  },
  {
    "id": "docs/CONTENT_EDITING.md:1242",
    "text": "choix : `app/features/diagnostic/config.ts`",
    "file": "docs/CONTENT_EDITING.md"
  },
  {
    "id": "docs/CONTENT_EDITING.md:1245",
    "text": "Données de démonstration",
    "file": "docs/CONTENT_EDITING.md"
  },
  {
    "id": "docs/CONTENT_EDITING.md:1239",
    "text": "Le libellé fiscal reste masqué tant qu’il n’est pas validé.",
    "file": "docs/CONTENT_EDITING.md"
  },
  {
    "id": "docs/CONTENT_EDITING.md:1241",
    "text": "Les explications doivent être validées et datées. Éviter des conclusions universelles.",
    "file": "docs/CONTENT_EDITING.md"
  },
  {
    "id": "docs/CONTENT_EDITING.md:1237",
    "text": "les formes couvertes, le moment du paiement, le téléphone, WhatsApp et l’e-mail.",
    "file": "docs/CONTENT_EDITING.md"
  },
  {
    "id": "docs/CONTENT_EDITING.md:1238",
    "text": "Modifier cette source plutôt que de saisir un prix ou une coordonnée dans un composant.",
    "file": "docs/CONTENT_EDITING.md"
  },
  {
    "id": "docs/CONTENT_EDITING.md:1246",
    "text": "Ne pas confondre ces données avec de vrais témoignages ou dossiers.",
    "file": "docs/CONTENT_EDITING.md"
  },
  {
    "id": "docs/CONTENT_EDITING.md:1235",
    "text": "Offre commerciale et contacts",
    "file": "docs/CONTENT_EDITING.md"
  },
  {
    "id": "docs/CONTENT_EDITING.md:1243",
    "text": "règles : `app/features/diagnostic/engine.ts`",
    "file": "docs/CONTENT_EDITING.md"
  },
  {
    "id": "docs/CONTENT_EDITING.md:1233",
    "text": "Remplacer nom, descripteur, email, téléphone, adresse et raison sociale.",
    "file": "docs/CONTENT_EDITING.md"
  },
  {
    "id": "docs/CONTENT_EDITING.md:1244",
    "text": "Toute évolution majeure nécessite une nouvelle version lors du passage en base de données.",
    "file": "docs/CONTENT_EDITING.md"
  },
  {
    "id": "docs/CRAWLABILITY_AUDIT.md:1250",
    "text": "`/choisir-statut/`",
    "file": "docs/CRAWLABILITY_AUDIT.md"
  },
  {
    "id": "docs/CRAWLABILITY_AUDIT.md:1252",
    "text": "`/creer-entreprise-a-plusieurs/`",
    "file": "docs/CRAWLABILITY_AUDIT.md"
  },
  {
    "id": "docs/CRAWLABILITY_AUDIT.md:1254",
    "text": "`/creer-entreprise-demandeur-emploi/`",
    "file": "docs/CRAWLABILITY_AUDIT.md"
  },
  {
    "id": "docs/CRAWLABILITY_AUDIT.md:1253",
    "text": "`/creer-entreprise-en-etant-salarie/`",
    "file": "docs/CRAWLABILITY_AUDIT.md"
  },
  {
    "id": "docs/CRAWLABILITY_AUDIT.md:1251",
    "text": "`/creer-entreprise-seul/`",
    "file": "docs/CRAWLABILITY_AUDIT.md"
  },
  {
    "id": "docs/CRAWLABILITY_AUDIT.md:1256",
    "text": "`/dossier-creation-entreprise-bloque/`",
    "file": "docs/CRAWLABILITY_AUDIT.md"
  },
  {
    "id": "docs/CRAWLABILITY_AUDIT.md:1255",
    "text": "`/passer-micro-entreprise-en-societe/`",
    "file": "docs/CRAWLABILITY_AUDIT.md"
  },
  {
    "id": "docs/CRAWLABILITY_AUDIT.md:1258",
    "text": "`dist/diagnostic/index.html`: 56,944 bytes, 1 H1, 36 paragraphs, 26 links, JSON-LD present;",
    "file": "docs/CRAWLABILITY_AUDIT.md"
  },
  {
    "id": "docs/CRAWLABILITY_AUDIT.md:1247",
    "text": "body content depended on client-side React execution;",
    "file": "docs/CRAWLABILITY_AUDIT.md"
  },
  {
    "id": "docs/CRAWLABILITY_AUDIT.md:1248",
    "text": "metadata hook updates the browser document after React starts, which is useful for users",
    "file": "docs/CRAWLABILITY_AUDIT.md"
  },
  {
    "id": "docs/CRAWLABILITY_AUDIT.md:1257",
    "text": "The build also prerenders known auth, client and operations routes so direct navigation to",
    "file": "docs/CRAWLABILITY_AUDIT.md"
  },
  {
    "id": "docs/CRAWLABILITY_AUDIT.md:1249",
    "text": "The routing fallback also treated unknown paths as valid SPA paths. That preserved client",
    "file": "docs/CRAWLABILITY_AUDIT.md"
  },
  {
    "id": "docs/DEPLOYMENT.md:1261",
    "text": "`public/_redirects` contient la réécriture vers `index.html`. Tester directement une route telle que `/app/documents` après déploiement.",
    "file": "docs/DEPLOYMENT.md"
  },
  {
    "id": "docs/DEPLOYMENT.md:1260",
    "text": "Ajouter les variables publiques par environnement. Ne jamais ajouter les secrets Supabase serveur dans Cloudflare puisque les opérations sensibles s'exécutent dans Supabase Edge Functions.",
    "file": "docs/DEPLOYMENT.md"
  },
  {
    "id": "docs/DEPLOYMENT.md:1259",
    "text": "Créer un dépôt GitHub privé, pousser le contenu, protéger `main` et imposer les pull requests.",
    "file": "docs/DEPLOYMENT.md"
  },
  {
    "id": "docs/DISCOVERY_AND_AI_VISIBILITY.md:1266",
    "text": "`llms.txt` facilite la compréhension du site par les agents qui choisissent de le lire.",
    "file": "docs/DISCOVERY_AND_AI_VISIBILITY.md"
  },
  {
    "id": "docs/DISCOVERY_AND_AI_VISIBILITY.md:1264",
    "text": "`llms.txt` pour présenter le service, les situations pertinentes, l’offre confirmée,",
    "file": "docs/DISCOVERY_AND_AI_VISIBILITY.md"
  },
  {
    "id": "docs/DISCOVERY_AND_AI_VISIBILITY.md:1279",
    "text": "`scripts/crawlability-routes.mjs`. Le générateur l’ajoute ensuite au sitemap et la",
    "file": "docs/DISCOVERY_AND_AI_VISIBILITY.md"
  },
  {
    "id": "docs/DISCOVERY_AND_AI_VISIBILITY.md:1281",
    "text": "Après modification, exécuter :",
    "file": "docs/DISCOVERY_AND_AI_VISIBILITY.md"
  },
  {
    "id": "docs/DISCOVERY_AND_AI_VISIBILITY.md:1275",
    "text": "aucun `lastmod` artificiel : il ne sera ajouté que lorsqu’il pourra refléter de façon",
    "file": "docs/DISCOVERY_AND_AI_VISIBILITY.md"
  },
  {
    "id": "docs/DISCOVERY_AND_AI_VISIBILITY.md:1277",
    "text": "aucune donnée privée, aucun paramètre de campagne et aucune promesse invérifiable.",
    "file": "docs/DISCOVERY_AND_AI_VISIBILITY.md"
  },
  {
    "id": "docs/DISCOVERY_AND_AI_VISIBILITY.md:1273",
    "text": "aucune route de connexion, client, opérations ou authentification dans le sitemap ;",
    "file": "docs/DISCOVERY_AND_AI_VISIBILITY.md"
  },
  {
    "id": "docs/DISCOVERY_AND_AI_VISIBILITY.md:1274",
    "text": "aucune valeur `priority` ou `changefreq`, ignorée par Google ;",
    "file": "docs/DISCOVERY_AND_AI_VISIBILITY.md"
  },
  {
    "id": "docs/DISCOVERY_AND_AI_VISIBILITY.md:1262",
    "text": "Découverte publique et visibilité dans les réponses génératives",
    "file": "docs/DISCOVERY_AND_AI_VISIBILITY.md"
  },
  {
    "id": "docs/DISCOVERY_AND_AI_VISIBILITY.md:1268",
    "text": "génération : `scripts/generate-discovery-files.ts`.",
    "file": "docs/DISCOVERY_AND_AI_VISIBILITY.md"
  },
  {
    "id": "docs/DISCOVERY_AND_AI_VISIBILITY.md:1267",
    "text": "Il ne garantit ni citation, ni indexation, ni recommandation par un modèle.",
    "file": "docs/DISCOVERY_AND_AI_VISIBILITY.md"
  },
  {
    "id": "docs/DISCOVERY_AND_AI_VISIBILITY.md:1270",
    "text": "La commande est également lancée avant le serveur de développement et chaque build.",
    "file": "docs/DISCOVERY_AND_AI_VISIBILITY.md"
  },
  {
    "id": "docs/DISCOVERY_AND_AI_VISIBILITY.md:1269",
    "text": "Les fichiers publics ne doivent pas être édités manuellement. Exécuter :",
    "file": "docs/DISCOVERY_AND_AI_VISIBILITY.md"
  },
  {
    "id": "docs/DISCOVERY_AND_AI_VISIBILITY.md:1265",
    "text": "les limites et les pages de référence dans un format Markdown concis.",
    "file": "docs/DISCOVERY_AND_AI_VISIBILITY.md"
  },
  {
    "id": "docs/DISCOVERY_AND_AI_VISIBILITY.md:1263",
    "text": "Orée publie trois ressources cohérentes à la racine du domaine :",
    "file": "docs/DISCOVERY_AND_AI_VISIBILITY.md"
  },
  {
    "id": "docs/DISCOVERY_AND_AI_VISIBILITY.md:1271",
    "text": "Principes appliqués",
    "file": "docs/DISCOVERY_AND_AI_VISIBILITY.md"
  },
  {
    "id": "docs/DISCOVERY_AND_AI_VISIBILITY.md:1276",
    "text": "prix et périmètre repris depuis la configuration commerciale centrale ;",
    "file": "docs/DISCOVERY_AND_AI_VISIBILITY.md"
  },
  {
    "id": "docs/DISCOVERY_AND_AI_VISIBILITY.md:1278",
    "text": "Toute nouvelle page publique indexable doit être ajoutée à",
    "file": "docs/DISCOVERY_AND_AI_VISIBILITY.md"
  },
  {
    "id": "docs/DISCOVERY_AND_AI_VISIBILITY.md:1272",
    "text": "uniquement les pages canoniques que nous souhaitons voir indexées ;",
    "file": "docs/DISCOVERY_AND_AI_VISIBILITY.md"
  },
  {
    "id": "docs/DISCOVERY_AND_AI_VISIBILITY.md:1280",
    "text": "validation impose qu’elle soit également présente dans `llms.txt`.",
    "file": "docs/DISCOVERY_AND_AI_VISIBILITY.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1326",
    "text": "`prefers-reduced-motion` reste respecté.",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1283",
    "text": "> Cette passe est conservée pour historique. La référence active est `docs/V3_REBUILD.md` et remplace les choix visuels ci-dessous.",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1327",
    "text": "1. La promesse, l'action principale et la réassurance sont visibles immédiatement.",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1328",
    "text": "2. Les pages Google répondent à l'intention exacte avant de raconter la marque.",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1329",
    "text": "3. Le diagnostic donne de la valeur avant la demande de contact.",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1330",
    "text": "4. Les champs sont limités à l'information utile à l'étape courante.",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1331",
    "text": "5. Le produit montre un vrai espace après le formulaire.",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1332",
    "text": "6. Les coûts, responsabilités et incertitudes restent explicites.",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1333",
    "text": "7. Le mobile possède ses propres navigations et actions persistantes.",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1334",
    "text": "8. Les interactions restent rapides et compréhensibles sans animation.",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1285",
    "text": "augmenter la confiance avant la collecte de coordonnées ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1325",
    "text": "barres de progression et états qui réagissent aux choix ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1311",
    "text": "blanc et dérivés très légers ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1312",
    "text": "bleu électrique pour les actions ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1321",
    "text": "bordures plus légères que le contenu ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1304",
    "text": "champs de formulaire, focus, hover et transitions harmonisés.",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1320",
    "text": "coins cohérents entre composants ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1299",
    "text": "collecte de contact séparée de la valeur initiale ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1310",
    "text": "comportement mobile adapté aux barres d'action.",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1337",
    "text": "conserver un CTA principal dominant par écran ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1296",
    "text": "diagnostic adaptatif avec progression desktop et mobile distincte ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1340",
    "text": "exécuter `npm run check` après toute passe significative.",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1297",
    "text": "feedback visuel et transitions d'étape ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1291",
    "text": "footer éditorial et CTA final ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1318",
    "text": "glassmorphism réservé aux environnements sombres et aux overlays ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1302",
    "text": "héros métier partagés sur les pages secondaires ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1306",
    "text": "hiérarchie claire pour le traitement rapide des leads.",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1292",
    "text": "homepage entièrement recomposée ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1324",
    "text": "hover avec élévation modérée sur desktop ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1308",
    "text": "index actualisé automatiquement ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1284",
    "text": "La refonte ne consiste pas à ajouter des effets décoratifs. Chaque amélioration vise au moins un objectif :",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1313",
    "text": "La V3 interdit désormais les anciennes couleurs violet, corail et ambre.",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1307",
    "text": "launcher, panneau et résultats redessinés ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1287",
    "text": "maintenir la qualité après la page d'accueil ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1305",
    "text": "métriques, file prioritaire et segmentation ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1317",
    "text": "micro-labels en capitales espacées uniquement pour les statuts et contextes.",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1309",
    "text": "navigation et propositions directes conservées ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1301",
    "text": "navigation mobile inférieure et drawer complet ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1290",
    "text": "navigation mobile plein écran avec regroupement par besoin ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1339",
    "text": "ne pas charger GSAP ou de lourdes animations sans bénéfice mesurable ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1336",
    "text": "ne pas remplacer la palette par des gradients aléatoires ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1314",
    "text": "Newsreader Variable comme accent éditorial secondaire limité ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1293",
    "text": "pages Google Search spécialisées ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1295",
    "text": "pages légales et 404.",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1289",
    "text": "préserver performance, accessibilité et reduced motion.",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1322",
    "text": "profondeur utilisée pour indiquer la priorité, pas pour décorer chaque carte.",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1303",
    "text": "projet, orientation, associés, documents, formalités, suivi, messages, rendez-vous et paramètres ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1282",
    "text": "Rapport de refonte premium — passe V2 (archivée)",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1286",
    "text": "réduire la sensation de formulaire administratif ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1335",
    "text": "Règles pour les modifications futures",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1300",
    "text": "rendez-vous contextualisé.",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1294",
    "text": "rendez-vous public ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1288",
    "text": "rendre l'expérience crédible sur mobile, tablette et desktop ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1298",
    "text": "résultat explicable ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1323",
    "text": "reveal progressif avec blur léger ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1319",
    "text": "surfaces claires avec transparence et ombres modérées ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1316",
    "text": "textes longs limités en largeur ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1315",
    "text": "titres en graisses 600 à 700, tracking modéré et échelle fluide ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/ENHANCEMENT_REPORT.md:1338",
    "text": "toujours vérifier mobile, tablette et desktop ;",
    "file": "docs/ENHANCEMENT_REPORT.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1363",
    "text": "| Accessibilité | Fusion | diagnostic/CTA | Focus, labels, reduced motion ; E2E. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1360",
    "text": "| Analytics / consentement | Fusion | `services/analytics.ts` | Événements V4 ajoutés sans PII. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1349",
    "text": "| Animations / responsive | V3 | Motion, médias | V3 garde reduced motion/mobile variants. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1344",
    "text": "| Architecture | V3 | `app/`, `supabase/`, Vite | Aucun backend modifié ; build. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1354",
    "text": "| Dashboard / gestion projet | V3 | pages app | Hiérarchie V3 déjà renforcée. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1345",
    "text": "| Dépendances | V3 | `package.json` | Aucun ajout ; lockfile inchangé. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1347",
    "text": "| Design, typo, boutons, cartes | V3 | `styles.css`, UI | Déjà palette/tokens cibles. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1352",
    "text": "| Diagnostic / résultat | Fusion | `features/diagnostic/*` | V4 situation-first, V3 persistance ; tests unitaires. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1356",
    "text": "| Documents / formalités / suivi | V3 | pages app, repositories | Contrats backend conservés. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1343",
    "text": "| Domaine | Décision | Fichiers principaux | Impact / vérification |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1348",
    "text": "| Formulaires | Fusion | diagnostic, rendez-vous | V3 data flow, V4 ordre diagnostic. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1358",
    "text": "| Guide Orée | Fusion | knowledge/index | Nouvelles routes indexées ; génération. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1346",
    "text": "| Homepage | V3 | `HomePage`, carousel, médias | V3 plus riche ; régression build. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1364",
    "text": "| Images | V3 | `content/imagery.ts` | V4 doublons rejetés ; manifest V3. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1353",
    "text": "| Lead / rendez-vous | V3 | repositories, pages | Aucun changement Supabase. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1357",
    "text": "| Messages / notifications | V3 | pages app | V3 conserve Notifications dédiée. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1359",
    "text": "| Opérations | V3 | `pages/ops` | V3 garde Aide et Profil. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1355",
    "text": "| Orientation / associés | V3 | pages app | Pas de régression fonctionnelle. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1351",
    "text": "| Pages de situation | Fusion | `landingPages.ts` | Landing demandeur d’emploi ajoutée. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1362",
    "text": "| Performance | V3 | imagerie/asset pipeline | AVIF/WebP et code splitting conservés. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1350",
    "text": "| SASU / EURL / SAS / SARL | V3 | landing content | Contenu et héros V3 ; tests route. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1361",
    "text": "| SEO / sitemap | Fusion | metadata, sitemap | Canonical/métadonnées par landing. |",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1342",
    "text": "complément retenu ; **Prudence** = non modifié sans besoin métier confirmé.",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FEATURE_COMPARISON_MATRIX.md:1341",
    "text": "Légende : **V3** = original plus fort ; **V4** = référence plus forte ; **Fusion** =",
    "file": "docs/FEATURE_COMPARISON_MATRIX.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1393",
    "text": "| Build production Vite | Réussi |",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1390",
    "text": "| ESLint | Réussi |",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1394",
    "text": "| Historique des migrations | `0001` à `0009` synchronisées |",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1392",
    "text": "| Index du Guide | 1 673 entrées / 84 fichiers |",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1391",
    "text": "| TypeScript strict | Réussi |",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1389",
    "text": "| Vérification | Résultat |",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1404",
    "text": "1. fournir le domaine final et les URLs Auth autorisées ;",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1405",
    "text": "2. choisir le fournisseur d’e-mail et l’adresse expéditrice ;",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1406",
    "text": "3. confirmer CRM, calendrier, GTM/GA4/Ads le cas échéant ;",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1407",
    "text": "4. valider identité juridique, mentions, coordonnées, offres, tarifs et politique de",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1408",
    "text": "5. créer le premier compte équipe et l’attribuer au rôle `admin` côté serveur.",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1399",
    "text": "aucun faux conseiller, témoignage, partenaire, nombre de notifications ou délai ;",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1401",
    "text": "aucune donnée analytique publicitaire avant configuration et consentement ;",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1384",
    "text": "aucune erreur de schéma.",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1400",
    "text": "aucune invitation externe avant branchement d’un fournisseur e-mail sécurisé ;",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1402",
    "text": "aucune promotion administrateur depuis un profil éditable.",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1368",
    "text": "backend et sans affaiblir Supabase, RLS, le mode démonstration ou le système visuel.",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1413",
    "text": "couleurs, polices, gradients et décorations incompatibles avec le système V3.",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1365",
    "text": "Date : 20 juillet 2026. Application livrable : dépôt V3 canonique uniquement.",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1383",
    "text": "de revendication et de création de projet exigent un JWT. Le lint distant ne remonte",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1411",
    "text": "dépendances, lockfile ou migrations copiés sans nécessité ;",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1370",
    "text": "diagnostic enrichi pour les projets solo, à plusieurs, salariés, demandeurs d’emploi,",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1409",
    "text": "Éléments V4 rejetés",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1398",
    "text": "Éléments volontairement non simulés",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1377",
    "text": "équipe, messagerie et audit ;",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1374",
    "text": "espace client entièrement relié aux projets, documents, fondateurs, tâches, messages,",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1376",
    "text": "espace opérations relié aux leads, projets, attributions, documents, rendez-vous,",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1397",
    "text": "être testés de bout en bout qu’après création d’un compte réel et promotion contrôlée du",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1373",
    "text": "honeypot, rate limiting serveur et revendication sécurisée après authentification ;",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1381",
    "text": "Le projet distant `sksydcdkliuisaahysya` (`oree`) contient les migrations `0001` à `0009`. Les trois fonctions Edge",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1395",
    "text": "Le runtime de navigateur intégré n’était pas disponible. Aucune nouvelle inspection",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1385",
    "text": "Les avertissements génériques portant sur des fonctions `SECURITY DEFINER` ne doivent",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1387",
    "text": "limite son exécution au rôle prévu, fixe son `search_path` et contrôle l’identité, le rôle",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1380",
    "text": "métadonnées, consentement analytics, CTA mobile et contenus juridiques renforcés.",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1371",
    "text": "micro-entrepreneurs et dossiers bloqués ;",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1378",
    "text": "mutations sensibles via RPC contrôlées et stockage documentaire privé ;",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1388",
    "text": "ou l’appartenance avant mutation. Ces fonctions sont nécessaires pour effectuer des",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1386",
    "text": "pas être interprétés comme une permission ouverte : chaque RPC exposée révoque `public`,",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1379",
    "text": "politiques RLS normalisées pour le planificateur et suppression des doubles politiques",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1403",
    "text": "Prérequis avant mise en production publique",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1369",
    "text": "présentation transparente du périmètre, des honoraires, frais légaux et coûts tiers ;",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1412",
    "text": "promesses, preuves sociales, chiffres, délais ou écrans fictifs ;",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1367",
    "text": "réimplémentées dans l’architecture V3 sans copier une seconde application, sans nouveau",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1375",
    "text": "rendez-vous, profils et préférences ;",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1410",
    "text": "second backend ou responsabilités dupliquées sur Cloudflare ;",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1382",
    "text": "sont actives : la soumission publique de lead valide elle-même la requête ; les fonctions",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1372",
    "text": "soumission de lead atomique, consentement et attribution persistés, idempotence,",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1366",
    "text": "V4 a servi de référence de contenu, conversion et UX. Les améliorations ont été",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_MERGE_REPORT.md:1396",
    "text": "visuelle manuelle n’est donc revendiquée. Les parcours authentifiés distants ne pourront",
    "file": "docs/FINAL_MERGE_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1439",
    "text": "`07 87 82 32 08`. Le prérendu bloque les requêtes Google pendant la génération afin de",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1424",
    "text": "`Commencer mon dossier` conserve l’entrée dans le diagnostic ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1423",
    "text": "`Être rappelé` reste la deuxième action et réutilise le flux Supabase existant ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1459",
    "text": "`npm ci` : réussi, installation propre depuis le lockfile ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1449",
    "text": "`sent` ou `failed`. Un échec d’e-mail ne transforme jamais une création de lead réussie",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1482",
    "text": "`submit-lead` si ce n’est pas encore fait sur le projet Supabase distant ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1438",
    "text": "Ads `AW-18362621917/mQHqCLOG6tscEN2__bNE` avec le numéro",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1479",
    "text": "appareil sans déclencher de fausse conversion ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1481",
    "text": "appliquer la migration `0013_offer_and_ads_lead_workflow.sql` et redéployer",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1442",
    "text": "après consentement. `phone_click` et `whatsapp_click` restent des événements de",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1475",
    "text": "automatisée multi-navigateur reste documentée ci-dessus.",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1454",
    "text": "bloc de contact humain sans faux nom, faux portrait, faux horaires ou témoignage ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1462",
    "text": "build Vite et prérendu : réussis sur 47 routes ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1480",
    "text": "confirmer dans Google Ads la durée minimale d’appel qualifié et le statut de",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1483",
    "text": "confirmer l’identité juridique, l’adresse d’envoi, le domaine public et le partenaire",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1456",
    "text": "correction du contraste réel des liens et boutons sombres/bleus dans la cascade CSS ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1466",
    "text": "crawlabilité : 19 routes publiques contrôlées avec 6 user-agents.",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1469",
    "text": "débordement, le contraste, la conservation des paramètres d’attribution et l’unicité",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1476",
    "text": "déployer cette version sur le domaine de production ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1443",
    "text": "diagnostic ; l’appel qualifié mesuré par l’action Google Ads demeure la conversion",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1455",
    "text": "diagnostic ramené à une progression unique, une question principale et une synthèse",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1431",
    "text": "dix statuts commerciaux confirmés ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1428",
    "text": "En mode démonstration, aucune donnée personnelle ne quitte le navigateur.",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1448",
    "text": "et l’URL publique sont configurées, l’Edge Function tente l’envoi puis marque le job",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1433",
    "text": "événements lifecycle qualifié/gagné dédupliqués.",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1465",
    "text": "explicitement ignorés faute de sessions client et opérations réelles ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1430",
    "text": "forme juridique, activité, calendrier et message ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1421",
    "text": "forme utilisent cette configuration. Les anciennes mentions de prix non validé ont été",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1450",
    "text": "héros SASU plus compact, prix et périmètre visibles avant tout écran produit ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1463",
    "text": "index Guide Orée : 1 988 entrées issues de 97 fichiers, avec réponses commerciales",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1478",
    "text": "l’action d’appel Ads, puis tester le remplacement/acheminement du numéro sur un vrai",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1417",
    "text": "l’offre micro-entreprise à `100 €`, présentée en second plan ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1425",
    "text": "la barre mobile SASU donne un accès persistant au lien `tel:+33787823208`.",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1434",
    "text": "La file opérations affiche les coordonnées, le projet, la landing, la campagne, le",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1422",
    "text": "La landing SASU suit désormais une hiérarchie dédiée à la conversion par appel :",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1470",
    "text": "La suite Playwright complète tient compte des redirections d’authentification lorsque",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1472",
    "text": "landings d’acquisition, le responsive, le contraste ou le prérendu.",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1437",
    "text": "Le chargeur Google existant est réutilisé : il n’existe qu’un seul chargement de",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1416",
    "text": "le forfait société de `600 € TTC tout compris` ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1426",
    "text": "Le formulaire de rappel est mobile-first, validé par Zod et React Hook Form, protégé par",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1468",
    "text": "le formulaire de rappel, le diagnostic simplifié, le lien téléphonique, l’absence de",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1427",
    "text": "le honeypot existant et soumis par le même repository/Edge Function que le diagnostic.",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1446",
    "text": "Le lead est persisté avant toute tentative de notification. L’outbox existante reçoit",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1473",
    "text": "Le runtime du navigateur intégré n’était pas disponible pendant cette passe. Aucune",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1418",
    "text": "le téléphone, WhatsApp, l’e-mail, la disponibilité et le partenaire à affecter ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1429",
    "text": "Leads et opérations",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1467",
    "text": "Les contrôles Playwright couvrent la landing SASU à 375, 390, 430, 768 et 1 440 px,",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1441",
    "text": "Les événements publics sont typés et envoyés via l’abstraction analytics existante",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1420",
    "text": "Les pages d’accueil, tarifs, accompagnement, diagnostic et les quatre landing pages de",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1415",
    "text": "Mise à jour : 4 août 2026.",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1435",
    "text": "mot-clé, le GCLID, les relances, notes et résultats. Elle propose les liens appel,",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1440",
    "text": "ne jamais sérialiser les scripts WCM injectés dynamiquement dans le HTML statique.",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1464",
    "text": "Playwright complet : 175 tests réussis, 11 scénarios connectés",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1457",
    "text": "premier rendu du héros prérendu sans élément critique masqué par une animation.",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1444",
    "text": "principale. Les paramètres GCLID, UTM, GBRAID et WBRAID restent conservés dès l’entrée.",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1414",
    "text": "Rapport final — offre et préparation Ads",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1451",
    "text": "reçu éditorial avec les quatre inclusions exactes et total TTC ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1484",
    "text": "réellement affecté.",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1474",
    "text": "revue visuelle interactive supplémentaire n’est donc revendiquée ; la validation",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1452",
    "text": "sections de contenu passées de grilles de cartes répétitives à des compositions avec",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1453",
    "text": "séparateurs, respiration et hiérarchie éditoriale ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1471",
    "text": "Supabase est configuré. Elle ne présente aucun échec sur les routes publiques, les",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1432",
    "text": "transitions contrôlées et auditées ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1460",
    "text": "TypeScript strict : réussi ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1445",
    "text": "Un filtre supprime les clés de données personnelles des paramètres analytics.",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1419",
    "text": "un libellé fiscal configurable mais masqué.",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1447",
    "text": "un résumé, la source d’acquisition et le chemin sécurisé. Lorsque les variables Resend",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1458",
    "text": "Vérifications réalisées le 4 août 2026 :",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1477",
    "text": "vérifier dans Tag Assistant, sur le domaine réel, le chargement unique de GA4 et de",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1461",
    "text": "Vitest : 48 tests réussis sur 48 ;",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md:1436",
    "text": "WhatsApp et e-mail, ainsi que les actions qualifié, gagné, perdu et hors cible.",
    "file": "docs/FINAL_OFFER_AND_ADS_READINESS_REPORT.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1496",
    "text": "1. Portrait conseiller",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1499",
    "text": "2. Salarié préparant son projet",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1502",
    "text": "3. Projet à plusieurs",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1505",
    "text": "4. Indépendant en croissance",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1508",
    "text": "5. Documents et formalités",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1510",
    "text": "6. Activités sectorielles",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1492",
    "text": "absence de texte généré dans l'image ;",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1521",
    "text": "aucun faux écran produit, Kbis, certificat ou document pseudo-officiel n'est livré ;",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1514",
    "text": "aucun fichier lourd chargé avant interaction ou visibilité ;",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1520",
    "text": "aucun portrait n'est associé à un nom, un témoignage ou une fonction réelle ;",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1518",
    "text": "Bibliothèque intégrée",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1490",
    "text": "cadrages documentaires, souvent légèrement décentrés ;",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1494",
    "text": "contraste suffisant pour permettre une superposition de texte lorsqu'elle est prévue.",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1511",
    "text": "Créer ensuite des séries cohérentes pour : conseil/numérique, commerce, artisanat, restauration, transport et services. Chaque série doit garder le même traitement colorimétrique et le même niveau de réalisme.",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1485",
    "text": "Direction et intégration des images",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1493",
    "text": "diversité crédible de profils et d'activités en France ;",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1495",
    "text": "Emplacements recommandés",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1489",
    "text": "imperfections de peau, tissus et environnements conservées ;",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1517",
    "text": "Le produit doit rester complet sans image. Une image enrichit une section mais ne porte jamais seule une information, un CTA ou une preuve. Ne pas remplacer le cockpit, la progression ou le diagnostic par une simple photographie.",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1486",
    "text": "Les images doivent renforcer la confiance, la réalité humaine et le contexte français de création d'entreprise. Elles ne doivent jamais ressembler à des banques d'images génériques ni à des portraits IA parfaits.",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1519",
    "text": "les images humaines générées portent un libellé illustratif dans le contexte où elles pourraient être prises pour une personne réelle ;",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1522",
    "text": "les pages client et opérations restent interface-first.",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1488",
    "text": "lumière naturelle ou lumière de bureau crédible ;",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1491",
    "text": "palette compatible : encre, blanc, bleu électrique et touches menthe ;",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1487",
    "text": "photographie éditoriale réaliste ;",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1513",
    "text": "poster fixe si une séquence vidéo est ajoutée ;",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1516",
    "text": "Règle d'intégration",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1498",
    "text": "scène : conseillère française dans un bureau sobre, regard direct mais naturel, posture accessible, lumière latérale douce",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1504",
    "text": "scène : deux ou trois associés autour d'une table, échange réel, documents et gestes naturels, pas de pose publicitaire",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1509",
    "text": "scène : main, dossier, ordinateur, signature ou classement ; aucun faux document juridique lisible",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1501",
    "text": "scène : personne travaillant le soir sur un projet, environnement domestique ou coworking crédible, documents et ordinateur sans écrans illisibles",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1507",
    "text": "scène : professionnel déjà actif, commandes ou planning visibles sans données personnelles, sensation de croissance opérationnelle",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1512",
    "text": "source maître haute résolution ;",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1515",
    "text": "texte alternatif défini dans le contenu, pas dans le nom de fichier.",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1497",
    "text": "usage : accompagnement, rendez-vous, espace client",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1503",
    "text": "usage : création SAS/SARL",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1500",
    "text": "usage : page salarié et sélecteur de parcours",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_DIRECTION.md:1506",
    "text": "usage : passage micro vers société",
    "file": "docs/IMAGE_DIRECTION.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1554",
    "text": "`npm run check` — lint, TypeScript strict, 6 tests unitaires et build de production réussis ;",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1538",
    "text": "21 sources sélectionnées donnent 298 variantes AVIF/WebP après la dernière optimisation.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1543",
    "text": "Accessibilité et confiance",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1533",
    "text": "Accompagnement : scène d'explication humaine, explicitement indiquée comme illustrative.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1525",
    "text": "Accueil : `hero-home-company-journey` occupe le panneau humain du héros 55/45 ; le cockpit produit réel se superpose sans masquer la scène.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1527",
    "text": "Activités : un sélecteur interactif n'affiche qu'une scène active parmi artisanat, commerce, services terrain, restauration et logistique ; il évite de charger une galerie complète sur mobile.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1544",
    "text": "Alt text en français, spécifique au contexte.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1547",
    "text": "Aucun nom, avis, note, taux de réussite ou résultat client n'est associé aux personnes générées.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1530",
    "text": "Choix du statut : scène de décision derrière le comparateur React.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1553",
    "text": "contrôle automatisé du manifeste — 298 chemins résolus, 0 manquant ;",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1556",
    "text": "contrôle HTTP local — page d'accueil et ressource AVIF servies en `200 OK` ;",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1545",
    "text": "Dimensions intrinsèques, ratios stables et fond de chargement.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1549",
    "text": "Éléments à remplacer par de vraies photographies",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1542",
    "text": "Elle utilise Sharp localement, nettoie uniquement `public/assets/imagery/`, puis régénère les formats ouverts sans service propriétaire.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1557",
    "text": "La configuration E2E complète comporte aussi un projet Mobile Safari. Son exécution locale nécessite encore l'installation du binaire WebKit Playwright ; cet échec d'environnement ne concerne pas le code Chromium validé.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1555",
    "text": "la suite Chromium contrôle également le méga-menu, les polices, le CTA bleu, le chargement des images et l'absence de débordement horizontal aux largeurs 390, 768, 1440 et 1728 px ;",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1529",
    "text": "Landing pages : images distinctes pour SASU, EURL, SAS, SARL, salarié, activité existante et dossier bloqué. La SASU réutilise la scène quotidienne `pathway-home-founder`, plus spontanée que le portrait institutionnel initial.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1537",
    "text": "Le composant `ArtDirectedPicture` choisit les sources mobiles sous 768 px. Le conteneur fixe le ratio visuel pour éviter le déplacement de mise en page pendant le chargement.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1539",
    "text": "Le dossier public d'images pèse environ 9,6 Mo au total ; une route ne charge qu'une fraction de ce volume et les nouvelles scènes restent lazy.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1548",
    "text": "Le mode `prefers-reduced-motion` désactive les zooms, transitions et profondeurs animées.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1540",
    "text": "Le principal visuel de chaque héros est eager avec `fetchPriority=\"high\"`.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1535",
    "text": "Les 12 rejets sont documentés dans `docs/IMAGE_INVENTORY.md`. Les faux écrans produit, confirmations d'immatriculation, certificats et documents pseudo-officiels ne sont pas livrés dans `public/`.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1550",
    "text": "Les captures du produit doivent toujours provenir de l'interface React réelle. Les documents officiels devront être photographiés ou capturés uniquement avec autorisation, données masquées et contexte non trompeur.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1536",
    "text": "Les héros et scènes humaines disposent de recadrages 4:5 issus de la même source. Les points focaux sont déclarés dans `app/content/imagery.ts`. Le texte et les CTA ne sont jamais intégrés dans les pixels.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1541",
    "text": "Les images hors écran restent lazy.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1546",
    "text": "Les scènes générées sont marquées « Scène illustrative » ou « Situation illustrative ».",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1551",
    "text": "Limite de vérification dans cette session",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1532",
    "text": "Offres : la scène d'accompagnement donne un contexte humain au choix du niveau de service, sans être présentée comme une photo d'équipe réelle.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1528",
    "text": "Parcours accueil : les scènes « projet chez soi » et « associés en discussion » remplacent les visuels génériques des entrées solo et équipe.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1531",
    "text": "Processus : `process-project-organisation` forme un fond documentaire lisible dans le rail des six étapes, avec un dégradé dérivé de la palette pour préserver le texte.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1523",
    "text": "Rapport d'intégration des images",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1534",
    "text": "Rendez-vous : scène de visioconférence secondaire sur grand écran ; le sélecteur de créneau reste prioritaire.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1526",
    "text": "Sélecteur de parcours : six intentions utilisent une image dédiée et ne chargent que la scène active.",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1524",
    "text": "Sélection et placements",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INTEGRATION_REPORT.md:1552",
    "text": "Vérifications exécutées",
    "file": "docs/IMAGE_INTEGRATION_REPORT.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1559",
    "text": "| # | Fichier original | Nouveau nom sémantique | Orientation / ratio | Sujet principal | Réalisme | Confiance | Recadrage mobile | Usage prévu | Statut | Motif de rejet ou réserve |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1589",
    "text": "| `11_01_09 (1).png` | `activity-artisan-workshop` | Artisan dans son atelier | Sélecteur d'activités de l'accueil | **Sélectionné** |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1590",
    "text": "| `11_01_09 (2).png` | `activity-local-shop` | Commerçante dans un magasin de proximité | Sélecteur d'activités de l'accueil | **Sélectionné** |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1591",
    "text": "| `11_01_10 (3).png` | `activity-field-service` | Professionnelle préparant une intervention | Sélecteur d'activités de l'accueil | **Sélectionné** |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1592",
    "text": "| `11_01_10 (4).png` | `activity-restaurant-owner` | Restaurateur préparant sa salle | Sélecteur d'activités de l'accueil | **Sélectionné** |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1593",
    "text": "| `11_01_13 (5).png` | `activity-logistics` | Professionnel préparant une livraison | Sélecteur d'activités de l'accueil | **Sélectionné** |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1594",
    "text": "| `11_01_13 (6).png` | `pathway-home-founder` | Créatrice structurant son projet chez elle | Héros SASU et parcours « Je crée seul » | **Sélectionné** |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1595",
    "text": "| `11_01_14 (7).png` | `pathway-founders-discussion` | Trois porteurs discutant d'un projet | Parcours « Nous créons à plusieurs » | **Sélectionné** |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1596",
    "text": "| `11_01_14 (8).png` | `process-project-organisation` | Dossier de travail, carnet et calculatrice | Rail du processus | **Sélectionné** |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1560",
    "text": "| 01 | `17_29_07 (1).png` | `rejected-assistant-interface-overlay.webp` | Carré · 1:1 | Femme devant une interface holographique | Moyen | Faible | Moyen | — | Rejeté | Interface fictive intégrée dans l'image et rendu IA trop visible. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1561",
    "text": "| 02 | `17_29_07 (2).png` | `rejected-product-dashboard-monitor.webp` | Carré · 1:1 | Homme face à un tableau de bord | Moyen | Faible | Moyen | — | Rejeté | Faux écran produit susceptible d'être compris comme l'interface réelle. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1562",
    "text": "| 03 | `17_29_08 (3).png` | `rejected-secure-dossier-laptop.webp` | Carré · 1:1 | Ordinateur, dossiers et symbole de sécurité | Bon | Moyen | Bon | — | Rejeté | Symbole et écran inventés ; composition générique de sécurité. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1563",
    "text": "| 04 | `17_29_09 (4).png` | `alternate-document-signature-seal.webp` | Carré · 1:1 | Signature de documents | Bon | Moyen | Bon | Formalités | Alternatif | Sceau vert et mise en scène pouvant évoquer un document officiel. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1564",
    "text": "| 05 | `17_29_09 (5).png` | `rejected-adviser-security-screen.webp` | Carré · 1:1 | Femme devant un écran de sécurité | Moyen | Faible | Moyen | — | Rejeté | Faux écran produit et scène trop publicitaire. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1565",
    "text": "| 06 | `17_29_13 (6).png` | `rejected-immatriculation-screen.webp` | Carré · 1:1 | Message d'immatriculation sur écran | Moyen | Très faible | Moyen | — | Rejeté | Texte généré et confirmation administrative fictive. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1566",
    "text": "| 09 | `17_29_14 (8).png` | `alternate-guidance-portrait-woman.webp` | Portrait · 3:4 | Portrait féminin en bureau | Bon | Moyen | Excellent | Accompagnement | Alternatif | Pose frontale et rendu légèrement retouché. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1567",
    "text": "| 10 | `17_29_14 (9).png` | `alternate-founder-portrait-man.webp` | Portrait · 3:4 | Entrepreneur devant un ordinateur | Bon | Moyen | Excellent | Cas de figure | Alternatif | Pose frontale trop proche d'un témoignage client. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1568",
    "text": "| 11 | `17_29_17 (1).png` | `rejected-employee-fake-platform.webp` | Paysage · 4:3 | Femme travaillant devant un ordinateur | Bon | Faible | Bon | — | Rejeté | Écran fictif lisible et documents générés au premier plan. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1569",
    "text": "| 12 | `17_29_17 (2).png` | `rejected-founder-fake-tablet.webp` | Paysage · 4:3 | Homme utilisant une tablette | Bon | Faible | Bon | — | Rejeté | Interface inventée présentée comme un produit réel. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1570",
    "text": "| 13 | `17_29_17 (3).png` | `rejected-consultation-product-sheets.webp` | Paysage · 4:3 | Échange entre une accompagnante et un créateur | Très bon | Faible | Bon | — | Rejeté | Feuilles comportant une fausse interface produit visible. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1571",
    "text": "| 14 | `17_29_17 (4).png` | `rejected-document-dashboard-still-life.webp` | Paysage · 4:3 | Dossier, écran et graphiques | Bon | Faible | Moyen | — | Rejeté | Documents et tableau de bord inventés, trop précis pour un décor. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1572",
    "text": "| 16 | `17_29_17 (6).png` | `alternate-project-reception.webp` | Paysage · 4:3 | Porteur de dossier à un accueil | Bon | Moyen | Moyen | Formalités | Alternatif | Lieu générique pouvant être confondu avec un guichet administratif réel. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1573",
    "text": "| 17 | `17_29_17 (7).png` | `rejected-fake-official-certificate.webp` | Paysage · 4:3 | Certificat tenu en main | Bon | Très faible | Bon | — | Rejeté | Faux document officiel, tampons et texte pseudo-administratif. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1574",
    "text": "| 19 | `17_29_17 (9).png` | `alternate-adviser-portrait-woman-navy.webp` | Portrait · 3:4 | Portrait féminin en veste | Bon | Moyen | Excellent | Accompagnement | Alternatif | Trop proche d'une photo d'équipe non réelle. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1575",
    "text": "| 20 | `17_29_18 (10).png` | `rejected-founder-dashboard-portrait.webp` | Portrait · 3:4 | Entrepreneur devant des écrans | Moyen | Faible | Bon | — | Rejeté | Faux tableaux de bord visibles et portrait fortement retouché. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1576",
    "text": "| 21 | `17_31_34 (1).png` | `rejected-wide-workflow-screen.webp` | Large · 8:5 | Bureau de nuit et workflow sur écran | Bon | Faible | Bon | — | Rejeté | Faux écran produit dominant, malgré un bon espace négatif. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1577",
    "text": "| 22 | `17_31_35 (2).png` | `pathway-solo-founder.webp` | Large · 8:5 | Créateur seul prenant des notes | Très bon | Bon | Très bon | Parcours « Je crée seul » | **Sélectionné** | Espace négatif utile et geste de travail crédible. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1578",
    "text": "| 23 | `17_31_36 (3).png` | `alternate-solo-document-review.webp` | Large · 8:5 | Créateur seul relisant une feuille | Très bon | Bon | Très bon | EURL / solo | Alternatif | Proche visuellement de plusieurs scènes solo déjà retenues. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1579",
    "text": "| 26 | `17_31_39 (6).png` | `support-remote-appointment.webp` | Paysage · 4:3 | Échange en visioconférence | Bon | Bon | Bon | Rendez-vous | **Sélectionné** | Échange crédible ; texte de fond rendu illisible par les variantes optimisées. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1580",
    "text": "| 28 | `17_31_41 (8).png` | `hero-sarl-organised-team.webp` | Paysage · 4:3 | Trois personnes organisant un projet | Bon | Bon | Bon | SARL | **Sélectionné** | Gouvernance collective lisible ; scène utilisée comme illustration uniquement. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1581",
    "text": "| 31 | `17_42_58 (1).png` | `hero-employee-transition.webp` | Large · 8:5 | Créateur préparant son projet au calme | Très bon | Bon | Très bon | Salarié en transition | **Sélectionné** | Préparation progressive, sans cliché de démission. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1582",
    "text": "| 32 | `17_42_58 (2).png` | `hero-eurl-structured-founder.webp` | Large · 8:5 | Entrepreneur seul structurant son activité | Très bon | Bon | Très bon | EURL | **Sélectionné** | Organisation et contrôle ; documents suffisamment discrets. |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1588",
    "text": "| Fichier original | Nom sémantique | Sujet principal | Usage prévu | Statut |",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1584",
    "text": "10 alternatives conservées uniquement dans le dossier source hors production.",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1585",
    "text": "12 images rejetées, principalement pour faux écrans, faux documents officiels ou manque de confiance.",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1583",
    "text": "21 images sélectionnées et publiées en variantes AVIF/WebP.",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1587",
    "text": "Ajouts activité — 23 juillet 2026",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1586",
    "text": "Aucun portrait n'est utilisé comme faux témoignage, client ou membre d'équipe.",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1597",
    "text": "Ces scènes représentent des situations illustratives. Elles ne sont associées à aucun nom, témoignage ou rôle réel.",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMAGE_INVENTORY.md:1558",
    "text": "Inventaire des images Orée",
    "file": "docs/IMAGE_INVENTORY.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1716",
    "text": "`0014_callback_request_visibility.sql` appliquées et enregistrées dans l’historique ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1602",
    "text": "`0014` sont appliquées, les fonctions `submit-lead`, `claim-lead` et `create-project`",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1694",
    "text": "`callback_request` et `whatsapp_click` reliés à l’abstraction analytics existante ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1695",
    "text": "`npm ci`, ESLint, TypeScript strict, 48 tests Vitest et build/prérendu réussis ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1712",
    "text": "`npm run check` réussi : ESLint, TypeScript strict, 51 tests Vitest, build et prérendu",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1719",
    "text": "`submit_lead_bundle` et un administrateur actif présents ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1717",
    "text": "`submit-lead` redéployée avec la notification explicite « Demande de rappel » ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1727",
    "text": "`submit-lead`, `claim-lead` et `create-project` redéployées avec un helper CORS qui ne",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1713",
    "text": "4 scénarios Playwright ciblés réussis dans Chromium et Mobile Safari pour le visuel",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1607",
    "text": "accueil, tarifs, accompagnement, diagnostic et landings de forme alignés ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1692",
    "text": "appel Ads `AW-18362621917/mQHqCLOG6tscEN2__bNE`, numéro `07 87 82 32 08` ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1667",
    "text": "bout nécessite au moins un compte réel.",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1672",
    "text": "build et prérendu : 47 routes réussies ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1658",
    "text": "build Vite de production : réussi ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1632",
    "text": "calendrier mensuel et demandes de rendez-vous ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1714",
    "text": "captures locales inspectées pour le héros SASU et la file opérations en mode démo.",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1723",
    "text": "cause observée en production : l’Edge Function renvoyait `Access-Control-Allow-Origin:",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1625",
    "text": "centre de pilotage, projet et progression réels ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1628",
    "text": "checklist documentaire, upload privé et téléchargement par URL signée courte ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1679",
    "text": "client ou opérations réelle ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1710",
    "text": "compatibilité vérifiée avec un frontend livré avant la migration `0014` ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1681",
    "text": "Configuration externe restant à fournir",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1691",
    "text": "configuration Google existante réutilisée : un chargeur, GA4 `G-FL6QMMYVLM`, action",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1693",
    "text": "conservation de GCLID/UTM vérifiée et événements diagnostiques `phone_click`,",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1637",
    "text": "contrôle documentaire ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1674",
    "text": "contrôlées et tests de routage par intention ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1685",
    "text": "conversions qualifiées ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1722",
    "text": "Correction CORS du 5 août 2026",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1675",
    "text": "crawlabilité : 19 routes publiques contrôlées avec 6 user-agents ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1696",
    "text": "crawlabilité réussie sur 19 routes et 6 user-agents ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1683",
    "text": "CRM/webhook éventuel ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1663",
    "text": "de test n’a été conservé. L’endpoint `submit-lead` accepte désormais les demandes",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1708",
    "text": "demande de rappel persistée par la migration additive `0014`, triée en priorité et",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1612",
    "text": "demandes de rappel persistées explicitement, prioritaires et signalées dans `/ops/leads` ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1715",
    "text": "Déploiement Supabase du 4 août 2026",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1647",
    "text": "Design et accessibilité",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1616",
    "text": "diagnostic adaptatif, déterministe, versionné et explicable ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1652",
    "text": "document, faux écran produit, témoignage ou partenariat.",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1711",
    "text": "Edge Function distante joignable : le smoke test honeypot a répondu `202` sans créer",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1721",
    "text": "endpoint public vérifié via honeypot : réponse `202`, sans écriture de données.",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1640",
    "text": "équipe et rôles administrés par RPC contrôlée ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1670",
    "text": "ESLint et TypeScript strict : réussis ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1624",
    "text": "Espace client connecté",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1635",
    "text": "Espace opérations connecté",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1707",
    "text": "et optimisée, avec recadrages desktop et mobile ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1598",
    "text": "État d’implémentation — V3 canonique",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1650",
    "text": "états vide, chargement, erreur et succès sur les parcours connectés ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1654",
    "text": "étincelles, baguette magique, halo pulsant ou promesse d’intelligence artificielle.",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1610",
    "text": "événements de conversion typés, dédupliqués et filtrés contre les données",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1611",
    "text": "file leads enrichie pour l’attribution Ads, les relances, notes, motifs et résultats ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1600",
    "text": "fonction par fonction ; V4 n’est ni une seconde application ni une cible de déploiement.",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1627",
    "text": "fondateurs et répartition du capital enregistrés dans le dossier ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1629",
    "text": "formalités dérivées du stade, des pièces et des tâches réelles ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1725",
    "text": "formulaire de rappel avant toute écriture ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1609",
    "text": "formulaire de rappel court soumis par l’Edge Function sécurisée existante ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1682",
    "text": "fournisseur de calendrier externe si synchronisation bidirectionnelle souhaitée ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1638",
    "text": "gestion des demandes de rendez-vous ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1673",
    "text": "Guide Orée : 1 931 entrées issues de 96 fichiers, avec réponses commerciales",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1621",
    "text": "Guide Orée local, vocal lorsque disponible, indexé depuis les contenus versionnés ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1653",
    "text": "Guide Orée présenté comme un outil sobre de recherche et de navigation, sans robot,",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1659",
    "text": "historique distant : migrations `0001` à `0012` synchronisées ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1724",
    "text": "http://localhost:5173` à l’origine `https://oree.optimutech.fr`, ce qui bloquait le",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1690",
    "text": "humain, sans faux témoignage, faux membre d’équipe ou faux horaire ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1686",
    "text": "identité juridique, mentions légales, libellé fiscal et politique de confidentialité",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1651",
    "text": "imagerie centralisée dans `app/content/imagery.ts`, optimisée AVIF/WebP et sans faux",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1657",
    "text": "index Guide Orée : 1 685 entrées issues de 84 fichiers ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1669",
    "text": "installation propre `npm ci` : réussie ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1703",
    "text": "interactive via le navigateur intégré n’est revendiquée. Une vérification Tag Assistant",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1649",
    "text": "interfaces mobile-first, navigation dédiée et barre de conversion sans chevauchement ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1645",
    "text": "l’affectation. Un client ne peut pas se promouvoir, valider ses propres documents ou",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1661",
    "text": "La procédure d’intake `submit_lead_bundle` a aussi été exécutée dans une",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1689",
    "text": "landing SASU reconstruite autour de l’appel, du rappel et d’un design éditorial plus",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1599",
    "text": "Le dépôt V3 est l’application canonique. Les apports utiles de V4 ont été intégrés",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1701",
    "text": "Le navigateur intégré n’était pas disponible pendant cette passe. La validation",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1601",
    "text": "Le projet Supabase `sksydcdkliuisaahysya` (`oree`) est lié et actif. Les migrations `0001` à",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1665",
    "text": "Le runtime de navigateur intégré n’était pas disponible pendant cette passe : aucune",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1639",
    "text": "messagerie client et notes internes ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1631",
    "text": "messagerie projet avec état de lecture par utilisateur ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1605",
    "text": "micro-entreprise à 100 € ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1613",
    "text": "migration additive avec RLS pour les notes et événements lifecycle ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1623",
    "text": "mode démonstration complet lorsque Supabase n’est pas configuré.",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1646",
    "text": "modifier directement le stade opérationnel de son projet.",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1633",
    "text": "notifications calculées depuis les données du dossier ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1688",
    "text": "offre centrale harmonisée sur `600 € TTC tout compris` avec les quatre inclusions",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1603",
    "text": "Offre commerciale et acquisition Ads",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1606",
    "text": "offre société active pour SASU, EURL, SAS et SARL, sans supplément selon la forme ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1626",
    "text": "orientation issue du projet et du diagnostic lié ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1615",
    "text": "pages d’acquisition par intention, contenus SEO et sitemap cohérents ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1648",
    "text": "palette limitée à l’encre, au blanc, au bleu électrique et à la menthe ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1644",
    "text": "passent par des fonctions SQL contrôlées qui vérifient l’utilisateur, le rôle et/ou",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1636",
    "text": "pilotage des projets et changements de stade contrôlés ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1614",
    "text": "plan de première campagne Search SASU documenté dans `docs/ADS_READINESS_PLAN.md`.",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1677",
    "text": "Playwright ciblé Guide Orée et compositions mobiles : 7 scénarios réussis dans",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1676",
    "text": "Playwright ciblé offre et rappel mobile : 12 tests réussis sur 12 dans Chromium et",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1678",
    "text": "Playwright complet : 159 tests réussis et 11 scénarios connectés ignorés sans session",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1697",
    "text": "Playwright complet : 175 tests réussis, 11 scénarios authentifiés ignorés sans comptes",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1706",
    "text": "portrait SASU remplacé par la scène quotidienne `pathway-home-founder`, déjà auditée",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1729",
    "text": "préflight production confirmé avec l’origine attendue ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1641",
    "text": "profil opérationnel réel, séparé du rôle interne.",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1634",
    "text": "profil, disponibilités, préférences et demandes relatives aux données.",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1608",
    "text": "quatre actions d’acquisition : démarrage, rappel, téléphone et WhatsApp ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1642",
    "text": "rafraîchissement de la file des demandes et du cockpit toutes les 15 secondes pour",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1698",
    "text": "réels, aucun échec ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1728",
    "text": "renvoie jamais une origine différente lorsqu’une requête est refusée ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1618",
    "text": "reprise sécurisée du lead après authentification ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1699",
    "text": "responsive SASU vérifié à 375, 390, 430, 768 et 1 440 px dans Chromium et Mobile",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1666",
    "text": "revue visuelle manuelle supplémentaire n’est revendiquée. Le test authentifié de bout en",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1700",
    "text": "Safari, avec contrôles de contraste, débordement, CTA, téléphone et rappel.",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1731",
    "text": "SASU créé avec `callback_requested = true`, puis suppression vérifiée du seul lead",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1726",
    "text": "secret `ALLOWED_ORIGINS` mis à jour pour inclure localhost et le domaine de production ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1709",
    "text": "signalée dans `/ops/leads` avec accès direct au téléphone, WhatsApp et e-mail ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1622",
    "text": "sitemap, robots et `llms.txt` générés depuis les routes canoniques et l’offre centrale ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1730",
    "text": "soumission réelle de vérification confirmée : réponse `201`, claim token émis et lead",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1620",
    "text": "soumission sans captcha externe, protégée par honeypot invisible et rate limiting",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1604",
    "text": "source typée unique pour le forfait société à 600 € TTC tout compris et la création de",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1630",
    "text": "suivi chronologique ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1704",
    "text": "sur le domaine réellement déployé reste nécessaire avant activation Google Ads.",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1732",
    "text": "synthétique (`0` restant).",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1619",
    "text": "téléphone facultatif sauf demande de rappel ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1720",
    "text": "test transactionnel annulé : une demande SASU avec rappel est marquée",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1680",
    "text": "tests authentifiés réels : toujours conditionnés à la fourniture de comptes client et",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1643",
    "text": "Toutes les lectures restent filtrées par RLS. Les changements opérationnels sensibles",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1662",
    "text": "transaction annulée sur le projet distant : l’écriture est valide et aucun lead",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1660",
    "text": "trois Edge Functions : état `ACTIVE`.",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1617",
    "text": "valeur fournie avant création de compte ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1684",
    "text": "validation Tag Assistant sur le domaine déployé et conventions d’import des",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1664",
    "text": "valides sans variable captcha, tout en rejetant les honeypots et les envois répétés.",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1718",
    "text": "vérification distante : champ `leads.callback_requested`, procédure",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1655",
    "text": "Vérifications du 22 juillet 2026",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1668",
    "text": "Vérifications du 30 juillet 2026",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1687",
    "text": "Vérifications du 4 août 2026 — landing SASU et suivi des appels",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1705",
    "text": "Vérifications du 4 août 2026 — visuel SASU et file de rappel",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1702",
    "text": "visuelle est donc fondée sur les rendus de test et la matrice Playwright ; aucune revue",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1656",
    "text": "Vitest : 26 tests réussis sur 26 ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/IMPLEMENTATION_STATUS.md:1671",
    "text": "Vitest : 47 tests réussis sur 47 ;",
    "file": "docs/IMPLEMENTATION_STATUS.md"
  },
  {
    "id": "docs/MASTER_ARCHITECTURE.md:1737",
    "text": "└─ opérations sensibles ────────── Supabase Edge Functions",
    "file": "docs/MASTER_ARCHITECTURE.md"
  },
  {
    "id": "docs/MASTER_ARCHITECTURE.md:1736",
    "text": "├─ documents ───────────────────── Supabase Storage privé",
    "file": "docs/MASTER_ARCHITECTURE.md"
  },
  {
    "id": "docs/MASTER_ARCHITECTURE.md:1735",
    "text": "├─ données autorisées ──────────── Supabase Data API + RLS",
    "file": "docs/MASTER_ARCHITECTURE.md"
  },
  {
    "id": "docs/MASTER_ARCHITECTURE.md:1734",
    "text": "├─ pages publiques / diagnostic ── Cloudflare Pages",
    "file": "docs/MASTER_ARCHITECTURE.md"
  },
  {
    "id": "docs/MASTER_ARCHITECTURE.md:1733",
    "text": "Architecture technique maître",
    "file": "docs/MASTER_ARCHITECTURE.md"
  },
  {
    "id": "docs/MASTER_ARCHITECTURE.md:1745",
    "text": "bucket `project-documents` privé ;",
    "file": "docs/MASTER_ARCHITECTURE.md"
  },
  {
    "id": "docs/MASTER_ARCHITECTURE.md:1739",
    "text": "Cloudflare sert vite un frontend statique mondial. Supabase reste l'unique autorité backend, ce qui évite de disperser secrets, validations et règles métier entre plusieurs runtimes.",
    "file": "docs/MASTER_ARCHITECTURE.md"
  },
  {
    "id": "docs/MASTER_ARCHITECTURE.md:1741",
    "text": "code splitting par route à renforcer lors de l'intégration finale ;",
    "file": "docs/MASTER_ARCHITECTURE.md"
  },
  {
    "id": "docs/MASTER_ARCHITECTURE.md:1746",
    "text": "Edge Functions pour lead public, création transactionnelle, liaison de lead, notifications, CRM et conversions ;",
    "file": "docs/MASTER_ARCHITECTURE.md"
  },
  {
    "id": "docs/MASTER_ARCHITECTURE.md:1750",
    "text": "Frontière de confiance",
    "file": "docs/MASTER_ARCHITECTURE.md"
  },
  {
    "id": "docs/MASTER_ARCHITECTURE.md:1742",
    "text": "pas de dépendance à un CMS pour la première version.",
    "file": "docs/MASTER_ARCHITECTURE.md"
  },
  {
    "id": "docs/MASTER_ARCHITECTURE.md:1743",
    "text": "PostgreSQL comme source de vérité ;",
    "file": "docs/MASTER_ARCHITECTURE.md"
  },
  {
    "id": "docs/MASTER_ARCHITECTURE.md:1738",
    "text": "Pourquoi cette séparation",
    "file": "docs/MASTER_ARCHITECTURE.md"
  },
  {
    "id": "docs/MASTER_ARCHITECTURE.md:1748",
    "text": "Projet Supabase distinct, fausses données, Cloudflare branch `develop`.",
    "file": "docs/MASTER_ARCHITECTURE.md"
  },
  {
    "id": "docs/MASTER_ARCHITECTURE.md:1749",
    "text": "Projet Supabase européen, données réelles, branche `main`, secrets dédiés, sauvegardes et monitoring.",
    "file": "docs/MASTER_ARCHITECTURE.md"
  },
  {
    "id": "docs/MASTER_ARCHITECTURE.md:1740",
    "text": "Radix/shadcn à ajouter sélectivement si un composant complexe le justifie ;",
    "file": "docs/MASTER_ARCHITECTURE.md"
  },
  {
    "id": "docs/MASTER_ARCHITECTURE.md:1744",
    "text": "RLS pour chaque table exposée ;",
    "file": "docs/MASTER_ARCHITECTURE.md"
  },
  {
    "id": "docs/MASTER_ARCHITECTURE.md:1747",
    "text": "staging et production séparés.",
    "file": "docs/MASTER_ARCHITECTURE.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1769",
    "text": "**Le système visuel V3 est conservé** : il applique déjà exactement la palette cible,",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1763",
    "text": "**V3 reste l’autorité** pour Supabase, Auth, RLS, Storage, Edge Functions,",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1766",
    "text": "**V4 est retenue comme référence sélective** pour le démarrage du diagnostic par la",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1754",
    "text": "`_merge_reference/` comme l’indique le brief). Elle est traitée uniquement comme une",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1768",
    "text": "`/tarifs`, les événements de conversion et le filtrage de l’intention",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1762",
    "text": "`app/components/marketing/DynamicHeroCarousel.tsx` corrige le défilement des onglets",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1758",
    "text": "| Base | Commande | Résultat |",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1760",
    "text": "| Référence V4 | `npm run check` | Vérification de 44 assets, ESLint, TypeScript, 8 tests et build : réussis ; index Guide : 1 698 entrées / 71 fichiers. |",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1759",
    "text": "| V3 canonique | `npm run check` | ESLint, TypeScript, 6 tests et build : réussis ; index Guide : 1 400 entrées / 71 fichiers. |",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1775",
    "text": "changement de table, enum, policy RLS, bucket, trigger ou Edge Function n’est nécessaire",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1764",
    "text": "configuration de déploiement, mode démonstration, images optimisées, navigation app",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1751",
    "text": "Date : 20 juillet 2026. Dépôt canonique : `oree-company-platform-v3`.",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1756",
    "text": "déployable. Aucun fichier d’environnement, lockfile, migration, fonction Edge ou",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1761",
    "text": "Deux changements locaux préexistants sont conservés sans écrasement :",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1772",
    "text": "doublons moins optimisés.",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1765",
    "text": "et opérations, récupération de mot de passe et écrans Notifications/Aide/Profil.",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1777",
    "text": "événements analytics ne contiennent ni e-mail, ni téléphone, ni contenu libre.",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1753",
    "text": "La référence V4 est présente localement dans `oree-company-platform-v4/` (et non dans",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1778",
    "text": "La référence V4 ne doit pas être publiée, installée ou fusionnée en bloc. Elle demeure",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1757",
    "text": "Les deux applications ont été contrôlées avant toute modification :",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1773",
    "text": "Les migrations V3 et V4 ont les mêmes familles `0001` à `0004`. V3 contient en plus la",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1770",
    "text": "Onest/Newsreader, le header flottant, les composants média art-directed et les",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1752",
    "text": "Périmètre et méthode",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1776",
    "text": "pour les améliorations retenues : elles consomment les contrats frontend existants. Les",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1767",
    "text": "situation, la branche dossier bloqué, la route demandeur d’emploi, l’alias SEO",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1755",
    "text": "source de comparaison : elle n’est ni importée par Vite, ni utilisée comme application",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1774",
    "text": "surface applicative et les protections opérationnelles actuellement utilisées. Aucun",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1779",
    "text": "un dossier de travail local à conserver jusqu’à validation complète de la fusion.",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_AUDIT.md:1771",
    "text": "variantes mobile AVIF/WebP. Les assets WebP V4 sont donc rejetés pour éviter des",
    "file": "docs/MERGE_AUDIT.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1782",
    "text": "`/creer-entreprise-demandeur-emploi`, contenu dédié, parcours diagnostic",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1790",
    "text": "| Audit | Documents de décision et baseline | Aucun | Les deux `npm run check` réussissent. |",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1793",
    "text": "| Conversion | Événements sans PII et sortie micro-entreprise officielle | Aucun | Tests TypeScript et inspection des appels. |",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1792",
    "text": "| Diagnostic | Situation initiale, branche bloquée, résultat prudent et reprise locale | Faible : stockage navigateur seulement | Tests unitaires de l’ordre des étapes et du moteur. |",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1789",
    "text": "| Phase | Travail | Risque backend | Vérification |",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1794",
    "text": "| Régression | Contrôle final de V3 | Aucun | `npm run check`, puis E2E si exécutable. |",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1791",
    "text": "| Routage/SEO | Alias tarifs et landing demandeur d’emploi, sitemap et index Guide | Aucun | Test des routes, métadonnées uniques. |",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1781",
    "text": "2. Ajouter les éléments V4 qui complètent réellement V3 : routes `/tarifs` et",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1783",
    "text": "3. Réemployer les primitives, styles et images V3 ; aucune copie de composants ou",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1785",
    "text": "4. Mettre à jour le sitemap, l’index Guide et les tests route/diagnostic.",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1786",
    "text": "5. Vérifier lint, TypeScript, tests, build et les tests E2E disponibles. Les inspections",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1796",
    "text": "canonique possède une intégration visuelle et média plus riche, déjà cohérente.",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1797",
    "text": "Copie des images V4 : V3 propose les mêmes intentions avec variants responsive,",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1784",
    "text": "d’assets V4 ne sera faite lorsqu’un équivalent V3 est plus complet.",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1787",
    "text": "de navigateur locales restent à rejouer si les binaires Playwright ne sont pas",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1780",
    "text": "Décisions exécutables",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1795",
    "text": "Éléments explicitement non retenus",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1798",
    "text": "manifest centralisé et disclosure illustratif.",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1788",
    "text": "Phases et critères de validation",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1799",
    "text": "Simplifications V4 d’Auth, Notifications et opérations : elles feraient perdre des",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/MERGE_PLAN.md:1800",
    "text": "Toute migration ou dépendance V4 : aucune ne résout un besoin que V3 ne couvre pas.",
    "file": "docs/MERGE_PLAN.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1828",
    "text": "`submit_lead_bundle` reste exécutable uniquement par `service_role` ;",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1822",
    "text": "| `assigned_partner_id` | `leads.assigned_advisor_id`, relié aux rôles internes contrôlés |",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1816",
    "text": "| Analytics | Service typé et consentement déjà présents | Ajouter les événements Ads manquants, filtrage PII et déduplication |",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1821",
    "text": "| Besoin commercial | Autorité V3 |",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1818",
    "text": "| Consentement | Choix nécessaire/analytics/marketing versionné | Conserver tel quel |",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1811",
    "text": "| Contact | Téléphone, SMS, e-mail et WhatsApp déjà centralisés | Dériver les liens de la configuration commerciale et ajouter les quatre actions acquisition |",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1824",
    "text": "| Événements qualifié/gagné | `lead_lifecycle_events`, clé d’idempotence unique |",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1812",
    "text": "| Formulaire public | Diagnostic complet sécurisé | Le conserver et ajouter un formulaire de rappel court utilisant le même repository |",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1813",
    "text": "| Leads Supabase | Contacts, attribution normalisée, statut, score, affectation | Étendre par migration additive pour forme, activité, relance, motifs, notes et résultat |",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1823",
    "text": "| Notes | `lead_notes`, lecture RLS et écriture via RPC |",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1817",
    "text": "| Notifications | Outbox `notification_jobs` existante | Enrichir le payload et tenter l’envoi après persistance, sans faire échouer le lead |",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1815",
    "text": "| Opérations | Qualification, score et affectation | Ajouter mot-clé, GCLID, landing, actions directes, notes, relance et résultats |",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1810",
    "text": "| Pages SASU/EURL/SAS/SARL | Intention SEO correcte, offre absente | Titre spécifique + même forfait central |",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1809",
    "text": "| Routes publiques | `/tarifs`, les quatre pages de forme, l’accompagnement et le diagnostic existaient | Conserver les routes et adapter le contenu |",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1814",
    "text": "| Sécurité lead | Edge Function, service role serveur, RLS, honeypot, rate limiting et idempotence | Conserver sans policy d’insert anonyme |",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1808",
    "text": "| Surface | Avant l’intégration | Décision |",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1806",
    "text": "actions prévues pour le trafic payant, et le modèle opérations utilisait une nomenclature",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1827",
    "text": "aucune clé `service_role` n’est utilisée par le navigateur ;",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1801",
    "text": "Audit d’intégration de l’offre commerciale",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1825",
    "text": "Ce mapping évite deux autorités concurrentes pour l’attribution et l’affectation.",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1807",
    "text": "commerciale antérieure.",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1833",
    "text": "identifiant réel du partenaire affecté ;",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1804",
    "text": "L’écart principal était éditorial : `/tarifs` et plusieurs composants indiquaient encore",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1830",
    "text": "l’envoi d’e-mail intervient après la transaction de création du lead ;",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1802",
    "text": "Le dépôt V3 disposait déjà des fondations nécessaires : routes d’acquisition, diagnostic",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1832",
    "text": "le mode démonstration ne transmet aucune donnée personnelle.",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1820",
    "text": "Le schéma reste normalisé. Les noms demandés sont pris en charge ainsi :",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1831",
    "text": "les événements analytics ne reçoivent ni nom, ni e-mail, ni téléphone, ni message libre ;",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1829",
    "text": "les notes et événements lifecycle ont RLS activée et aucun droit d’écriture navigateur ;",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1819",
    "text": "Mapping du modèle existant",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1803",
    "text": "mode démonstration et espace opérations. L’intégration ne nécessite ni reconstruction ni",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1826",
    "text": "Points de sécurité confirmés",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1805",
    "text": "que le montant n’était pas validé. Les landing pages n’exposaient pas non plus les quatre",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/OFFER_INTEGRATION_AUDIT.md:1834",
    "text": "vérification Tag Assistant sur le domaine de production ;",
    "file": "docs/OFFER_INTEGRATION_AUDIT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1845",
    "text": "→ coordonnées / rendez-vous / sauvegarde",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1846",
    "text": "→ création du compte",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1844",
    "text": "→ diagnostic sans compte",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1847",
    "text": "→ documents et échanges",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1848",
    "text": "→ résultat commercial qualifié",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1851",
    "text": "activité existante : planifier la transition ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1853",
    "text": "blocage : faire vérifier le dossier.",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1865",
    "text": "calendrier tiers réel ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1866",
    "text": "comptabilité et facturation ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1858",
    "text": "connexion/inscription démo ou Supabase ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1842",
    "text": "création à plusieurs ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1856",
    "text": "diagnostic adaptatif ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1861",
    "text": "données réalistes ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1859",
    "text": "espace client complet ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1860",
    "text": "espace opérations ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1854",
    "text": "expérience publique complète ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1863",
    "text": "génération juridique automatique définitive ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1838",
    "text": "Google Search est le moteur commercial initial. Chaque groupe d'intention reçoit une page dédiée :",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1864",
    "text": "intégration CRM précise ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1843",
    "text": "La page doit reprendre exactement le vocabulaire de la recherche et conduire au bon état du diagnostic.",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1836",
    "text": "La promesse centrale est la clarté et le suivi, pas un simple formulaire administratif.",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1841",
    "text": "micro-entrepreneur qui passe en société ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1837",
    "text": "Modèle d'acquisition",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1855",
    "text": "neuf entrées d'acquisition ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1835",
    "text": "Orée est le centre de contrôle d'un projet de création de société : comprendre, choisir les structures à comparer, préparer les informations, centraliser les documents, échanger avec un conseiller et suivre les formalités.",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1852",
    "text": "plusieurs fondateurs : inviter les associés ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1849",
    "text": "projet sous 30 jours : commencer le dossier ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1857",
    "text": "réservation de démonstration ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1850",
    "text": "salarié : sauvegarder la feuille de route ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1840",
    "text": "salarié qui prépare une transition ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1839",
    "text": "SASU ou EURL / choix du statut ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/PRODUCT_BLUEPRINT.md:1862",
    "text": "transmission réelle au Guichet unique ;",
    "file": "docs/PRODUCT_BLUEPRINT.md"
  },
  {
    "id": "docs/QA_CHECKLIST.md:1883",
    "text": "attribution stockée ;",
    "file": "docs/QA_CHECKLIST.md"
  },
  {
    "id": "docs/QA_CHECKLIST.md:1877",
    "text": "aucun rôle admin auto-attribué.",
    "file": "docs/QA_CHECKLIST.md"
  },
  {
    "id": "docs/QA_CHECKLIST.md:1882",
    "text": "bundles app/ops séparés à optimiser ;",
    "file": "docs/QA_CHECKLIST.md"
  },
  {
    "id": "docs/QA_CHECKLIST.md:1875",
    "text": "client incapable de valider un document ;",
    "file": "docs/QA_CHECKLIST.md"
  },
  {
    "id": "docs/QA_CHECKLIST.md:1876",
    "text": "conseiller incapable d'accéder à un projet non attribué ;",
    "file": "docs/QA_CHECKLIST.md"
  },
  {
    "id": "docs/QA_CHECKLIST.md:1870",
    "text": "coordonnées validées ;",
    "file": "docs/QA_CHECKLIST.md"
  },
  {
    "id": "docs/QA_CHECKLIST.md:1868",
    "text": "diagnostic complet sur mobile ;",
    "file": "docs/QA_CHECKLIST.md"
  },
  {
    "id": "docs/QA_CHECKLIST.md:1885",
    "text": "durées de conservation configurées.",
    "file": "docs/QA_CHECKLIST.md"
  },
  {
    "id": "docs/QA_CHECKLIST.md:1880",
    "text": "état synchronisé dans la timeline.",
    "file": "docs/QA_CHECKLIST.md"
  },
  {
    "id": "docs/QA_CHECKLIST.md:1871",
    "text": "Guide Orée retrouve pages et actions.",
    "file": "docs/QA_CHECKLIST.md"
  },
  {
    "id": "docs/QA_CHECKLIST.md:1872",
    "text": "mode démo client ;",
    "file": "docs/QA_CHECKLIST.md"
  },
  {
    "id": "docs/QA_CHECKLIST.md:1873",
    "text": "mode démo ops avec email contenant `ops` ;",
    "file": "docs/QA_CHECKLIST.md"
  },
  {
    "id": "docs/QA_CHECKLIST.md:1879",
    "text": "nouvelle version sans écraser l'ancienne ;",
    "file": "docs/QA_CHECKLIST.md"
  },
  {
    "id": "docs/QA_CHECKLIST.md:1867",
    "text": "page Google cohérente avec son intention ;",
    "file": "docs/QA_CHECKLIST.md"
  },
  {
    "id": "docs/QA_CHECKLIST.md:1881",
    "text": "pas de vidéo lourde obligatoire ;",
    "file": "docs/QA_CHECKLIST.md"
  },
  {
    "id": "docs/QA_CHECKLIST.md:1884",
    "text": "politique de confidentialité finale ;",
    "file": "docs/QA_CHECKLIST.md"
  },
  {
    "id": "docs/QA_CHECKLIST.md:1869",
    "text": "retour navigateur conservé ;",
    "file": "docs/QA_CHECKLIST.md"
  },
  {
    "id": "docs/QA_CHECKLIST.md:1878",
    "text": "types et tailles limités ;",
    "file": "docs/QA_CHECKLIST.md"
  },
  {
    "id": "docs/QA_CHECKLIST.md:1874",
    "text": "utilisateur réel limité à ses projets ;",
    "file": "docs/QA_CHECKLIST.md"
  },
  {
    "id": "docs/SECURITY_AND_RGPD.md:1893",
    "text": "Avant choix : analytics et publicité refusées par défaut. Après choix : mise à jour Consent Mode selon la décision. Le refus doit être aussi simple que l'acceptation.",
    "file": "docs/SECURITY_AND_RGPD.md"
  },
  {
    "id": "docs/SECURITY_AND_RGPD.md:1886",
    "text": "clé service role uniquement côté serveur ;",
    "file": "docs/SECURITY_AND_RGPD.md"
  },
  {
    "id": "docs/SECURITY_AND_RGPD.md:1894",
    "text": "Créer des durées par finalité : diagnostic abandonné, prospect non qualifié, prospect actif, client, obligations légales, compte supprimé. Ne pas conserver « pour toujours ».",
    "file": "docs/SECURITY_AND_RGPD.md"
  },
  {
    "id": "docs/SECURITY_AND_RGPD.md:1889",
    "text": "CSP à déployer d'abord en Report-Only ;",
    "file": "docs/SECURITY_AND_RGPD.md"
  },
  {
    "id": "docs/SECURITY_AND_RGPD.md:1896",
    "text": "Faire valider les textes juridiques, la base légale, les sous-traitants, les durées, les transferts éventuels, les mesures de sécurité et le cadre professionnel de l'accompagnement.",
    "file": "docs/SECURITY_AND_RGPD.md"
  },
  {
    "id": "docs/SECURITY_AND_RGPD.md:1887",
    "text": "honeypot invisible sur les entrées publiques ;",
    "file": "docs/SECURITY_AND_RGPD.md"
  },
  {
    "id": "docs/SECURITY_AND_RGPD.md:1892",
    "text": "La demande de service et le marketing sont séparés. La case marketing est facultative et décochée par défaut. Le formulaire affiche l'identité du responsable, la finalité, les destinataires, la durée, les droits et le contact.",
    "file": "docs/SECURITY_AND_RGPD.md"
  },
  {
    "id": "docs/SECURITY_AND_RGPD.md:1895",
    "text": "Prévoir : accès, export, rectification, suppression, limitation, opposition et retrait du consentement marketing.",
    "file": "docs/SECURITY_AND_RGPD.md"
  },
  {
    "id": "docs/SECURITY_AND_RGPD.md:1891",
    "text": "sauvegardes et procédure de restauration.",
    "file": "docs/SECURITY_AND_RGPD.md"
  },
  {
    "id": "docs/SECURITY_AND_RGPD.md:1890",
    "text": "séparation staging/production ;",
    "file": "docs/SECURITY_AND_RGPD.md"
  },
  {
    "id": "docs/SECURITY_AND_RGPD.md:1888",
    "text": "URLs signées courtes ;",
    "file": "docs/SECURITY_AND_RGPD.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1912",
    "text": "1. générer un index structuré à chaque build ;",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1913",
    "text": "2. publier les contenus approuvés dans une table de connaissance ;",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1914",
    "text": "3. créer des embeddings ;",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1915",
    "text": "5. appeler une Edge Function qui contrôle le contexte ;",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1916",
    "text": "6. renvoyer réponse, sources et actions autorisées.",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1898",
    "text": "base contrôlée : `app/content/knowledge.ts` ;",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1903",
    "text": "fonctionnement dans les espaces public, client et opérations.",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1899",
    "text": "index généré : `app/generated/search-index.json` ;",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1907",
    "text": "La base contrôlée reprend uniquement les informations commerciales confirmées et",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1897",
    "text": "Le Guide Orée est un moteur local de recherche et de navigation. Il ne dépend d'aucune API payante et ne fabrique pas de réponses juridiques.",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1901",
    "text": "Le script analyse les fichiers du projet, extrait des chaînes françaises utiles et les associe à des routes. Il s'exécute avant `dev` et `build`.",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1905",
    "text": "moment du paiement, les exclusions, l’offre micro-entreprise et les moyens de",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1917",
    "text": "Ne jamais envoyer l'ensemble des documents d'autres clients au modèle. Toute récupération doit être filtrée avant l'appel.",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1900",
    "text": "offre commerciale de référence : `app/config/commercial-offers.ts`.",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1910",
    "text": "pas d'accès à des documents privés en dehors des permissions de l'utilisateur ;",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1911",
    "text": "pas de garantie de compréhension sémantique équivalente à un LLM.",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1909",
    "text": "qualifications opérations et les données privées ne font pas partie des réponses",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1902",
    "text": "recherche tolérante par mots-clés ;",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1906",
    "text": "réponse de prudence dédiée lorsqu’une mention HT, TTC ou TVA non configurée est",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1904",
    "text": "réponses contrôlées sur le prix, les formes prises en charge, les inclusions, le",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SMART_ASSISTANT.md:1908",
    "text": "utiles au visiteur. Les paramètres internes de campagnes publicitaires, les",
    "file": "docs/SMART_ASSISTANT.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1927",
    "text": "`app/services/supabase/operations.ts` pour l’espace équipe, et les repositories",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1939",
    "text": "`db lint --linked --level warning` : aucune erreur de schéma ;",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1934",
    "text": "`submit-lead` redéployée après l’ajout de la file de demandes de rappel ;",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1936",
    "text": "avec `callback_requested = true` et un canal téléphone ;",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1929",
    "text": "centraliser mapping, erreurs, cache, contrôle du mode démonstration et mutations.",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1919",
    "text": "Ces valeurs sont publiques. La sécurité repose sur RLS.",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1922",
    "text": "Configurer les redirect URLs locales, staging, previews nécessaires et production. Pour les previews, préférer une stratégie contrôlée afin de ne pas autoriser des domaines arbitraires.",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1938",
    "text": "distant dans une transaction annulée, sans conserver de lead de test ;",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1931",
    "text": "État distant au 4 août 2026",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1943",
    "text": "frontend ou dans Git. Il sert uniquement aux opérations CLI ponctuelles. L’origine de",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1928",
    "text": "génériques de `app/services/supabase/repositories.ts`. Conserver cette couche afin de",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1918",
    "text": "Intégration Supabase",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1937",
    "text": "la procédure transactionnelle `submit_lead_bundle` a été vérifiée sur le projet",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1924",
    "text": "Le bucket `project-documents` est privé. Les chemins sont :",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1920",
    "text": "Le formulaire de diagnostic ne dépend d'aucune configuration captcha externe. La",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1921",
    "text": "le honeypot invisible et un rate limiting serveur fondé sur des empreintes hachées",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1942",
    "text": "Le jeton de gestion Supabase ne doit jamais être placé dans un fichier `.env`, dans le",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1926",
    "text": "Les composants appellent `app/services/supabase/portal.ts` pour l’espace client,",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1930",
    "text": "Les opérations créant plusieurs objets doivent finir dans une fonction SQL transactionnelle ou une Edge Function : création de projet, création des tâches initiales, conversation, checklist et événement d'ouverture.",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1925",
    "text": "Les policies vérifient l'appartenance au projet. Les validations de document restent réservées au staff.",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1923",
    "text": "Les rôles internes sont dans `staff_roles`. L'utilisateur ne peut pas écrire cette table. Un profil public ne contient pas de rôle administrateur éditable.",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1933",
    "text": "migrations `0001` à `0014` appliquées ;",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1941",
    "text": "origine locale autorisée pour le développement.",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1944",
    "text": "production et les URLs Auth doivent encore être configurées avec le domaine définitif.",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1932",
    "text": "projet lié : `sksydcdkliuisaahysya` (`oree`) ;",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1940",
    "text": "secret de revendication de lead généré et configuré côté Edge ;",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/SUPABASE_BACKEND.md:1935",
    "text": "une demande transactionnelle de rappel a été vérifiée puis annulée : elle est visible",
    "file": "docs/SUPABASE_BACKEND.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1950",
    "text": "`--font-editorial` : **Newsreader Variable**, livrée localement avec le build. Réservée à une courte expression éditoriale dans certains grands titres.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1949",
    "text": "`--font-sans` : **Onest Variable**, livrée localement avec le build. Utilisée pour toute l'interface, les formulaires, la navigation, les chiffres et les textes.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2011",
    "text": "`AppPageHero` : continuité des pages client ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2014",
    "text": "`ArtDirectedPicture` : source et ratio mobiles dédiés ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2012",
    "text": "`Button` : variantes limitées et sheen réservé aux CTA forts.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2010",
    "text": "`DashboardPage` : centre de pilotage du projet ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2009",
    "text": "`DynamicHeroCarousel` : cinq intentions, scènes responsives, zoom lent, fondu, onglets et pause ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2018",
    "text": "`EditorialMediaCard`, `TestimonialIllustration` et `AppEmptyState` : usages secondaires et encadrés.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2008",
    "text": "`HeroCockpit` : état vivant du projet ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2015",
    "text": "`HeroMedia` : photographie environnementale et preuve produit React superposée ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2017",
    "text": "`HumanTrustPanel` : scène d'accompagnement avec statut illustratif explicite ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2016",
    "text": "`ProcessRail` : image documentaire en fond contextualisé, avec l'information et les contrôles toujours construits en React ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2013",
    "text": "`ResponsiveImage` : AVIF/WebP, dimensions intrinsèques, priorité et chargement contrôlés ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1947",
    "text": "1. **Encre profonde** — `#0B1220` : confiance, navigation, espaces projet et contrastes forts.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1948",
    "text": "3. **Menthe de signal** — `#46D6A6` : validation, progression et sécurité.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1975",
    "text": "animation permanente de tous les éléments ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2005",
    "text": "aperçus contextuels dans le diagnostic ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1991",
    "text": "Au sommet de l'accueil, le header est une barre sombre superposée à l'image. Après le premier défilement, il devient une surface blanc chaud flottante afin de rester lisible sur les sections éditoriales.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1998",
    "text": "aucune collision entre l'action principale, le Guide Orée, le contrôle de pause et les onglets du héros ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2022",
    "text": "aucune information essentielle intégrée dans une image.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1999",
    "text": "aucune interaction critique dépendante du hover.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1974",
    "text": "blobs néon aléatoires ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1955",
    "text": "Capitales espacées limitées aux statuts et micro-libellés réellement utiles.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1969",
    "text": "changement d'étape ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1970",
    "text": "changement de parcours dans le diagnostic ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2003",
    "text": "cockpit et compositions asymétriques ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2007",
    "text": "Composants de référence",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2000",
    "text": "compositions dédiées, pas un desktop simplement réduit ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1987",
    "text": "contextes sombres : version monochrome inversée du même lock-up, jamais un symbole concurrent ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2020",
    "text": "contrastes vérifiés avec les contenus définitifs ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1963",
    "text": "Distinguer une orientation indicative, une validation professionnelle et une décision définitive.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1959",
    "text": "Employer un français écrit, précis et professionnel, avec des phrases complètes.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2021",
    "text": "état jamais communiqué uniquement par la couleur ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1961",
    "text": "Éviter les fragments de phrase, les formules orales, les anglicismes non nécessaires et les oppositions artificielles du type « pas seulement » ou « jamais opaque ».",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1988",
    "text": "favicon, Apple Touch et manifeste installable utilisent les icônes dédiées fournies avec l'identité.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1953",
    "text": "Graisses 800 et 900 interdites dans l'interface courante ; les anciennes classes `font-extrabold` sont normalisées à 650 pendant la migration.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2001",
    "text": "grilles deux colonnes lorsque la largeur réelle le permet ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1995",
    "text": "Guide Orée toujours visible sans masquer l'action principale ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2006",
    "text": "hover précis, jamais décoratif.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1982",
    "text": "le changement de route affiche l'identité Orée, une progression courte et un retour lisible même quand les images se chargent encore ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1981",
    "text": "le contenu du héros peut accompagner le premier défilement par une translation inférieure à 52 px et une variation d'opacité limitée ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1993",
    "text": "Le glassmorphism est réservé au header flottant, au cockpit et à quelques contrôles sur fond sombre.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1990",
    "text": "Le héros d'accueil utilise un carrousel plein cadre : photographie immersive, voile de contraste, message à gauche, CTA larges, onglets narratifs renseignés et contrôle de pause.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1983",
    "text": "le ruban de formalités effectue une boucle linéaire de 38 secondes et se suspend au survol, au focus et en reduced motion ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1980",
    "text": "les CTA forts utilisent une élévation nette, un reflet bref et un feedback d'appui ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1989",
    "text": "Les fichiers web optimisés vivent dans `public/assets/brand/`. Les sources maîtres restent dans `oree logos/` et sont traitées par `npm run brand:optimize`.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1992",
    "text": "Les héros sombres servent à focaliser une intention ; les surfaces blanc chaud servent à lire, comparer et agir.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1966",
    "text": "Les limites du mode démonstration doivent être formulées sobrement et au moment où elles affectent réellement une action.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1979",
    "text": "les révélations imbriquées peuvent être légèrement décalées, sans retarder la lecture ni animer chaque mot ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1978",
    "text": "les sections entrent dans le viewport par une translation verticale courte, une opacité progressive et un flou léger ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1973",
    "text": "micro-scan sur une étape active.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1967",
    "text": "Mouvements autorisés :",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1985",
    "text": "navigation : lock-up horizontal « Orée Entreprises » ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1996",
    "text": "navigation client inférieure ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1972",
    "text": "navigation et ouverture du Guide Orée ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1994",
    "text": "navigation publique plein écran ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1965",
    "text": "Ne jamais inventer un nom de conseiller, une citation, un délai moyen, une disponibilité ou une preuve sociale. Employer une désignation fonctionnelle tant que l'identité réelle n'est pas validée.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1951",
    "text": "Ne pas ajouter une troisième police. L'éditorial ne doit jamais être utilisé pour les libellés, formulaires ou tableaux.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1964",
    "text": "Ne pas exposer au public les détails d'implémentation tels que les noms de services, les fonctions serveur ou les règles de base de données, sauf dans une documentation technique destinée à cet usage.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1962",
    "text": "Nommer clairement l'objet de l'action : « Transmettre un justificatif conforme » plutôt que « Débloquer la suite ».",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1997",
    "text": "onglets du héros lisibles, défilables horizontalement et centrés sur l'intention active ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1956",
    "text": "Paragraphes limités en largeur et rédigés en français direct.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1986",
    "text": "pied de page : lock-up complet avec le descriptif « Création & accompagnement d'entreprise » ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1960",
    "text": "Préférer les faits, les conditions et les conséquences pratiques aux slogans ou aux métaphores publicitaires.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1968",
    "text": "progression d'un dossier ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1958",
    "text": "Rédaction d'interface",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1971",
    "text": "révélation au scroll ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2004",
    "text": "sidebars persistantes client/opérations ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1984",
    "text": "sur mobile, ce ruban devient une grille statique afin que la compréhension ne dépende jamais du mouvement.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1945",
    "text": "Système UI/UX — référence V3",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1976",
    "text": "texte essentiel dépendant d'une animation ;",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2002",
    "text": "titres et espacements intermédiaires.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1952",
    "text": "Titres principaux en graisse 600 à 700, tracking négatif modéré et interlignage maîtrisé.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1946",
    "text": "Toute l'interface dérive de quatre couleurs de base seulement :",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1957",
    "text": "Un CTA dominant par écran ; les actions secondaires restent visibles sans concurrencer la principale.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1954",
    "text": "Un seul geste éditorial par bloc, généralement avec `.editorial-mark`.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:2019",
    "text": "Une seule image de héros par route reçoit `fetchPriority=\"high\"`. Toute image sous la ligne de flottaison reste lazy. Les transitions média sont des fondus ou des variations de profondeur inférieures à 1.025 et s'arrêtent en reduced motion.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/UI_UX_SYSTEM.md:1977",
    "text": "vidéo de fond qui retarde la compréhension du mot-clé Google.",
    "file": "docs/UI_UX_SYSTEM.md"
  },
  {
    "id": "docs/V3_REBUILD.md:2034",
    "text": "1. où il se trouve ;",
    "file": "docs/V3_REBUILD.md"
  },
  {
    "id": "docs/V3_REBUILD.md:2035",
    "text": "2. ce que la plateforme sait de son projet ;",
    "file": "docs/V3_REBUILD.md"
  },
  {
    "id": "docs/V3_REBUILD.md:2038",
    "text": "architecture prête pour un LLM serveur Supabase avec permissions.",
    "file": "docs/V3_REBUILD.md"
  },
  {
    "id": "docs/V3_REBUILD.md:2037",
    "text": "base de connaissances métier ;",
    "file": "docs/V3_REBUILD.md"
  },
  {
    "id": "docs/V3_REBUILD.md:2032",
    "text": "Critère de qualité",
    "file": "docs/V3_REBUILD.md"
  },
  {
    "id": "docs/V3_REBUILD.md:2027",
    "text": "dashboard transformé en centre de pilotage ;",
    "file": "docs/V3_REBUILD.md"
  },
  {
    "id": "docs/V3_REBUILD.md:2028",
    "text": "diagnostic enrichi d'une feuille de route en direct ;",
    "file": "docs/V3_REBUILD.md"
  },
  {
    "id": "docs/V3_REBUILD.md:2031",
    "text": "documentation image et règles de continuité ajoutées.",
    "file": "docs/V3_REBUILD.md"
  },
  {
    "id": "docs/V3_REBUILD.md:2030",
    "text": "états mobile/tablette/desktop harmonisés ;",
    "file": "docs/V3_REBUILD.md"
  },
  {
    "id": "docs/V3_REBUILD.md:2029",
    "text": "Guide Orée restauré comme fonctionnalité globale et visible ;",
    "file": "docs/V3_REBUILD.md"
  },
  {
    "id": "docs/V3_REBUILD.md:2025",
    "text": "homepage reconstruite autour de l'intention Google et du projet vivant ;",
    "file": "docs/V3_REBUILD.md"
  },
  {
    "id": "docs/V3_REBUILD.md:2036",
    "text": "Le Guide est injecté globalement hors écrans d'authentification. Il possède :",
    "file": "docs/V3_REBUILD.md"
  },
  {
    "id": "docs/V3_REBUILD.md:2039",
    "text": "Le prototype ne prétend pas remplacer un modèle de langage : il fournit immédiatement une recherche intelligente locale, rapide et auditable, puis documente le branchement IA sécurisé futur.",
    "file": "docs/V3_REBUILD.md"
  },
  {
    "id": "docs/V3_REBUILD.md:2024",
    "text": "palette réduite et contrôlée à quatre couleurs ;",
    "file": "docs/V3_REBUILD.md"
  },
  {
    "id": "docs/V3_REBUILD.md:2026",
    "text": "processus animé par étapes ;",
    "file": "docs/V3_REBUILD.md"
  },
  {
    "id": "docs/V3_REBUILD.md:2023",
    "text": "Refonte V3 — reconstruction de l'expérience",
    "file": "docs/V3_REBUILD.md"
  },
  {
    "id": "docs/V3_REBUILD.md:2033",
    "text": "Un écran ne doit pas seulement être « beau ». En moins de quelques secondes, l'utilisateur doit comprendre :",
    "file": "docs/V3_REBUILD.md"
  }
]
